const signUp = {
  HI: "欢迎使用Healthnex",
  SIGN_UP_TO_JOIN_US: "注册并加入我们",
  USER_PROFILE: "用户资料",
  LOGIN_CREDENTIALS: "登录凭证",
  CONFIRM_PASSWORD: "确认密码",
  PLEASE_ENTER_YOUR_USERNAME: "请输入用户名",
  PLEASE_ENTER_YOUR_PASSWORD: "请输入密码",
  PLEASE_CONFIRM_YOUR_PASSWORD: "请确认密码",
  PLEASE_ENTER_YOUR_EMAIL: "请输入邮箱地址",
  PLEASE_ENTER_YOUR_PHONE: "请输入正确的澳洲手机号码，如：0412345678",
  EG_PROFESSOR_OF_TRADITIONAL_CHINESE_MEDICINE: "例如：中医专业人员",
  PLEASE_BRIEFLY_INTRODUCE_YOURSELF: "请简要介绍自己",
  TRADITIONAL_CHINESE_MEDICINE_IS_A_DISCIPLINE_THAT_UTILIZES_NATURAL_PRINCIPLES_COMBINED_WITH_VARIOUS_PHYSIOLOGICAL_AND_PATHOLOGICAL_CHANGES_IN_THE_BODY:
    "例如：中医学是一门结合自然原理与人体各种生理和病理变化的学科。",
  HERBAL_MEDICINE: "中药治疗",
  SIGN_UP: "提交注册",
  PURCHASE_AND_SIGN_UP: "购买并注册",
  SIGN_UP_AS_PRACTITIONER: "注册为医师",
  USERNAME_ALLOW_U_TO_LOGIN_TO_HEALTHNEXT_PLS_DONT_START_WITH_NUMBER:
    "用户名用于登录 Healthnex，请勿以数字开头或包含空格",
  THIS_IS_A_VALID_USERNAME: "该用户名可用。",
  NO_CLINIC_NAME: "未知诊所名",
  IN_THIS_CLINIC_UR: "在这间诊所，您的角色是",
  MEMBER: "诊所成员",
  IF_UR_MEMBER: "如果您是诊所成员",
  IF_UR_OWNER: "如果您是诊所负责人 (Business Owner)",
  WE_WILL_CREATE_THE_CLINIC_FOR_U: "没问题，我们将为您创建这间诊所！",
  OR_IF_NO_ANY_CLINIC_FROM_ABOVE: "未找到您要加入的诊所?",
  THIS_BECUZ_THE_CLINIC_OWNER_MIGHT_NOT_CREATED_THE_CLINIC_IN_OUR_SYSTEM_YET:
    "可能是该诊所的负责人尚未在 Healthnex 创建该诊所。",
  PLS_CONTACT_THE_CLINIC_OWNER_TO_CREATE_THE_CLINIC_AND_INVITE_YOU_IN:
    "请联系诊所负责人创建诊所，并在创建后邀请您加入。",
  VERIFYING_EXTERNAL_ACCOUNT: "正在验证外部账户信息",
  CONFIRM_PACKAGE: "确认套餐",
  READ_AND_AGREE_TO_TERMS: "确认条款",
  SELECTED_PACKAGE: "已选择套餐",
  SIGN_IN_MINI: "登录 (轻量版)",
  BYE: "账户已登出",
  U_DONT_HAVE_OWNED_CLINIC_PLS_GO_DESKTOP_VERSION_TO_CREATE_YOUR_OWN_CLINIC:
    "您还不是任何诊所的负责人，请前往桌面版本创建您的诊所。",
  CLINIC_OWNER: "诊所负责人（Business Owner）",
  OWNER_DESCRIPTION:
    "如果您是诊所的负责人 (Business Owner)，并希望在 Healthnex 上创建诊所来开始工作，请选择此选项。",
  MEMBER_DESCRIPTION:
    "如果您不是诊所负责人 (Business Owner)，并希望加入其他诊所，或单纯希望通过 Healthnex 发布您的个人网站，请选择此选项。",
  PLEASE_INPUT_YOUR_CLINIC_ADDRESS: "请填写您的诊所地址",
  SELECT_ROLE: "角色选择",
  U_ARE: "如果您是",
  SYSTEM_RECOMMEND_THE_BELOW_PACKAGE_WILL_BE_SUITABLE_FOR_YOU:
    "Healthnex 已为您推荐适合的套餐方案.",
  GET_X_MONTHS_FREE_NOW: "立即享受{{X}}个月免费使用期！",
  FREE_SUBSCRIPTION_OFFER_JOIN_NOW:
    "在限时优惠期间，您可免费使用完整的订阅功能包。",
  U_CAN_ALSO_JOIN_THE_EXISTING_CLINIC_AND_WORK_WITH_THEM_COOPERATIVE_IN_HEALTHNEX:
    "此外，您也可以选择加入已有诊所，并其他医师在 Healthnex 中共同协作。",
  ORIGINAL_PRICE: "原价",
  X_MONTHS_FREE_ACCESS: "{{X}} 个月免费使用期",
  S_CLINIC: "的诊所",
  AGENT_INVITATION_TO_JOIN: "来自中介的加入邀请",
  INVALID_AGENT_REF_KEY: "当前的中介推荐码已失效，请联系中介获取更多帮助。",
  VERIFYING_AGENT_REF_KEY: "正在验证推荐码有效性",
  PRESS_LEFT_AND_RIGHT_KEY_TO_SWITCH_CLINIC:
    "按 ← 左箭头 和 → 右箭头 键切换诊所",
  PRESS_ENTER_KEY_TO_START_WORKING: "按 ⤶ 回车 键开始工作",
  WELCOME_TO_HEATHNEXT_TO_START_PLS_TELL_ME_WHICH_ROLE_YOU_WANT_TO_PLACE:
    "欢迎来到 Healthnex 👋\n在注册开始前，请告诉我们您的身份吧！",
  UPLOAD_UR_PROFILE_PICTURE_HERE: "上传一张您的个人照片，让大家更快认识您吧！",
  INCORRECT_PREV_PASSWORD: "检测到您当前使用的密码不正确，请重新输入",
  UPDATING_PASSWORD: "正在更新密码",
  CURRENT_PASSWORD: "当前密码",
  PLEASE_LOGIN_USING_DESKTOP_VERSION_ENJOY_FULL_SERVICES:
    "注册成功！请通过Healthnex桌面端登录以使用完整服务。或者，您也可以继续使用 当前的移动精简版 以使用基础功能。",
  INDIVIDUAL_BUSINESS: "个体户",
  INDIVIDUAL_BUSINESS_DESCRIPTION:
    "如果您以个人形式执业，可创建个人诊所，且依然允许您未来邀请其他员工加入。",
  PLEASE_INPUT_YOUR_BUSINESS_OR_HOME_ADDRESS:
    "请输入您的营业地址（如有了话）或当前居住地址。",
};

const navigation = {
  PRACTITIONER: "医师",
  PRACTITIONER_PORTAL: "医师平台",
  HOME: "主页",
  ABOUT_US: "学会介绍",
  PARTNERS: "合作伙伴",
  MEMBER_SERVICE: "学会服务",
  CPD_TRAINING: "CPD培训",
  TRAINING_AND_COURSES: "培训与课程",
  EVENT: "学会活动",
  NEWS: "最新动态",
  BECOMING_MEMBER: "成为会员",
  LOGIN_SIGNUP: "登录/注册",
  ONLINE_PAYMENT: "在线支付",
  DOWNLOAD_CENTER: "下载园区",
  AGREE_TO_USE_VAI_CLINIC_TEXT: "登录即表示您已经同意我们的",
  SIGN_IN: "登录",
  SIGN_OUT: "登出系统",
  USERNAME: "用户名",
  PASSWORD: "密码",
  FORGET_PASSWORD: "忘记密码",
  AND: "和",
  PLEASE_ENTER_YOUR_USERNAME: "请输入您的用户名",
  PLEASE_ENTER_YOUR_PASSWORD: "请输入您的密码",
  CLINIC: "诊所",
  PRACTITIONER_PROFILE: "个人网页定制",
  CONTACT_US: "联系我们",
  GO_BACK: "返回",
  ADD_PATIENT: "添加新患者",
  SELECT_CLINIC_TO_WORK: "选择工作诊所",
  SELECT_CLINIC: "选择诊所",
  PRESCRIPTION_MEDICAL_HISTORY: "病历与开方",
  LANDING_PAGE_UPDATED: "已将当前页面设置为首页",
  CHANGE_THIS_PAGE_AS_THE_ENTRY_PAGE:
    "设置此页面为首页后，每次进入系统时将优先显示该页面",
  ENTRY_PAGE: "首页",
  URL_LINK: "URL链接",
  URL_COPIED_TO_CLIPBOARD: "URL已复制到剪贴板",
  EMAIL_COPIED_TO_CLIPBOARD: "邮箱已复制至剪贴板",
  FAILED_TO_COPY_TO_CLIPBOARD: "复制到剪贴板失败，请手动复制或切换到https",
  PROFILE_PAGE_QR_CODE: "{{X}}网页二维码",
  E_DAYS: "天",
  PENDING_CLINIC_REQUESTS: "发现待处理诊所请求",
  ARE_YOU_SURE_TO_SIGN_OUT: "您确定要退出当前帐号吗",
  APPOINTMENT_MINI: "预约记录",
  PRESCRIPTION_MINI: "患者与开方",
  SHOW_MORE: "显示更多",
  SHOW_LESS: "显示更少",
  BACK_TO_PATIENT_INFO: "返回患者信息",
  ADD_POINT: "添加穴位",
  UR_CLINIC_PACKAGE_PERMISSION_CHANGED: "您的诊所工作权限已变更",
  UR_CLINIC_PACKAGE_PERMISSION_CHANGED_DESCRIPTION:
    "您在当前诊所的权限已更新。以下是您可以使用的服务。",
  UR_CLINIC_ROLE_PERMISSION_CHANGED: "您在该诊所的权限已变更",
  UR_CLINIC_ROLE_PERMISSION_CHANGED_DESCRIPTION:
    "您在当前诊所的角色权限发生了变化，请查看以下详情。",
  PERMISSION_DIFF_VS_BEFORE_HINT: "以下展示您的权限相较于变更前的差异。",
  PERMISSION_CHANGE_AUTO_REFRESH_HINT: "系统将在3秒后自动刷新",
  GOT_IT: "我知道了",
  CONFIGURE_U_WORKTIME:
    "配置您的工作时间，Healthnex 将根据您的工作时间自动生成预约时间段。",
  MANAGE_UR_APPOINTMENTS:
    "您可以在系统中管理您的预约。外部患者也可通过 Healthnex 官网 或您的 个人主页（如已开通相关权限）进行预约。",
  PATIENT_SYSTEM_AND_PRESCRIPTION_FUNCTION:
    "您可以管理诊所的患者信息与病历，并为患者开具处方。",
  AI_FUNCTION: "您可以使用 AI 助手获取支持，例如翻译信息、总结问诊过程等。",
  U_CAN_EASILY_CUSTOMISED_PUBLISH_YOUR_PERSONAL_WEBSITE_TO_THE_PUBLIC:
    "您可以高度自定义您的个人网站，并将其发布到互联网，让更多患者了解您。",
  UR_CLINIC_HAS_REMOVED_PACKAGE_FROM_U:
    "您的诊所已移除了您的工作权限。如与您的预期不符，请联系诊所负责人。",
  IF_UNEXPECTED_PLS_CONTACT_THE_CLINIC_OWNER:
    "如与您的预期不符，请联系所在诊所的负责人。",
  NEW_VERSION_AVAILABLE: "新版本可用",
  NEW_VERSION_DESCRIPTION:
    "Healthnex 已推出新版本。请点击以下按钮刷新页面以完成升级。",
  REFRESH_AND_UPGRADE: "更新并刷新页面",
  SYSTEM_REDIRECTING: "系统正在跳转",
  SWITCHING_CLINIC: "正在切换诊所",
  UPDATING_PROFILE: "正在更新个人资料",
  UPLOADING_AVATAR: "正在上传头像",
  EDIT_PRESCRIPTION: "编辑处方",
  DASHBOARD: "工作概览",
};

const prescription = {
  CLEAR_SEARCH: "清空",
  PRESCRIPTION: "病历",
  PATIENT_PRESCRIPTION: "患者病历",
  DOCTOR_PRESCRIPTION: "医师处方",
  NO_PRESCRIPTION_FOUND: "未找到处方",
  NO_PREVIOUS_HISTORY: "未找到历史",
  PRESCRIPTION_NOT_FOUND: "处方未找到",
  "EDIT_NOW_HISTORY_#X": "正在编辑病历 #{{X}}",
  EDITING_NOW: "正在编辑",
  NO_ENGLISH_ENTRY: "未填写英文记录",
  NO_CHINESE_ENTRY: "未填写中文记录",
  ENGLISH_CONTENT: "英文内容",
  CHINESE_CONTENT: "中文内容",
  CASE_ID: "病历编号",
  DATE: "日期",
  CREATED_BY: "创建人",
  PAYMENT_STATUS: "支付状态",
  ACTION: "操作",
  NOT_PAID: "未支付",
  PAID: "已支付",
  CARD_ONLINE: "在线支付",
  CARD_OFFLINE: "线下刷卡",
  CASH: "现金",
  HICAPS: "HICAPS",
  CONNECTING_TO_HICAPS_TERMINAL: "正在连接 HICAPS 终端...",
  HICAPS_TERMINAL_CONNECTED: "已连接 HICAPS 终端",
  HICAPS_TERMINAL_CONNECTION_FAILED: "连接 HICAPS 终端失败",
  RETRY: "重试",
  RESUBMIT: "重新提交",
  SUBMITTING: "正在提交...",
  HICAPS_TERMINAL_SERVER_NOT_CONFIGURED: "该诊所的HICAPS终端未配置服务器地址，请联系管理员处理。",
  HICAPS_CHARGE_NOT_SUBMITTED_TITLE: "已扣款但未提交成功",
  HICAPS_CHARGE_NOT_SUBMITTED_DESCRIPTION: "HICAPS终端已经完成扣款，但保存到病历记录失败。点击重新提交完成保存——不会再次向终端发起扣款。",
  CONFIRM_REFUND_TITLE: "确定要通过HICAPS退款吗？",
  CONFIRM_REFUND_DESCRIPTION: "此操作将把病历重置为未付款状态。以下内容将被退款：",
  CONFIRM_REFUND_ITEM_REBATE: "医保理赔将被取消",
  CONFIRM_REFUND_ITEM_BALANCE: "余额付款将被退款",
  CONFIRM_REFUND: "确认退款",
  CONFIRM_REFUND_SCOPE_FULL: "全部退款",
  CONFIRM_REFUND_SCOPE_FULL_DESCRIPTION: "取消医保理赔并退还余额付款",
  CONFIRM_REFUND_SCOPE_BALANCE_ONLY: "仅退尾款",
  CONFIRM_REFUND_SCOPE_BALANCE_ONLY_DESCRIPTION: "只退还余额付款——医保理赔保持不变",
  REFUND_CLAIM_CANCEL_SUCCESS_PROCESSING_BALANCE: "理赔取消成功，正在处理余额退款...",
  HICAPS_PRICE_LOCK_WARNING: "选择Hicaps后，该记录的价格将无法再编辑。",
  SELECT_PROVIDER: "请选择医保提供商",
  SEARCH_PROVIDER_NAME: "按名称搜索",
  SELECT_MERCHANT: "请选择商户",
  HEALTH_FUND_REBATE: "医保报销",
  BALANCE_PAYMENT: "尾款支付",
  PROCESSING_REBATE_PAYMENT: "正在处理医保报销付款",
  PROCESSING_BALANCE_PAYMENT: "正在处理尾款付款",
  PROVIDER_USED_FOR_BOTH_STEPS: "该医保提供商将用于报销和尾款支付两个步骤",
  WAITING_FOR_PAYMENT: "等待付款",
  PLEASE_TAP_CARD_ON_TERMINAL: "请让患者在 HICAPS 终端上刷卡、插卡或感应付款",
  FINALIZING_PAYMENT: "正在确认付款结果",
  SAVING_INSURANCE_RECORD: "正在保存报销记录",
  HICAPS_ZERO_AMOUNT_HINT: "金额为 $0 时无法选择 HICAPS 支付",
  HICAPS_PAYMENT_LOCKED_TITLE: "已通过 HICAPS 支付",
  HICAPS_PAYMENT_LOCKED_DESCRIPTION: "该病历已通过 HICAPS 终端完成支付，价格相关内容已被锁定，无法修改。如需修改，请先申请退款；退款成功后，该病历将变为未支付状态。",
  HICAPS_PAYMENT_LOCKED_DESCRIPTION_SHORT: "已通过 HICAPS 支付，如需修改价格请先申请退款",
  COMPLETE: "完成",
  REFUND: "申请退款",
  UNPAID: "未付款",
  MARK_AS_PAID: "标记为已付款",
  MARK_REBATE_AS_PAID: "将报销标记为已付款",
  MARK_REBATE_AS_PAID_WARNING: "此操作会将该报销的HICAPS支付状态更新为已付款。仅在HICAPS终端已经实际完成支付，但系统未能正确显示为已付款时使用。",
  HICAPS_PAY_IN_FULL: "全部用HICAPS支付",
  HICAPS_PAY_PARTIAL: "分开用其他方式支付",
  HICAPS_AMOUNT_TO_PAY: "HICAPS支付金额",
  HICAPS_PARTIAL_AMOUNT_MUST_BE_LESS_THAN_BALANCE: "需大于$0且小于尾款总额",
  REMAINING_AMOUNT_X: "剩余 ${{X}} 将用另一种方式支付",
  CONNECT_HICAPS_TERMINAL: "连接HICAPS终端",
  REFUND_STEP_REBATE: "正在取消报销申请",
  REFUND_STEP_BALANCE: "正在退还尾款",
  REFUND_STEP_ROLLBACK: "正在更新病历支付状态",
  REFUND_STEP_REBATE_ROLLBACK: "正在更新理赔的支付状态",
  REFUND_STEP_REBATE_ROLLBACK_SHORT: "理赔状态",
  REFUND_STEP_REBATE_SHORT: "理赔取消",
  REFUND_STEP_BALANCE_SHORT: "余额退款",
  REFUND_STEP_ROLLBACK_SHORT: "更新状态",
  REFUND_SUCCESSFUL: "退款成功",
  REFUND_FAILED: "退款失败，请重试",
  PROCESSING_WITH_HICAPS_TERMINAL: "正在通过 HICAPS 终端处理...",
  HICAPS_TRANSACTION_SUCCESSFUL: "HICAPS 交易成功",
  HICAPS_TRANSACTION_FAILED: "HICAPS 交易失败，请重试",
  HICAPS_REBATE_COMPLETED: "已通过 HICAPS 完成报销",
  FILTER_BY_DATE: "按日期筛选",
  SELECT_DEFAULT_DATE_RANGE: "选择默认日期范围",
  SELECT_CUSTOM_DATE_RANGE: "选择自定义日期范围",
  LAST_ONE_YEAR: "过去一年",
  LAST_ONE_MONTH: "过去一个月",
  LAST_THREE_MONTHS: "过去三个月",
  ROWS_PER_PAGE: "每页行数",
  MORE_INFORMATION: "更多信息",
  AGE: "年龄",
  PRESCRIPTION_FORM: "处方单",
  CREATE_CASE: "创建病历",
  CREATE_CASE_FAILED: "创建病历失败，请重试",
  SELECT_OPTIONS: "选择选项",
  CLICK_TO_RECORD: "点击录音",
  PRESS_TO_RECORD: "按住录音",
  TRANSLATE_TO_X: "翻译为{{X}}",
  COMPLAINTS_SYMPTOMS: "主诉与症状",
  PAST_DISEASE: "既往病史",
  FAMILY_DISEASE_HISTORY: "家族病史",
  ALLERGY: "过敏史",
  ALLERGEN: "过敏原",
  CURRENT_MEDICINE_TAKEN: "当前用药",
  SIGNS_DIAGNOSIS: "体征与诊断",
  ATTACHMENT: "文件",
  REMARKS: "备注",
  CLICK_DRAG_TO_UPLOAD: "点击或拖拽上传",
  NO_ATTACHMENT_FOUND: "未添加文件",
  TREATMENT_PLAN: "治疗方案",
  PATIENT_ADVICES: "医嘱",
  PROCEED_TO_PAYMENT: "前往付款",
  PROCEED_TO_TREATMENT: "进入开方",
  MEDICINE: "中药",
  PRESCRIBE_MEDICATION_TO_THE_PATIENT: "为患者开具中药",
  PRESCRIBE_ACUPUNCTURE_TO_THE_PATIENT: "为患者提供针灸治疗",
  PRESCRIBE_MASSAGE_TO_THE_PATIENT: "为患者推拿治疗",
  PRESCRIBE_REMEDIAL_MASSAGE_TO_THE_PATIENT: "为患者提供康复推拿治疗",
  SELECT: "选择",
  MODALITY: "治疗方式",
  MEDICINE_TREATMENT_NAME: "治疗名称",
  PREVIOUS_STEP: "上一步",
  PATIENT_HERB_HISTORY: "患者中药记录",
  APPLY: "复用此方",
  HERB: "中药",
  RAW: "生药量 (g)",
  GRAN: "颗粒剂量(g)",
  TOTAL: "总计",
  FORMULA: "药方",
  CLASSICAL: "药方",
  SINGLE_HERB: "单味中药",
  TYPE: "类型",
  SELECT_HERBS: "选择中药",
  SEARCH_CLASSICAL_FORMULA: "搜索经典方",
  PLEASE_SEARCH_BY_NAME: "请按名称搜索",
  CANCEL_SEARCH: "取消搜索",
  ADD_ALL_HERBS_IN_FORMULA: "添加整方",
  X_HERBS_INCLUDED: "已包含{{X}}味药",
  FILL_IN_THE_DOSAGE: "填写剂量",
  HERBS_ADDED: "已添加的中药",
  PLS_SELECT_HERB_FROM_HISTORY_OR_FORMULA: "请从药方或过往历史添加中药",
  GRAMS_DAILY: "剂量",
  DAILY_TOTAL: "每日总计",
  DAYS: "天数",
  TOTAL_GRANS: "总颗粒剂量",
  TOTAL_RAW: "总生药量",
  DAILY_GRANS: "每日颗粒剂量",
  DAILY_RAW: "每日生药量",
  DOSAGE_INSTRUCTION: "注意事项",
  DOSAGE: "剂量",
  NO_OF_REPEATS: "用药天数",
  DOSAGE_DAYS: "用药天数",
  TO_BE_DISPENSED_AFTER: "下次取药时间",
  WEEK: "周",
  RAW_HERBS: "原药材",
  HERBS_EXTRACT: "中药提取物",
  HERBAL_MEDICATION: "中药治疗",
  EXTERNAL: "外用药",
  HERB_BOIL_GUIDE: "煎药指导",
  SECOND_BOIL_REQUIRED: "需要二煎",
  FIRST_BOILS: "首次煎煮",
  NO_CUP_WATER: "加几碗水",
  BOIL_TIME: "煎煮时间",
  NO_CUPS_REMAINS: "煎成几碗",
  MIN_BOIL_TIME: "最小煎煮时间（分钟）",
  PLEASE_ENTER_NUMBER: "请输入数字",
  SELECT_POINT: "选择穴位",
  X_HISTORY: "{{X}}条历史记录",
  POINT: "穴位",
  X_GROUP: "{{X}}分组",
  POINT_GROUPS: "穴位分组",
  ORDER: "顺序",
  SINGLE_POINT: "单一穴位",
  REVIEW_THE_POINTS: "检查所选穴位",
  PLS_SELECT_POINT_FROM_HISTORY_OR_GROUP: "请从历史或穴位分组中添加穴位",
  DROP_HERE: "拖放到此处",
  X_INSTRUCTION: "{{X}}说明",
  DURATION: "持续时间",
  PLS_ENTER_THE_DURATION: "请输入持续时间",
  PRECAUTION: "注意事项 / 备注 / 医嘱",
  FILL_IN_PRECAUTION: "填写注意事项 / 备注 / 医嘱",
  MAS_TECHNIQUE: "手法",
  PLS_ENTER_THE_PRECAUTION: "请输入注意事项 / 备注 / 医嘱",
  POINTS_ADDED: "已添加的穴位",
  VIEW_COPIED_POINTS: "查看上次病历的添加穴位",
  VIEW_COPIED_HERBS: "查看上次病历的添加中药",
  HERB_RAW_SHORT: "生药",
  HERB_GRAN_SHORT: "颗粒",
  PAYMENT: "付款",
  FILL_IN_THE_PAYMENT_DETAILS: "填写付款信息",
  SUBTOTAL: "小计",
  OTHER_FEE: "其他费用",
  DIAGNOSIS_FEE: "治疗费",
  DISCOUNT_FEE: "折扣",
  FEE: "费用",
  TOTAL_AMOUNTS: "总金额",
  CASH_OR_CARD_OFFLINE_AMOUNT: "线下现金/刷卡金额",
  INITIAL_VISIT: "初诊",
  FOLLOW_UP: "复诊",
  ADD_FEE: "添加费用",
  FEE_LABEL: "费用名称",
  PLEASE_ENTER_LABEL: "请输入标签",
  FEE_AMOUNT: "费用金额",
  PLEASE_ENTER_AMOUNT: "请输入金额",
  FEE_LABEL_ALREADY_EXISTS: "已存在同名的费用标签",
  FEE_AMOUNT_MUST_BE_POSITIVE: "金额不能为负数",
  MEDICAL_REBATE: "医保返还",
  MEDICAL_FUNDS_OF_PATIENT: "是否使用患者医保",
  REBATE_AMOUNT: "医保返还金额",
  ANY_DISCOUNT: "是否有折扣",
  PENDING_PAYMENT_AMOUNT: "待支付金额",
  PAYMENT_METHOD: "支付方式",
  DISCOUNT_AMOUNT: "折扣金额",
  FINISH_PAYMENT: "完成支付",
  PLEASE_ENTER_YOUR_CARD_DETAILS_BELOW_TO_COMPLETE_YOUR_PURCHASE:
    "请填写下方信用卡信息以完成付款",
  PAYMENT_FAILED_PLEASE_TRY_AGAIN: "支付失败，请重试",
  X_TRIES_LEFT: "剩余{{X}}次尝试",
  TOTAL_AMOUNT_CANNOT_BE_NEGATIVE: "总金额不能为负数",
  PAY_NOW: "立即支付",
  YOUR_PAYMENT_HAS_BEEN_SUCCESSFULLY_PROCESSED:
    "付款成功，您的支付已顺利处理。",
  SYSTEM_REDICTING: "系统正在跳转...",
  SURCHARGE_WILL_BE_INCLUDED: "已包含手续费",
  PROCESSING_PAYMENT: "正在处理支付",
  LAST_MODIFIED_AT: "上次查看于",
  PAY: "支付",
  NEXT: "下一步",
  PRINT_RECEIPT: "下载收据",
  SEND_RECEIPT_TO_PATIENT: "发送账单至患者",
  SEND_TO_PATIENT_VIA_EMAIL_WITH_RECEIPT_ATTACHED:
    "通过邮件的方式发送账单至患者邮箱",
  PATIENT_EMAIL: "患者邮箱地址",
  RECIPIENT_EMAIL: "收件人邮箱",
  EMAIL_SENT_TO_X: "邮件已发送至：{{X}}",
  SEND: "发送",
  SENDING_EMAIL: "正在发送邮件",
  PRINT_MEDICAL_RECORD: "下载病历记录",
  GENERATING: "生成中",
  NO_MEDICAL_HISTORY_FOUND: "未填写病历",
  NO_TREATMENTS_INCLUDED: "未包含治疗方案",
  TREATMENT: "开方",
  TREATMENTS: "开方",
  VIEW_X_INSTRUCTION: "查看{{X}}说明",
  X_SURCHARGE_AMOUNT: "{{X}}手续费",
  DISCOUNT: "折扣",
  COLLAPSE_ALL: "全部收起",
  EXPAND_ALL: "全部展开",
  VIEW_DOSAGE_INSTRUCTION: "查看用药说明",
  NO_TREATMENTS_INCLUDED: "未包含治疗方案",
  FINISH: "总结",
  X_OPTIONS: "{{X}}选项",
  FULL_CONTENT_MODE: "简易模式",
  HAS_BEEN_ADDED: " 已添加",
  ALL_HERBS_IN_FORMULA_HAS_ADDED: "药方中的所有中药已添加",
  CLASSICAL_FORMULA: "药方",
  PLS_ENTER_NUMBER: "请输入数字",
  SEARCH_CLASSICAL_FORMULA_BY_NAME: "按名称搜索药方",
  SEARCH_CLASSICAL_FORMULA_HERB_BY_NAME: "按名称搜索药方和中药",
  SEARCH_HERB_BY_NAME: "按名称搜索中药",
  REMOVE_TREATMENT: "移除开方信息",
  ARE_YOU_SURE_TO_REMOVE: "确定要移除",
  SECOND_BOILS: "第二次煎煮",
  MIN_BOILING: "煎煮时间（分钟）",
  X_POINTS_INCLUDED: "已包含{{X}}个穴位",
  ADD_ALL_POINTS_IN_FORMULA: "添加分组中的所有穴位",
  SEARCH_POINT_GROUPS_BY_NAME: "按名称搜索穴位分组",
  SEARCH_POINT_GROUPS_POINT_BY_NAME: "按名称搜索穴位分组和穴位",
  SEARCH_POINT_BY_NAME: "按名称搜索穴位",
  ALL_POINTS_IN_FORMULA_HAS_ADDED: "分组中的所有穴位已添加",
  THIS_TREATMENT_HAS_NO_PRICE_OR_PRICE_ZERO: "该治疗无定价或价格为零",
  PAYMENT_CHANNEL_EXPIRED_PLS_RELOAD_PAGE: "支付通道已失效，请刷新页面重试",
  ENTER_FEE_AMOUNT: "请输入费用金额",
  NO_TREATMENT_INCLUDED_IN_THIS_PRESCRIPTION: "该处方未包含任何治疗",
  PLEASE_SELECT_TREATMENT_TO_PROCEED: "请选择一种治疗方式以继续",
  ADD_TREATMENT: "添加治疗",
  MORE: "更多",
  HAS_REMOVED: "已移除",
  PRESCRIBE_X_TO_THE_PATIENT: "为患者开具{{X}}",
  ATTACHMENT_UPLOADED: "文件已上传",
  REMOVE_ATTACHMENT: "移除文件",
  ARE_YOU_SURE_TO_REMOVE_THIS_FILE: "你确定要移除这个文件吗？",
  ATTACHMENT_REMOVED: "文件已移除",
  DELETE_DAILY_SHARING: "删除每日分享",
  ARE_YOU_SURE_TO_DELETE_THIS_DAILY_SHARING: "你确定要删除这条每日分享吗？",
  LAST_SIX_MONTHS: "过去半年",
  INPUT_TOTAL_COST_HERE: "在此输入治疗费用",
  EDIT_PATIENT_INFO: "编辑患者信息",
  ARE_YOU_SURE_TO_CLEAR_ALL_CONTENT_IN_THIS_FIELD:
    "确定要清除以下填写的所有内容吗？",
  CLEAR_CONFIRM: "清空确认",
  DUPLICATE_MEDICAL_HISTORY: "复诊",
  ARE_YOU_SURE_TO_DUPLICATE_THIS_MEDICAL_HISTORY:
    "你将要复制所选的这条病历记录",
  YOU_WILL_GET_A_NEW_MEDICAL_HISTORY_WITH_PREFILLED_DATA_FROM_LAST_RECORD:
    "你将会获得一条新的病历记录并会预填上所需病历的完整信息。",
  ARE_YOU_SURE_TO_DELETE_MEDICAL_RECORD: "你将删除这条病历记录",
  PATIENT_HISTORY_COPIED: "患者病历复制成功",
  DELETE_SUCCESS: "删除成功",
  ADD_ASSISTANT_EXAMINATION: "添加辅助检查",
  ADD_NOW: "立即添加",
  RESULT_PREVIEW: "总览",
  AUXILIARY_TEST: "辅助检查",
  TEST_NAME: "检查名称",
  TEST_DATE: "检查日期",
  ATTACHMENTS: "文件",
  SELECT_PHOTO_PDF: "选择照片/PDF",
  TAKE_PHOTO_OR_SELECT_FILE: "拍照或选择文件",
  EXAMINATION: "体征信息",
  EXAMINATION_DESCRIPTION: "描述",
  INSPECTION: "望诊",
  TONGUE_PHOTO: "舌象照片",
  FACIAL_PHOTO: "面部照片",
  INQUIRY: "问诊",
  INQUIRY_RECORD: "问诊记录",
  PULSE: "脉诊",
  LISTEN_SMELL: "闻诊",
  BODY_TEMP: "体温",
  BLOOD_PRESSURE: "血压",
  PULSE_RATE: "脉率",
  BREATH_RATE: "呼吸频率",
  PERSONAL_OTHER: "个人习惯及其他",
  ANY_ALLERGY: "是否有过敏",
  IS_PREGNANT: "是否怀孕",
  ALLERGY_DRUGS: "药物过敏",
  ALLERGY_TRIGGERS: "过敏诱因",
  STD: "是否有性病史",
  PROMISCUITY: "是否有不洁性行为",
  SMOKING: "是否吸烟",
  ALCOHOL_ABUSE: "是否酗酒",
  ADD_HISTORY: "添加过往病史",
  NO_DISEASES: "从未得过",
  FAMILY_DISEASES: "家族病史",
  SYMPTOMS: "症状",
  NO_SYMPTOMS_ADDED: "未添加症状",
  MAIN_SYMPTOM: "主要症状",
  SYMPTOM_DESCRIPTION: "症状描述",
  ONSITE_TIME: "发生时间",
  TIME_UNIT: "时间单位",
  RECURRENCE_TIME: "复发时间",
  EXACERBATION_TIME: "加重时间",
  FREQUENCY_OF_OCCURRENCE: "发生频率",
  FREQUENCY: "频率",
  ADD_MAIN_SYMPTOMS: "添加主要症状",
  PREDISPOSITION: "诱因",
  ASSOCIATED_SYMPTOMS: "伴随症状",
  ARE_YOU_SURE_TO_DELETE_THIS_SYMPTOM: "确定要删除此症状吗？",
  DURATION: "持续时间",
  ADD_ASSISTANT_EXAMINATION: "添加辅助检查",
  ADD_PAST_DISEASE: "添加既往病史",
  OTHERS: "其他",
  PROCEED_TO_DIAGNOSIS: "开始诊断",
  UPDATE_SUCCESS: "更新成功",
  PREVIOUS_TREATMENT: "症状描述",
  ADD_ASSITANT_EXAMINATION: "添加辅助检查",
  ASSISTANT_EXAMINATION: "辅助检查",
  CLICK_TO_ADD: "点击以搜索并添加",
  CLICK_TO_SELECT: "点击以搜索并选择",
  PREVIOUS_HISTORY: "既往病史",
  PAST_DISEASE_DESCRIPTION: "描述",
  ADD_EVALUATION: "添加诊断",
  TCM_ICD_CODE: "中医ICD编码",
  DETERMINATION_TCM: "中医诊断名称",
  SYNDROME: "中医证型名称",
  EVALUATION: "诊断",
  DISCIPLINE_TREATMENT_OPTIONS: "治则治法",
  ARE_YOU_SURE_TO_DELETE_THIS_RECORD: "您确定要删除此记录吗？",
  BPM: "次/分钟",
  SYSTOLIC: "高压",
  DIASTOLIC: "低压",
  ADD_NEW_INSURANCE: "添加新医保",
  PLZ_INPUT_INSURANCE_NO: "请输入会员号",
  PLZ_INPUT_COMPANY_NAME: "请输入医保公司名称",
  RESULT: "检查结果",
  VIEW_HISTORY: "查看过往记录",
  COLLAPSE_HISTORY: "收起记录",
  COLLAPSE_INSTRUCTION: "收起注意事项",
  SHOW_DOSAGE_INSTRUCTION: "编辑注意事项",
  IT_LOOKS_LIKE_PATIENT_HAS_NOT_BEEN_CONSENTED_WITH_AGREEMENT_WITH_US:
    "看来患者还没有同意我们的患者同意书。",
  PLEASE_ASK_PATIENT_TO_SCAN_THE_QR_BELOW_SIGN_THE_CONSENT_FORM:
    "如需开始医嘱流程，患者需先扫描下方的二维码完成患者同意书的签署。",
  PLEASE_ASK_PATIENT_TO_SCAN_THE_QR_BELOW_SIGN_THE_CONSENT_FORM_SHORT:
    "患者可通过扫描下方的二维码完成患者同意书的签署。",
  SIGN_CONSENT_FORM: "签署患者同意书",
  SIGNATURE_DATE: "签署日期",
  PATIENT_FIRST_VISIT_ON: "病人初诊于",
  APPLY_DATE: "应用",
  // THIS_PATIENT_WAS_CREATED_FROM_IMPORT_U_CAN_ASK_PATIENT_TO_SIGN_CONSENT: "该患者信息为导入数据，虽暂未完成系统内同意书签署，您仍可直接开始医嘱流程",
  THIS_PATIENT_WAS_CREATED_FROM_IMPORT_U_CAN_ASK_PATIENT_TO_SIGN_CONSENT:
    "该患者信息虽暂未完成系统内同意书签署，您仍可直接开始医嘱流程",
  PLEASE_CLICK_BUTTON_BELOW_AND_ASK_PATIENT_TO_SIGN_THE_CONSENT_FORM:
    "如需开始医嘱流程，请点击下方按钮并让患者签署患者同意书。",
  CLICK_HERE_TO_SIGN_CONSENT: "点击此处签署患者同意书",
  SIGN_NOW: "立即签署",
  X_TREATMENT_NAME: "{{X}}开方名称",
  RECENT_PRESCRIPTIONS: "近期开方记录",
  EDITED_IN: "编辑于",
  PHOTOS_AND_VIDEOS: "照片和视频",
  GENERATING_CONSENT_FORM: "正在生成同意书",
  CANCELLED: "已取消",
  MORE_INFO_PLS_CHECK_MEDICAL_HISTORY_USING_DESKTOP:
    "部分价格信息在轻量版本中不可查看，请使用桌面版查看完整内容。",
  UPDATING_PRICE: "更新价格中... 请重试",
  DIAGNOSIS_DATE: "问诊日期",
  EDIT_DIAGNOSIS_DATE: "编辑问诊日期",
  CHANGE_DIAGNOSIS_DATE_TO: "将问诊日期修改为",
  PAID_AT: "结账日期",
  PRESCRIPTION_DATE_UPDATED: "诊断日期已更新",
  PAIN_LEVEL: "疼痛程度",
  PAIN_TYPE: "疼痛类别",
  NO_INFO_RECORDED: "暂无记录。",
  RECORD_NO: "记录编号",
  SAVE_AND_NEXT: "保存并下一步",
  GUIDED_HINT_CONSULT_NOTES: "用患者自己的描述记录本次就诊的主诉。",
  GUIDED_HINT_PAIN_TYPE: "选择患者描述的所有疼痛类型。",
  GUIDED_HINT_PAIN_LEVEL: "评估患者当前疼痛程度（0 为无痛，10 为剧痛）。",
  GUIDED_HINT_PAIN_CONDITIONS: "按身体系统添加相关病症。",
  GUIDED_HINT_TODAYS_TREATMENTS: "今日治疗",
  GUIDED_MODALITY_TAB_DESC: "在上方选择治疗卡片进行编辑，或添加新的治疗。下方标签页用于记录当前治疗。",
  GUIDED_MISSING: "缺少",
  GUIDED_TREATMENT_OVERVIEW: "总览",
  GUIDED_TREATMENT_DETAILS: "治疗内容",
  GUIDED_HINT_OVERVIEW: "查看今日治疗，选择一项进行记录。",
  GUIDED_HINT_TREATMENT_DETAILS: "选择部位与穴位、手法，并填写治疗时长。",
  GUIDED_HINT_TREATMENT_NOTE: "填写治疗备注与计划。",
  GUIDED_HINT_PRECAUTION: "记录注意事项或禁忌。",
  GUIDED_TAB_HELPER: "点击上方标签切换填写内容。",
  GUIDED_TAB_TOOLTIP: "打开此部分",
  GUIDED_HINT_CHECKOUT: "核对费用、添加其他收费并确认收款。",
  GUIDED_CONFIRM_PAYMENT: "确认收款",
  BODY_MAP: "在人体图上标记疼痛部位。",
  GUIDED_HINT_MEDICAL_SAFETY: "治疗前请记录过敏史与怀孕状态。",
  GUIDED_HINT_UPLOAD_PHOTOS: "上传与本次问诊相关的照片。",
  GUIDED_HINT_MODALITY: "查看或添加本次就诊的治疗项目。",
  GUIDED_HINT_TREATMENT_POINTS: "搜索并选择本次治疗使用的穴位。",
  GUIDED_HINT_TECHNIQUES: "选择治疗部位，以及每个部位所使用的手法。",
  GUIDED_HINT_DURATION: "填写治疗时长及相关备注。",
  GUIDED_HINT_OUTCOME: "记录患者对治疗的反应。",
  GUIDED_HINT_RECOMMENDATION: "记录医嘱与建议的后续安排。",
  GUIDED_HINT_PAYMENT_FEE: "确认每项治疗的费用。",
  GUIDED_HINT_PAYMENT_OTHER: "添加其他费用并核对总额。",
  GUIDED_HINT_BODY_MAP: "在人体图上标记疼痛部位。",
  // 引导式流程专用显示文案；Classic 保持原有措辞，且不影响任何 key / 接口字段。
  GUIDED_LABEL_CHIEF_COMPLAINT: "问诊记录",
  GUIDED_LABEL_PAIN_CHARACTER: "疼痛类别",
  GUIDED_LABEL_PAIN_SEVERITY: "疼痛程度",
  GUIDED_LABEL_RELATED_CONDITIONS: "痛症",
  GUIDED_LABEL_AFFECTED_AREAS: "疼痛部位",
  GUIDED_LABEL_MEDICAL_SAFETY: "过敏/怀孕情况",
  GUIDED_LABEL_ALLERGY: "过敏情况",
  GUIDED_LABEL_ASSESSMENT_PHOTOS: "上传照片",
  GUIDED_LABEL_TREATMENT_OVERVIEW: "治疗总览",
  GUIDED_LABEL_TREATMENT_AREA_TECHNIQUE: "治疗部位与手法",
  GUIDED_LABEL_TREATMENT_POINTS: "治疗穴位",
  GUIDED_LABEL_TREATMENT_DURATION: "治疗时长",
  GUIDED_LABEL_TREATMENT_NOTE_PLAN: "治疗记录与计划",
  GUIDED_LABEL_PRECAUTIONS_ADVICE: "注意事项与医嘱",
  GUIDED_LABEL_TREATMENT_OUTCOME: "治疗效果",
  GUIDED_LABEL_FOLLOW_UP_RECOMMENDATION: "后续建议",
  GUIDED_LABEL_PAYMENT: "付款",
  GUIDED_DOC_TITLE: "病历清单",
  GUIDED_X_OF_Y_REQUIRED_COMPLETED: "已完成 {{X}}/{{Y}} 项必填",
  GUIDED_REQUIRED_MISSING_SUMMARY: "必填 ({{X}}) 条未填写内容：",
  GUIDED_OPTIONAL_MISSING_SUMMARY: "选填 ({{X}}) 条未填写内容：",
  GUIDED_STEP_1_SYMPTOMS: "第一步：症状",
  GUIDED_STEP_2_TREATMENT: "第二步：治疗",
  GUIDED_STEP_3_PAYMENT: "第三步：付款",
  GUIDED_GROUP_SYMPTOMS: "症状",
  GUIDED_GROUP_ASSESSMENT: "评估",
  GUIDED_GROUP_TREATMENT: "治疗",
  GUIDED_GROUP_PAYMENT: "付款",
  GUIDED_X_REQUIRED_REMAINING: "还有 {{X}} 项必填",
  GUIDED_GROUP_COMPLETE: "已完成",
  GUIDED_GROUP_NOT_STARTED: "未开始",
  GUIDED_SAVE_AND_CONTINUE_TO_PAYMENT: "保存并付款",
  GUIDED_SAVE_AND_SKIP_OPTIONAL: "保存并跳过选填",
  GUIDED_SKIP_TOOLTIP: "暂不填写，直接进入下一项",
  BODY_MAP: "人体图",
  GST: "消费税 (GST)",
  RECEIPT: "收据",
  CLINICAL_RECORD: "临床记录",
  EXPAND_RECORD_PREVIEW: "展开记录预览",
  COLLAPSE_RECORD_PREVIEW: "关闭记录预览",
  DOC_CHECKLIST: "病历清单",
  CLICK_TO_TOGGLE_IMG: "点击切换图片",
  CLICK_TO_TOGGLE_X: "点击切换至{{X}}",
  IMG_FRONT: "正面",
  IMG_BACK: "反面",
  DEFAULT_SCALE: "默认比例",
  LOADING_IMG: "正在加载图片",
  THIS_IMAGE_HAS_DETECTED_TO_BE_OLD_CANVAS_NEW_CANVAS_WILL_BE_APPLY_IN_NEXT_UPDATE:
    "检测到当前使用的图片为旧版本。在您下次更新时，系统将自动切换为最新版本的图片。请注意，新版本的点位位置与旧版本存在差异，更新后需重新进行标点。",
  NO_IMAGE_FOUND: "未找到图片",
  SELECTABLE_POINTS: "点位",
  NO_OF_PACKS: "药包数量",
  PER_DAY: "天",
  "DOSAGE.PER_DAY": "每天",
  "DOSAGE.SHOW_DAILY": "显示每日剂量",
  PACKS: "包",
  HEALTH_CONDITION_RECORD: "健康状况记录",
  AS_MYSELF: "以自己名义",
  ON_BEHALF_OF: "为其他医师开方",
  ON_BEHALF_OF_X: "为{{X}}开方",
  ON_BEHALF_OF_OTHERS: "为其他医师开方",
  UPLOAD_PAYMENT_DOC: "上传付款文件",
  PAYMENT_FILES: "付款文件",
  SELECTED_HISTORY: "已选择的记录",
  PATIENT_NOT_FOUND: "未在当前工作诊所中找到患者",
  NEW_PATIENT_RECORD: "为新患者开方",
  VIEW_EDIT: "查看 / 编辑",
  FIND: "查找",
  SEARCH_BY_PATIENT_NAME_MOBILE: "按患者姓名/手机号搜索",
  NO_BOOKINGS_FOUND: "未找到有关预约记录",
  FILL_IN_TREATMENT_NOTE_PLAN: "填写治疗描述/计划",
  TREATMENT_NOTE_PLAN: "治疗描述/计划",
  DOWNLOAD_SELECTED_MEDICAL_RECORDS: "下载选中的病历",
  DOWNLOAD_ALL_CURRENT_MEDICAL_RECORDS: "下载以下全部病历",
  DOWNLOAD_ALL_CONSENT_FORMS: "下载患者历史所有同意书",
  ARE_YOU_SURE_TO_DOWNLOAD_SELECTED_MEDICAL_RECORDS: "确定要下载所选病历吗？",
  ARE_YOU_SURE_TO_DOWNLOAD_ALL_MEDICAL_RECORDS: "确定要下载全部病历吗？",
  UNPAID_MEDICAL_RECORDS_WILL_NOT_BE_DOWNLOADED: "未完成付款的病历将不会包含在下载内容中。",
  DATE_RANGE: "日期范围",
  NUMBER_OF_RECORDS: "病历数量",
  ENTER_TREATMENT_NAME: "请输入开方名称",
  QUICK_SELECT: "快捷选择",
  SELECT_FROM_BODY_PART: "从部位图选择",
  ADD_EDIT_METHOD_FROM_BODY_PART: "从已选部位编辑手法",
  EDIT_METHOD: "编辑手法",
  NO_BODY_PART_HAS_BEEN_SELECTED: "检测到您暂未在上一步勾选部位",
  GO_AND_EDIT_BODY_PART: "前往部位图勾选",
  CLICK_POINT_ON_IMAGE_TO_SELECT_METHOD: "点击圆圈，为该部位添加手法",
  BACK_TO_TREATMENT: "返回开方流程",
  CLICK_POINT_ON_IMAGE_FROM_LEFT_TO_SELECT_METHOD: "点击左侧图片中的部位来选择手法",
};

const search = {
  SEARCH: "搜索",
  SEARCH_PLACEHOLDER: "搜索",
  SEARCH_RESULT: "搜索结果",
  NO_SEARCH_RESULT: "未找到搜索结果",
  SEARCHING: "搜索中",
  SEARCH_PATIENT: "按姓名/电子邮箱/手机号搜索患者",
  SEARCH_PATIENT_WITH_INSURANCE: "按姓名/电子邮箱/手机号/保险号搜索患者",
  SEARCH_FOR_PATIENT_IN_TOP_SEARCH_BAR_OR_NEW_PATIENT_HERE:
    "在下方通过搜索患者姓名查找患者，或点击左侧按钮添加新患者。",
  SEARCH_PATIENT_BY_NAME: "按姓名/电子邮箱/手机号/保险号搜索患者",
  NO_PATIENT_FOUND: "未找到患者",
  SEARCHING_PATIENT: "正在搜索患者",
};

const info = {
  DOB: "出生日期",
  DATE_OF_BIRTH: "出生日期",
  SELECT_PATIENT: "选择患者",
  X_PRESCRIPTION_INFO: "{{X}}的处方单",
  VIEW_DETAILS: "查看详情",
  "MEDICAL_HISTORY_#X": "病历 #{{X}}",
  LAST_MODIFIED_BY_X_AT_Y: "最后由 {{X}} 于 {{Y}} 修改",
  NEW_MEDICAL_HISTORY: "新病历",
  NOT_SAVED_YET: "尚未保存",
  SAVE_HISTORY: "保存病历",
  PATIENT_INFO: "患者信息",
  PATIENT_ID: "患者ID",
  GENDER: "性别",
  MALE: "男",
  FEMALE: "女",
  MEDICAL_HISTORY: "病历记录",
  APPOINTMENT: "预约记录",
  NO_HISTORY_FOUND: "未找到历史记录",
  DESCRIPTION: "个人简介",
  COMPLAINTS_SYMPTOMS: "主诉/症状",
  DIAGNOSIS: "诊断",
  TREATMENT: "开方",
  ENGLISH_CONTENT_GOES_HERE: "在此录入英文内容",
  CN_CONTENT_GOES_HERE: "在此录入中文内容",
  EDITING: "编辑中",
  SIGNS_DIAGNOSIS: "体征和诊断",
  TREATMENT_STRATEGIES: "治疗方案",
  ACUPUNCTURE_POINTS_DURATION_METHODS: "穴位、时间和方法",
  ALLERGY: "艾灸",
  THERAPEUTICAL_MASSAGE: "推拿",
  GUA_SHA: "刮痧",
  OTHER: "其他",
  REMARKS: "备注",
  TRANSLATE_FROM_X: "从{{X}}",
  TRANSLATE_TO_X: "翻译至{{X}}",
  TRANSLATE: "翻译",
  CHINESE: "中文",
  ENGLISH: "英文",
  THAI: "泰文",
  VIETNAMESE: "越南文",
  X_CONTENT_GOES_HERE: "在此录入{{X}}内容",
  NAME_X: "名称（{{X}}）",
  TRANSLATION_CONFIRM: "翻译确认",
  TRANSLATED_CONTENT_WILL_BE_APPLIED_OVERWRITE_UR_EXISTING_CONTENT:
    "翻译的内容将覆盖现有内容。",
  TRANSLATE_FROM_X_TO_Y: "从 {{X}} 翻译为 {{Y}}",
  ARE_YOU_SURE_TO_TRANSLATE: "是否确认翻译",
  INFO_FILLED: "信息已保存",
  NO_DATA_FOUND: "无数据",
  FULL_CONTENT_X: "{{X}}完整病历",
  "UPDATE_HISTORY_#X": "更新病历 #{{X}}",
  EDIT_DESCRIPTION: "编辑个人简介",
  EDIT_PATIENT: "编辑患者信息",
  BASIC_INFO: "基本信息",
  FIRST_NAME: "名",
  LAST_NAME: "姓",
  CONTACT_DETAIL: "联系方式",
  RESIDENTIAL_ADDRESS: "家庭地址",
  EMERGENCY_CONTACT_DETAIL: "紧急联系人信息",
  RELATIONSHIP: "与患者关系",
  PATIENT_DISCLOSE: "患者补充信息",
  GUARDIAN_NAME: "监护人姓名",
  GUARDIAN: "监护人",
  GUARDIAN_CONTACT_NUMBER: "监护人联系方式",
  GUARDIAN_MOBILE: "监护人联系方式",
  REFERRED_BY: "推荐人",
  NO_INSURANCE: "无医保信息",
  EMERGENCY_CONTACT_PERSON: "紧急联系人",
  EMERGENCY_CONTACT_NUMBER: "紧急联系电话",
  INSURANCE_INFO: "医保信息",
  MORE_DETAILS: "更多信息",
  INSURANCE_X: "医保 {{X}}",
  COMPANY_NAME: "医保公司名称",
  INSURANCE_NO: "会员号",
  EXPIRY_DATE: "到期日期",
  ADD_INSURANCE: "添加医保信息",
  CANCEL: "取消",
  CONFIRM: "确认",
  RESPONSE: "回应",
  SELECT_TEMPLATE: "选择网页模板",
  ADD_TEMPLATE: "添加模板",
  EDIT_TEMPLATE: "编辑模式",
  PUBLISH_WEBSITE: "发布网站",
  VIEW_PUBLISHED_WEB: "预览已发布网站",
  TEMPLATE: "网页模板",
  INSURANCE: "医保",
  EXPIRED_IN: "到期时间",
  EXIT_EDIT: "退出编辑",
  X_VERSION: "{{X}}版本",
  MAKE_APPOINTMENT: "预约医师",
  AI_TRANSLATE: "AI翻译",
  EDIT_TITLE: "编辑标题",
  EDIT_NAME: "编辑名称",
  EDIT_INTRODUCTION: "编辑专业描述",
  ADD_SKILL: "添加专长",
  SKILL: "专长描述",
  AI_ENQUIRY: "AI查询",
  EDIT_AVATAR: "编辑头像",
  ADD_AVATAR: "添加头像",
  EDIT_CLINIC: "编辑诊所",
  MY_STRENGTHS: "我的优势",
  STANDARD_TREATMENT: "诊疗特色",
  ACADEMIC: "学术成就",
  PATIENT_REVIEW: "患者评价",
  CLINIC_INFO: "诊所信息",
  EDIT_STRENGTHS: "编辑我的优势信息",
  EDIT_TREATMENT: "编辑开方信息",
  EDIT_PROFILE_TREATMENT: "编辑诊疗特色",
  DR_X_ARTICLE: " {{X}}的文章",
  COURSES: "课程",
  ARTICLES: "文章",
  EDIT_COURSE: "编辑课程",
  UPLOAD_REVIEW_BG: "上传评论背景图",
  EDIT_REVIEW: "编辑患者评论",
  PATIENT: "患者",
  TITLE: "专业职称",
  SAVE_SUCCESS: "保存成功",
  CLINIC_NAME: "诊所名称",
  PIN_TO_DISPLAY: "置顶显示",
  DELETE: "删除",
  SUBURB: "区",
  POSTCODE: "邮政编码",
  STATE: "州",
  ADD: "添加",
  MOVE_DOWN: "下移",
  MOVE_UP: "上移",
  SPECIALITY: "专长",
  PUBLISHED: "已发布",
  HIDDEN: "隐藏",
  READ: "阅读",
  ADD_ARTICLE: "添加文章",
  SAVE: "保存",
  PUBLISH: "发布",
  RE_UPLOAD_BG: "重新上传背景",
  PATIENT_NAME: "患者姓名",
  PATIENT_DESCRIPTION: "患者描述",
  REVIEW: "评论",
  REUPLOAD_PROFILE_IMAGE: "重新上传头像",
  COURSE: "课程",
  COURSE_TITLE: "课程名称",
  START_DATE: "开始日期",
  END_DATE: "结束日期",
  START_TIME: "开始时间",
  DURATION: "持续时间",
  COURSE_TYPE: "课程类型",
  OFFLINE_COURSE: "线下课程",
  ONLINE_COURSE: "在线课程",
  MEETING_URL: "课程网址",
  LOCATION: "地点",
  STRENGTH: "优势方面",
  EXIT_PREVIEW: "退出预览",
  MY_PROFILE: "我的档案",
  PURE_HARMONY: "简洁专业模板",
  HERB_ESSENCE: "清新精致模版",
  IM_WORKED_AT: "我已位于",
  START_WORKING: "开始工作",
  TOOLBAR: "工具栏",
  COLLAPSE_TOOLBAR: "收起工具栏",
  EDIT_URL: "编辑网址",
  SLUG: "URL链接",
  EDIT_SLUG: "编辑个人网址",
  PUBLISH_CONFIRM: "发布确认",
  UNPUBLISH_CONFIRM: "取消发布确认",
  ARE_YOU_SURE_TO_X_WEBSITE: "您确定要{{X}}此网页吗？",
  WEBSITE_WILL_BE_PUBLISHED_AND_VISIBLE_TO_PUBLIC_VIA_BELOW_LINK:
    "您的网页将被发布，并允许公众通过以下链接访问",
  WEBSITE_WILL_BE_UNPUBLISHED_AND_HIDDEN_FROM_PUBLIC:
    "您的网页将被取消发布并对公众隐藏",
  U_CAN_STILL_PUBLISH_THE_WSBSITE_LATE_IF_U_WISH:
    "您仍然可以在之后重新发布网页",
  PUBLISH_S: "发布",
  UNPUBLISH_S: "取消发布",
  UNPUBLISH_WEBSITE: "取消发布",
  UNPUBLISHED: "未发布",
  SWITCH_YOUR_TEMPLATE_PUBLISHED: "选择您的新页面模板并发布。",
  CLOSE_EDITOR: "关闭编辑",
  CLOSED: "已关门",
  REMOVE_SUCCESS: "删除成功",
  VIEW_ALL_X_CLINICS: "查看所有 {{X}} 个诊所",
  CONTINUE: "确定",
  ONLY_WORKING_WEEKDAY: "仅在工作日工作",
  WORKING_TIME: "工作时间",
  WORKING_IN_WHOLE_WEEK: "整周工作",
  MONDAY: "周一",
  TUESDAY: "周二",
  WEDNESDAY: "周三",
  THURSDAY: "周四",
  FRIDAY: "周五",
  SATURDAY: "周六",
  SUNDAY: "周日",
  WORKING_TODAY: "设定为工作日",
  END_TIME: "结束时间",
  APPLY_WORKING_TIME_TO_ALL_DAYS: "应用当前工作时间至所有工作日",
  ONLY_WORK_IN_WEEKDAYS: "仅工作日工作",
  WORK_IN_WHOLE_WEEK: "全周工作",
  CURRENT_WORKING_TIME_APPLIED_TO_ALL_DAYS: "当前工作时间已应用于所有工作日",
  DR_X_COURSE: "{{X}}的课程",
  DR_X_VIDEO: "{{X}}的视频",
  DELETE_ARTICLE: "删除文章",
  ARE_YOU_SURE_TO_DELETE_ARTICLE: "您确定要删除这篇文章吗?",
  THIS_ACTION_CANNOT_BE_UNDONE: "此操作不可撤销。",
  SAVE_ARTICLE: "保存文章",
  SAVE_ARTICLE_AND_PUBLISH: "保存文章并发布",
  PUBISH_ARTICLE: "发布文章",
  UNPUBLISH_ARTICLE: "取消发布文章",
  PUBLISH_ARTICLE: "发布文章",
  ARE_YOU_SURE_TO_X_ARTICLE: "您确定{{X}}吗?",
  VISITORS_WILL_NOT_BE_ABLE_TO_VIEW_THIS_ARTICLE: "访客将无法查看这篇文章",
  VISITORS_WILL_BE_ABLE_TO_VIEW_THIS_ARTICLE: "访客可以查看这篇文章",
  UNPUBLISH: "取消发布",
  REMOVE_BG_IMAGE: "移除背景图",
  ARE_YOU_SURE_TO_REMOVE_BG_IMAGE: "您确定要移除背景图片吗？",
  BG_UPLOAD: "上传背景图",
  DEFAULT_BG_WILL_BE_APPLIED: "默认背景图",
  U_ARE_PREPARED_TO_TRANSLATE_UR_WEBSITE_CONTENT: "您已准备好翻译您的网站内容",
  WARNING: "警告",
  IF_YOU_HAVE_INPUTTED_ANY_TEXT_INTO_THE_LANGUAGE_YOU_SELECTED_WILL_BE_OVERWRITTEN:
    "如果您在所选语言中已填入了任何文本信息，这些文本将被覆盖",
  I_UNDERSTAND_THE_ACTION_AND_AGREE_TO_TRANSLATE_USING_AI:
    "我理解该操作并同意使用AI进行翻译",
  ALL_7_DAYS: "整周",
  ARTICLE_TITLE: "文章标题",
  NO_WORKING_DAYS: "无工作时间",
  WEBSITE_PUBLISHED: "网页已发布",
  WEBSITE_UNPUBLISHED: "网页已取消发布",
  TEMPLATE_SWITCHED_AND_PUBLISHED: "模板已更新并发布",
  TRANSLATING_X_PLS_BE_PATIENT: "正在翻译您的网页至{{X}}，请稍候",
  SAVING_TRANSLATION: "正在保存翻译",
  TOGGLE_LANGUAGE: "切换语言",
  TRANSLATE_UR_WEBSITE_USING_AI: "通过AI工具翻译您的网页",
  ARTICLE: "文章",
  VIEW_PATIENT_HISTORY: "查看患者历史",
  PRESCRIPTION_INFO: "患者病历信息",
  TRANSLATE_FROM: "原文",
  TRANSLATE_TO: "翻译至",
  SWAP: "互换",
  NO_WORKING_TIME_AVAILABLE: "无可用工作时间",
  MY_COLLEAGUES: "团队介绍",
  DAILY_SHARING: "每日分享",
  EDIT_MY_COLLEAGUES: "编辑团队介绍",
  ADD_NEW_SHARING: "添加每日分享",
  EDIT_DAILY_SHARING: "编辑每日分享",
  ADD_IMAGE: "添加图片",
  COLLEAGUE_DESCRIPTION: "成员详情",
  REUPLOAD: "重新上传",
  COLLEAGUE: "成员",
  PAY_THE_BALANCE: "支付余额",
  PAYMENT_SUCCESSFUL: "支付成功",
  WHETHER_TO_DISPLAY_THIS_SECTION: "是否展示该模块",
  EDIT_VIDEO: "编辑视频",
  ADD_VIDEO: "添加视频",
  VIDEO: "专业知识分享",
  COVER_IMAGE: "封面图片",
  VIDEO_TITLE: "视频标题",
  VIDEO_DESC: "视频描述",
  WATCH: "观看",
  DELETE_VIDEO: "删除视频",
  ARE_YOU_SURE_TO_DELETE_THIS_VIDEO: "确定要删除此视频吗？",
  USED_BY_PHONE: "正在使用手机操作",
  DISCONNECT_YOUR_PHONE_TO_TYPE_IN: "请断开手机连接以输入内容",
  DISCONNECT: "断开连接",
  CONTENT: "内容",
};

const notification = {
  CLINIC_SWITCHED_TO_X: "诊所已切换至{{X}}",
  ONLY_IMAGE_FILES_ALLOWED: "仅允许图像文件",
  HISTORY_SAVED: "已保存病历",
  TRANSLATION_COMPLETED: "翻译完成",
  "UPDATE_HISTORY_#X": "病历 #{{X}}已更新",
  ARTICLE_TITLE_CANNOT_BE_EMPTY: "文章标题不能为空",
  ARTICLE_UPDATED: "文章已更新",
  ARTICLE_CREATED: "文章已创建",
  ARTICLE_PUBLISHED: "文章已发布",
  ARTICLE_UNPUBLISHED: "文章已取消发布",
  ARTICLE_DELETED: "文章已删除",
  PREVIEW_TEMPLATE: "预览网页",
  U_R_IN_PREVIEW_MODE: "您处于预览模式",
  U_R_IN_EDIT_MODE: "您处于编辑模式",
  PROFILE_IMAGE_UPLOADED: "头像已上传",
  SAVE_SUCCESS: "保存成功",
  INCORRECT_USERNAME_OR_PASSWORD: "用户名或密码错误",
  CLINIC_X_SELECTED: "已选择当前工作诊所: {{X}}",
  AUTHENTICATION_EXPIRED: "身份验证已过期！请尝试重新登录",
  MAKE_AN_APPOINTMENT: "预约",
  APPOINTMENT_TIME: "预约时间",
  PHONE: "电话",
  EMAIL: "电子邮箱",
  FIRST_NAME_IS_REQUIRED: "需要填写名",
  LAST_NAME_IS_REQUIRED: "需要填写姓",
  PHONE_IS_REQUIRED: "需要填写电话",
  INVALID_PHONE_NUMBER: "无效的电话号码",
  INVALID_PHONE_FORMAT_SMS_WARNING: "当前号码可能影响短信接收，请确保为04XXXXXXXX格式以保证短信收取正确。",
  PLEASE_FIX_ERRORS: "请修正错误",
  BOOKING_CREATED: "预约已创建",
  FIRSTNAMEEN_IS_REQUIRED: "需要填写名（英文）",
  LASTNAMEEN_IS_REQUIRED: "需要填写姓（英文）",
  INVALID_EMAIL: "无效的电子邮箱",
  EMAIL_IS_REQUIRED: "需要填写电子邮箱",
  ADDRESS_IS_REQUIRED: "需要填写地址",
  LESS_DETAILS: "收起详情",
  REMOVE: "移除",
  COMPANY_NAME_IS_REQUIRED: "需要填写保险公司名称",
  INSURANCE_NUMBER_IS_REQUIRED: "需要填写保险单号",
  CONFIGURATION: "偏好设置",
  SELECT_SECTION_U_ARE_GOING_TO_CONFIGURE: "选择您要设置的功能",
  BUSINESS: "工作",
  CONFIGURE_BUSINESS_TIME: "设置营业时间以及您的服务种类",
  LANGUAGE: "语言",
  CURRENT_LANGUAGE_X: "当前语言是: {{X}}",
  PATIENT_CREATED: "已创建患者信息",
  PATIENT_EDITED: "患者信息已更新",
  CHECK_IN_SUCCESS: "签到成功",
};

const appointment = {
  APPOINTMENT_INFO: "预约信息",
  APPOINTMENT_STATUS: "预约状态",
  CHECKED_IN: "已就诊",
  CHECK_IN: "开始问诊",
  PROCEED_TO_MEDICAL_HISTORY: "添加病历",
  APPOINTMENT_CLINIC: "预约诊所",
  NAME: "姓名",
  U_MIGHT_LOOKING_FOR_PATIENT: "👀 您在找以下患者吗？",
  NO_RELAVANT_PATIENT_IN_CLINIC: "👀 当前诊所中暂未发现相似的患者信息记录。",
  PLS_ADD_PATIENT_FIRST: "您想添加此患者到您的诊所吗？",
  SELECT_EXISTING_PATIENT_FROM_CLINIC_TO_CREATE_MEDICAL_HISTORY:
    "从当前诊所中选择患者以创建新病历",
  CREATE_MEDICAL_HISTORY: "新建病历",
  NONE_OF_PATIENT_ABOVE_IS_CORRECT: "以上患者都不符合？",
  PENDING_CHECK_IN: "已预定",
  PENDING_CHECK_IN_WAITING: "在诊所候诊",
  ARE_YOU_SURE_TO_CHECK_IN_THIS_APPOINTMENT_FOR_X:
    "您确定为{{X}}完成预约签到？",
  AFTER_CHECKED_IN_YOU_CAN_PROCEED_MEDICAL_HISTORY_FOR_THIS_PATIENT:
    "预约签到后，您可以为此患者填写病历。",
  LOADING_APPOINTMENT: "加载预约信息",
  TODAY: "今天",
  MASSAGE: "中医推拿",
  ACUPUNCTURE: "针灸",
  CHINESE_MEDICINE: "中医",
  APPROX: "预计时长",
  APPROXIMATE_DURATION: "预计时长",
  DURATION_MINUTES: "{{m}}分钟",
  DURATION_HOURS: "{{h}}小时",
  DURATION_HOURS_MINUTES: "{{h}}小时{{m}}分钟",
  VIEW_IN_SCHEDULE: "在时间表中查看",
  BUSINESS_TIME: "营业时间",
  WORKING_SERVICES: "服务种类",
  WORKING_DAYS: "工作日期",
  WORKING_TIME_PERIOD: "工作时间段",
  RESET: "重置更改",
  BLOCK_TIME_SLOTS: "选择休息时间段",
  APPLY_BLOCK_TIMES_TO_ALL_DAYS: "应用当前休息时间至所有工作日",
  LOADING_TIME_SLOTS: "加载时间段",
  NO_AVAILABLE_TIME: "无可用时间段",
  RESET_CLINIC: "成功重置工作时间更改",
  SAVE_CHANGES: "保存更改",
  CLINIC_NOT_FOUND: "未找到诊所",
  SAVE_CLINIC_SUCCESS: "营业时间更新成功",
  PLEASE_SELECT_WORKING_SERVICES: "请选择至少一个服务",
  START_TIME_CANNOT_BE_AFTER_END_TIME: "开始时间不能晚于结束时间",
  END_TIME_CANNOT_BE_BEFORE_START_TIME: "结束时间不能早于开始时间",
  SELECTED_WEEKDAY: "选择的工作日",
  MINUTES: "分钟",
  CLEAR_ALL: "清空",
  SELECT_ALL: "全选",
  COPY_PRODUCTS_TO_OTHER_CLINIC: "复制产品至其他诊所",
  COPY_PRODUCTS_FROM_OTHER_CLINIC: "从其他诊所复制产品",
  ASSIGN_PRACTITIONERS_TO_IMPORTED: "为导入产品配置人员",
  SELECT_SOURCE_CLINIC: "选择来源诊所",
  X_PRODUCTS_IMPORTED_FROM_Y: "已从 {{Y}} 成功导入 {{X}} 个产品",
  COPY_TO_THIS_CLINIC: "复制到该诊所",
  SELECT_PRODUCTS_TO_COPY: "选择要复制的产品",
  SELECT_TARGET_CLINIC: "选择目标诊所",
  SELECTED_X_OF_Y: "已选 {{X}} / {{Y}}",
  PRODUCTS_COPIED_SUCCESS: "产品已成功复制至目标诊所",
  X_PRODUCTS_COPIED_TO_Y: "已成功将 {{X}} 个产品复制至 {{Y}}",
  GO_TO_CLINIC_PRODUCTS: "跳转至该诊所产品页面",
  HIDE_PREVIEW: "隐藏预览",
  X_PRODUCTS_IN_THIS_CLINIC: "该诊所共有 {{X}} 个产品",
  CLICK_ON_TIMESLOT_THAT_YOU_DONT_WANT_IT_BE_AVAILABLE_FOR_APPOINTMENT:
    "通过点击来屏蔽您不想让患者预约的时间段",
  SELECT_WORKING_DAY: "选择工作日",
  DECREASE_DURATION: "减少时长",
  INCREASE_DURATION: "增加时长",
  CURRENT_BLOCK_TIME_APPLIED_TO_ALL_DAYS: "当前休息时间已应用于所有工作日",
  SAVE_AS_NOT_WORKING: "设定为非工作日",
  SAVE_AS_WORKING: "设定为工作日",
  CONFIRM_CLEAR_BLOCK_TIMES: "您确定要清除休息时间吗？",
  CHANGING_DURATION_WILL_CLEAR_ALL_BLOCK_TIMES:
    "此操作将清除所有休息时间，包括已选择的时间段，并将其设定为可预约时间段，此操作不可撤销。",
  CHANGING_WORKING_TIME_WILL_CLEAR_TODAY_BLOCK_TIMES:
    "此操作将清除当前日期的休息时间，包括已选择的时间段，并将其设定为可预约时间段，此操作不可撤销。",
  BLOCK_TIMES_CLEARED: "休息时间已清除",
  SAVING: "保存中",
  BLOCK_THIS_TIMESLOT: "禁用这个时间段",
  ACTIVE_THIS_TIMESLOT: "激活这个时间段",
  UNSAVED_CHANGES: "您有未保存的更改",
  SCHEDULE_CONFLICT: "排班冲突",
  ALREADY_WORKING_IN_OTHER_CLINICS_ON_THESE_DAYS: "您在以下日期已在其他诊所安排了工作：",
  CONFIRM_TO_REPLACE_AND_SAVE: "确认后将先替换其他诊所的这些日期，然后保存当前更改。",
  YOU_HAVE_UNSAVED_CHANGES_CONTINUE:
    "您有未保存的更改。您确定要切换诊所并忽略它们吗？",
  DISCARD_AND_SWITCH: "忽略并切换",
  YOU_HAVE_NO_CONFIGURE_YOUR_WORKING_TIME_IN_THIS_CLINIC:
    "您尚未在此诊所配置工作时间",
  CONFIGURE_WORKING_TIME: "医师工作时间与服务种类",
  MY_WORKING_CLINICS: "我的工作诊所",
  ALL: "全部",
  FILTER: "筛选",
  STATUS: "状态",
  ERROR_BOOKINGS: "错误预约",
  TIP: "提示",
  ERROR_BOOKINGS_USUALLY_BECUZ_THE_WORKING_DURATION_HAS_CHANGED_OVER_TIME_AFTER_THE_APPOINTMENT_HAS_BEEN_CREATED_EARLIER:
    "错误预约通常是由于工作时间在预约创建前发生了变更所导致的。您仍可以照常进行问诊，或为患者重新安排一个新的时间。",
  REJECT: "拒绝",
  DATE_OF_BIRTH_IS_REQUIRED: "出生日期是必填项",
  INVALID_DATE: "日期无效",
  DATE_CANNOT_BE_IN_FUTURE: "日期不能晚于今天",
  PATIENT_UPDATED_WARNING: "患者信息提示",
  SYSTEM_HAS_DETECTED_THE_FOLLOWING_CHANGES_TO_THIS_PATIENT:
    "系统检测到当前患者信息与预约时提供的信息不一致",
  DO_U_WANT_TO_UPDATE_THIS_PATIENT_INFO: "您是否希望更新患者信息？",
  CURRENT_INFO: "当前资料",
  UPDATED_INFO: "更新后的资料",
  QUICK_UPDATE: "一键更新",
  DATE_SCHEDULE: "当天规划",
  NO_APPOINTMENT_FOUND: "无预约",
  INCOMING_BOOKINGS_ONLY: "仅显示未开始的预约",
  SELECT_HOUR: "选择小时",
  SELECT_MINUTE: "选择分钟",
  SELECT_APPOINTMENT_TIME: "选择预约时间",
  X_APPOINTMENTS_SCHEDULED_FOR_THIS_DATE: "当天已安排 {{X}} 个预约",
  X_APPOINTMENTS_SECHEDULED_FOR_TODAY: "今天已安排 {{X}} 个预约",
  THIS_SAVED_PATIENT_INCLUDES_INVALID_PHONE_NUMBER_THIS_MIGHT_BE_A_PROBLEM_RECEIVING_SMS_LATER:
    "检测到当前患者的电话号码无效，这可能会影响后续短信通知的接收。",
  A_REMINDER_SMS_WILL_BE_SENT_TO_THE_PATIENT_WHEN_NEAR_THE_APPOINTMENT_DATE:
    "注：当预约时间临近时，系统将向患者发送提醒短信。",
  A_REMINDER_SMS_WILL_BE_SENT_TO_THE_U_WHEN_NEAR_THE_APPOINTMENT_DATE:
    "注：当预约时间临近时，系统将向您发送提醒短信。",
  BOOKED_PRACTITIONER: "被预约医师",
  U_CAN_MANAGE_UR_CLINIC_PRODUCT_HERE: "在此管理您的诊所服务产品",
  THESE_PRODUCTS_WILL_BE_USED_IN_PATIENTS_BOOKING_FROM_PUBLIC: "这些产品将用于患者通过公开预约系统进行预约时选择",
  THIS_NOTE_WILL_BE_SAVED_TO_NEW_PATIENT_PROFILE: "此备注会保存到新患者资料中",
};

const clinicManagement = {
  CLINIC_SETTINGS: "诊所设置",
  CLINIC_MANAGEMENT: "诊所与人员管理",
  SEARCH_CLINIC_IN_SEARCH_BAR_TO_JOIN_IN_OR_CREATE_NEW_CLINIC:
    "在搜索栏中搜索诊所以加入或创建新诊所",
  NO_CLOSED_CLINICS: "无已关闭的诊所",
  NO_PENDING_CLINICS: "无待处理的诊所",
  SEARCH_CLINIC: "搜索诊所",
  ADD_CLINIC: "创建新诊所",
  CLINIC_INFO: "诊所信息",
  OWNER: "负责人",
  INVITE_PRACTITIONERS: "邀请医师",
  INVITED: "已邀请",
  NO_PRACTITIONER_FOUND: "未找到医师",
  SUBMIT_CLINIC_INFO: "提交诊所信息",
  UPDATE_CLINIC_INFO: "更新诊所信息",
  RESUBMIT_CLINIC_INFO: "重新提交诊所信息",
  ADDRESS: "地址",
  OPEN: "营业中",
  PENDING: "待处理",
  MY_CLINIC: "我的诊所",
  EDIT_CLINIC_INFO: "编辑诊所信息",
  ACTIVE: "活跃",
  INACTIVE: "不活跃",
  ASSOCIATED_PRACTITIONERS: "当前诊所医师",
  NO_PHONE_NUMBER: "无电话号码",
  PRACTITIONER_INFO: "医师信息",
  SERVICES: "服务",
  WORK_TIME: "工作时间",
  WORKING_DAY: "工作日",
  NOT_AVAILABLE: "不可用",
  MINS: " 分钟",
  X_PRACTITIONERS_ARE_NOW_ACTIVE: "{{X}} 位医师处于活跃状态",
  X_PRACTITIONERS_FOUND: "总计{{X}}位医师",
  NO_ACTIVE_PRACTITIONERS: "未找到任何医师",
  NO_INACTIVE_PRACTITIONERS: "无未激活的医师",
  INVITE: "邀请",
  WORKING_IN_CLINIC: "在诊所工作",
  QUIT_PRACTITIONER: "移除医师",
  QUIT_FROM_CLINIC: "退出诊所",
  QUIT_CLINIC_CONFIRM: "确认退出诊所",
  QUIT_CLINIC_REQUEST_SENT: "退出诊所请求已发送",
  ARE_YOU_SURE_TO_QUIT_CLINIC: "确定要退出该诊所吗",
  YOU_WILL_NOT_BE_ABLE_TO_BE_BOOKED_BY_PATIENT_FOR_THIS_CLINIC_ANYMORE:
    "被批准后您将无法再被患者预约该诊所",
  PENDING_APPROVE_TO_QUIT: "离职请求待审批",
  PENDING_APPROVE_TO_JOIN: "加入请求待审批",
  JOIN_CLINIC: "加入诊所",
  X_NEW_MEMBER_REQUESTS: "{{X}} 个待定请求",
  JOIN_CLINIC_CONFIRM: "确认加入诊所",
  ARE_YOU_SURE_TO_JOIN_CLINIC: "确定要加入该诊所吗",
  YOUR_JOIN_REQUEST_HAS_BEEN_SENT: "加入请求已发送",
  NEW_PRACITTIONERS: "新医师",
  ACCEPT_CONFRIM: "确认接受",
  ARE_YOU_SURE_TO_ACCEPT_PRACTITIONER_REQUEST: "确定要接受该医师请求吗",
  ARE_YOU_SURE_TO_REJECT_PRACTITIONER_REQUEST: "确定要拒绝该医师请求吗",
  VIEW_INFO: "查看信息",
  NO_SERVICES_AVAILABLE: "无可用服务",
  SEARCH_PRACTITIONER_BY_NAME: "按姓名搜索诊所医师",
  X_PENDING_APPROVAL: "{{X}} 个请求待审批",
  APPROVE: "批准",
  DECLINE: "拒绝",
  ACCEPT: "接受",
  CLEAR: "清除",
  ACCEPT_CONFIRM: "确认接受",
  REJECT_CONFIRM: "确认拒绝",
  CLOSE_CLINIC: "关闭诊所",
  CONFIRM_TO_CLOSE_CLINIC: "确认关闭诊所",
  THIS_CLINIC_WILL_BE_CLOSED_AND_ALL_ASSOCIATED_PRACTITIONERS_WILL_BE_REMOVED:
    "此诊所将被关闭，所有关联的医师将被移除",
  I_UNDERSTAND_THE_CONSEQUENCES_OF_CLOSING_THIS_CLINIC:
    "我了解关闭此诊所的后果",
  ME: "我",
  ARE_YOU_SURE_TO_REMOVE_PRACTITIONER_FROM_CLINIC:
    "确定要将此医师从诊所中移除吗",
  THIS_PRACTITIONER_WILL_NOT_BE_ABLE_TO_VIEW_USE_INFO_FOR_THIS_CLINIC:
    "此医师将无法再在该诊所工作",
  INVITE_CONFIRM: "确认邀请",
  ARE_YOU_SURE_TO_INVITE_X_TO_YOUR_CLINIC: "确定要邀请 {{X}} 加入您的诊所吗",
  CONTINUE: "继续",
  PENDING_ACCEPT: "待医师接受",
  NO_CLINIC_SELECTED: "未选择诊所",
  NO_WORKING_CLINIC_FOUND: "未找到工作中的诊所",
  NEW_CLINIC_INVITATION: "诊所加入邀请",
  ADD_JOIN_CLINIC: "加入 / 创建新诊所",
  OR_U_CAN: "或者您可以",
  CONSULTATION_FEES: "诊所费用",
  THIS_CONSULTATION_FEES_WILL_BE_DISPLAYED_IN_YOUR_PERSONAL_PAGE:
    "填写完整的诊所费用（费用需填写大于$0.00）将显示在您的个人主页上",
  ENTER_FEE_LABEL: "填入费用名称",
  ADD_OTHER_CONSULTATION_FEE: "添加其他诊所费用",
  DOWNLOAD_EMPTY_CONSENT_FORM: "打印患者同意书",
  CONSENT_FORM_UPLOADED: "患者同意书上传成功",
  VIEW_CONSENT_FORM: "下载同意书",
  UPLOAD_CONSENT_FORM: "上传同意书",
  REUPLOAD_CONSENT_FORM: "重新上传同意书",
  UPLOADING: "上传中",
  UPLOAD: "上传",
  IMPORTANT: "您当前未属于任何诊所",
  ALL_PACKAGES: "所有套餐",
  PACKAGE_FILTER: "通过已绑定套餐筛选诊所用户",
  EXTEND_PACKAGE: "扩展套餐",
  OOPS_THIS_PACKAGE_HAS_ALREADY_REACHED_ITS_CAPACITY:
    "🤔 该套餐已达到其可分配用户最大数量。",
  USER_PACK_PURCHASED: "用户已分配数量 / 已购买数量",
  THIS_PACKAGE_HAS_ALREADY_BEEN_ASSIGNED_TO_THIS_CLINIC_USER:
    "当前所选的用户已被分配此套餐",
  THIS_PACKAGE_HAS_ALREADY_REACHED_ITS_CAPACITY:
    "该套餐已达到其可分配用户的最大数量",
  EXPIRED_TODAY: "即将过期",
  SOON_TO_EXPIRED: "即将过期",
  EXTEND_NOW: "立即添加人数",
  REMOVE_PACKAGE_FROM_USER: "移除此用户的套餐",
  NO_PERMISSION_TO_ACCESS_CLINIC_FUNCTION:
    "无套餐的情况下此用户将无权访问该诊所功能",
  NO_PERMISSION_ACCESS_FEATURE_OR_DATA:
    "您当前不具备访问该数据或者功能的权限，如您有任何权限有关疑问请向诊所管理员咨询",
  CURRENT_CLINIC_INVALID_MAY_HAVE_LEFT:
    "当前诊所已失效，您可能已离开该诊所",
  CLINIC_WORK_PERMISSIONS_UPDATED: "检测到您当前的诊所工作权限已更新",
  VALID_PACKAGE: "当前有效套餐",
  REPURCHASE_PACKAGE: "重新购买套餐",
  CLOSED_CLINIC: "诊所已关闭",
  THIS_CLINIC_HAS_BEEN_CLOSED: "当前诊所已处于关闭状态",
  CLINIC_RELATED_TO_ME: "与我相关的诊所",
  CANCEL_INVITATION_SUCCESS: "邀请取消成功",
  AVG_DURATION: "平均问诊时长",
  VIEW_CLINIC: "查看诊所详情",
  NEW: "新用户",
  CLINIC_NO_PACKAGE_SUBSCRIBED: "诊所当前没有订阅任何套餐。",
  PURCHASE_PACKAGE_AND_ASSIGN_TO_CLINIC_MEMBERS_TO_START_WORKING_AT_HEALTHNEX:
    "购买套餐并分配给诊所工作人员后，您就能立刻启用 Healthnex 的完整服务体验！",
  PURCHASE_PACKAGE_TO_START_WORKING_AT_HEALTHNEX:
    "购买套餐后，您就能立刻启用 Healthnex 的完整服务体验！",
  PURCHASE_PACKAGE_FOR_UR_CLINIC: "为您的诊所购买合适的套餐吧",
  NO_SURE_WHAT_DO: "不确定从哪里开始？",
  START_SYSTEM_GUIDE: "开始引导",
  NO_PACKAGE_ALLOCATED: "当前诊所尚未为您分配工作权限",
  PLEASE_CONTACT_YOUR_CLINIC_OWNER_TO_ASSIGN_THE_PACKAGE_TO_ACCESS_MORE_FEATURES_IN_HEALTHNEX:
    "请联系您的诊所负责人 (Business Owner) 为您分配工作权限，以便访问完整 Healthnex 功能。",
  SUBSCRIPTION: "订阅服务",
  SELECT_A_SUITABLE_PACKAGE_FOR_YOUR_CLINIC_MEMBERS_TO_START_WORKING:
    "请选择适合您诊所工作的功能套餐",
  ASSIGN_TO_CLINIC: "分配至诊所",
  SELECT_THE_CLINIC_THAT_U_WITH_TO_APPLY_THIS_PACKAGE_FOR:
    "请选择您希望应用此套餐的诊所",
  ADJUST_NUMBER_USER_PACK_U_WISH_TO_PURCHASE:
    "请调整您希望购买的用户套餐数量 （如果此套餐是规定人数的组合包您将无法自定义用户数量）",
  USER_PACK_CAN_BE_ASSIGNED_TO_CLINIC_USER_TO_ALLOW_EXPERIENCE_THE_PACKAGE_FEATURE:
    "用户套餐可分配给诊所工作人员，使其能够体验套餐功能",
  EG_PURCHASED_3_USER_PACKS_CAN_BE_APPLY_TO_3_USERS_IN_CLINIC_INCLUDE_OWNER:
    "例如，购买 3 个用户套餐后，您可以将其分配给 3 位诊所工作人员（包括诊所负责人 / Business Owner）",
  ASSIGN_USER_PACK_TO_CLINIC_USER: "将用户套餐分配给诊所工作人员",
  CLINIC_MEMBERS_WHO_DONT_HAVE_PACKAGE_WILL_BE_DISPLAYED_HERE_U_CAN_QUICK_ASSIGNED_PURCHASED_USER_PACK_TO_THEM:
    "当诊所工作人员尚未被分配套餐（工作权限）时，他们将显示在此处。您可以在此快速为他们分配已购买的用户套餐",
  CARD_DETAIL: "信用卡信息",
  FILLING_UR_CARD_DETAIL_TO_PAY: "填写您的信用卡信息以完成支付",
  PAY_NOW: "立即支付",
  DONT_SHOW_AGAIN: "不再显示",
  ORDER_NO: "订单",
  SELECTED_CLINIC: "当前所选诊所",
  CLINIC_LOGO: "诊所 Logo",
  EDIT_LOGO: "编辑 Logo",
  ADD_LOGO: "添加 Logo",
  REUPLOAD_LOGO: "重新上传 Logo",
  UPLOAD_LOGO: "上传 Logo",
  CLINIC_LOGO_UPLOADED: "诊所 Logo 已上传",
  NO_CLINICS_FOUND_IN_X: "🤔 在{{X}}中未找到相关诊所",
  U_CAN_CREATE_YOUR_OWN_CLINIC_OR_JOIN_AN_EXISTING_CLINIC_TO_WORK_LATER:
    "🎉 别担心，稍后您可以随时创建新的诊所，或加入现有诊所来继续享受系统功能。",
  JOINED: "已加入",
  U_ARE_THE_OWNER_OF_BELOW_CLINICS: "您将成为以下诊所的负责人",
  WE_WILL_CREATE_THE_CLINIC_FOR_YOU_ANY_NO_NAME_CLINIC_WILL_BE_RENAME_TO_YOUR_NAME:
    "我们将为您创建这些诊所。请注意，任何未命名的诊所将自动使用您的名称进行命名。例如：John's Clinic",
  U_ARE_THE_MEMBER_OF_BELOW_CLINICS: "您将成为以下诊所的成员",
  U_WILL_BE_THE_MEMBER_OF_THE_BELOW_CLINICS:
    "您将加入以下 Healthnex 已存在的诊所，成为其中的一员",
  THESE_CLINICS_HAS_NOT_BEEN_CREATED_BY_THEIR_OWNER_IN_SYSTEM_PLEASE_CONTACT_THEIR_OWNER_TO_CREATE_THE_CLINIC_AND_INVITE_YOU_IN:
    "这些诊所在 Healthnex 系统中尚未由其负责人创建。请联系诊所负责人 (Business Owner) 完成创建，并邀请您加入。",
  CLINIC_BELOWS_ARE_NOT_IN_THE_SYSTEM:
    "您是以下诊所的成员，但这些诊所尚未在 Healthnex 系统中创建。",
  CREATING_ACCOUNT: "请稍候，我们正在创建您的 Healthnex 账号",
  PLEASE_DONT_CLOSE_THIS_PAGE: "请勿关闭此页面",
  WELCOME_TO_HEALTHNEX: "欢迎来到 Healthnex!",
  GETTING_STARTED_SUB: "完成几个简单步骤，开始使用 Healthnex。",
  GETTING_STARTED_PROGRESS: "已完成 {{count}} / 3",
  GETTING_STARTED_CLINIC_TITLE: "创建或加入诊所",
  GETTING_STARTED_CLINIC_DONE: "您的诊所已连接。",
  GETTING_STARTED_CLINIC_SUB: "连接诊所以解锁预约、处方和病历功能。",
  GETTING_STARTED_HOURS_TITLE: "设置您的工作时间",
  GETTING_STARTED_HOURS_LOCKED: "请先创建或加入诊所。",
  GETTING_STARTED_HOURS_DONE: "您的工作时间已设置。",
  GETTING_STARTED_SET_HOURS: "设置工作时间",
  GETTING_STARTED_RECORD_TITLE: "创建您的第一条病历记录",
  GETTING_STARTED_RECORD_LOCKED: "完成诊所设置后即可使用。",
  GETTING_STARTED_RECORD_DONE: "您已创建第一条病历记录。",
  GETTING_STARTED_CREATE_RECORD: "创建病历",
  GETTING_STARTED_TEAM_TITLE: "邀请团队成员",
  GETTING_STARTED_TEAM_SUB: "邀请同事协助管理预约和病历。",
  GETTING_STARTED_INVITE_TEAM: "邀请团队成员",
  GETTING_STARTED_PROFILE_TITLE: "完善诊所资料",
  GETTING_STARTED_PROFILE_SUB: "添加地址、服务项目等详细信息，方便患者找到您。",
  GETTING_STARTED_COMPLETE_PROFILE: "完善诊所资料",
  PACKAGE_IS_SOOON_TO_EXPIRED: "套餐即将到期",
  IF_NOT_RENEW_SERVICE_WILL_BE_STOPPED:
    "以下套餐即将过期，如果未及时续订，您当前享受的服务将会被暂停。",
  RENEW_UR_PACKAGE_BEFORE_LOSE_ACCESS_TO_UR_SERVICE:
    "为了避免影响您的日常使用与工作流程，请尽快完成续费，以确保所有服务持续可用。",
  RENEW_NOW: "立即续费",
  MY_PACKAGE: "我的订阅套餐",
  THIS_FEATURE_REQUIRED_A_PACKAGE_SUBSCRIPTION: "此功能需要订阅套餐",
  CURRENT_PACKAGE: "当前套餐",
  NO_ADDRESS: "无地址信息",
  CURRENT_CLINIC_NOT_FOUND: "未找到当前诊所",
  CURRENT_PACKAGE_OFFER: "当前套餐已包含",
  FOR_USERS_PACK_AVAILABLE: "份用户使用权",
  U_CAN_ENTER_MODIFY_UR_INSURANCE_NUMBER_HERE:
    "您可以在此填写或修改您的保险信息",
  INCLUDED_INSURANCES: "已添加的保险信息",
  NO_MODALITY_INSURANCE: "无保险信息",
  ADD_MODALITY_INSURANCE_NO: "添加保险信息",
  INSURANCE_PROVIDER: "保险公司",
  INSURANCE_NUMBER: "保险号",
  SWITCH_TO_ENABLED: "启用",
  SWITCH_TO_NOT_ENABLED: "切换为未启用",
  INSURANCE_NOT_ENABLED: "保险未启用",
  MODALITY_NOT_ENABLED: "当前服务类别未启用",
  X_INSURANCES_CHANGE_UNSAVED_ARE_YOU_SURE_TO_CLOSE: "您还有{{X}}个未保存的保险信息，是否确定关闭此弹窗？",
  CLINIC_MAXIMUM_BED_NUM: "诊所最大床位数量",
  CURRENT_MAXIMUM_BED_NUM_CONFIGURED_BY_CLINIC: "当前诊所配置的最大床位数量",
  CONFIGURE_BED_NUM: "修改诊所最大床位数",
  BED: "床位",
  PRACTITIONER_CAPACITY: "医师可同时服务的最大人数",
  PATIENT_AT_SAME_TIME: "名患者（同时）",
  THIS_VALUE_CANNOT_EXCEED_THE_CLINIC_MAXIMUM_CAPACITY: "该人数不能超过诊所最大床位数",
  U_CAN_CHANGE_THE_CLINIC_BED_NUM_HERE: "您可以在此处修改诊所床位数",
  NOT_WORKING_DAY_IN_THIS_CLINIC: "未设置工作日",
  REST_DAY: "休息",
  WORK_IN: "在",
  SELECT_ADDON: "选择附加服务",
  YOU_SUBSCRIBED_ALL_ADDONS_TO_THIS_PACKAGE: "您已订阅此套餐中的所有附加服务",
  EFFECTIVE_DATE: "生效时间",
  NOT_YET_EFFECTIVE: "未生效",
  CANCEL_SUBSCRIPTION: "取消订阅",
  CANCEL_SUBSCRIPTION_CONFIRM: "确认取消订阅？",
  CANCEL_SUBSCRIPTION_DESC: "取消后，此套餐将无法再续费。在订阅到期前您仍可正常使用，到期后套餐将彻底失效。",
  SUBSCRIPTION_CANCELLED: "订阅已取消",
  E_DAYS_LEFT: "天后",
  E_DAYS_AGO: "天前",
  FILTER_PRACTITIONER_BY: "筛选医师",
  ASSIGN_PRACTITIONER: "分配医师",
  CLINIC_PRACTITIONERS_NOT_VISIBLE_BELOW: "名未提供该服务的医师",
  BELOW_PRACTITIONERS_NOT_PROVIDING_SERVICE: "以下医师未提供该服务种类",
  ENABLE_SERVICE: "开启服务",
  ADDON: "附加服务",
  PACKAGE: "套餐服务",
};

const clinicHerbs = {
  HERB_MANAGEMENT: "诊所资源管理",
  MANAGE_YOUR_CLINIC_HERBS_FORMULA: "管理当前诊所可用的中药与药方信息",
  CURRENT_CLINIC: "当前诊所",
  CONFIGURE_CLINIC_HERBS: "管理诊所中药",
  CONFIGURE_CLINIC_FORMULA: "管理诊所药方",
  CLINIC_HERB: "诊所中药",
  CLINIC_FORMULA: "诊所药方",
  SEARCH_HERB_NAME: "搜索中药名称",
  SEARCH_FORMULA_NAME: "搜索药方名称",
  ADD_HERB: "添加中药",
  ADD_FORMULA: "添加药方",
  HERB_NAME: "中药名称",
  HERB_NAME_IN_X: "中药名称（{{X}}）",
  PINYIN: "拼音",
  IS_TOXIC: "是否具有毒性",
  IS_PREMIUM: "是否为高级药材",
  USED_BY_CREATER_ONLY: "仅创建者可用",
  TOXIC: "具有毒性",
  PREMIUM: "高级药材",
  YES: "是",
  NO: "否",
  HERB_NAME_CN: "中药名称（中文）",
  FORMULA_NAME_CN: "药方名称（中文）",
  HERB_NAME_EN: "中药名称（英文）",
  FORMULA_NAME_EN: "药方名称（英文）",
  HERB_NAME_X: "中药名称（{{X}}）",
  FORMULA_NAME_X: "药方名称（{{X}}）",
  HERB_INFO: "中药信息",
  FORMULA_INFO: "药方信息",
  THIS_FORMULA_CAN_ONLY_BE_USED_EDITED_BY_YOURSELF:
    "此药方仅限创建者本人（我）使用与编辑",
  SEARCH_HERB_NAME_HERE: "在此搜索中药名称",
  SEARCH_HERB_BY_HERB_NAME: "按中药名称搜索",
  HERB_IN_THIS_FORMULA: "药方中的中药",
  NO_HERB_ADDED: "尚未添加中药",
  FORMULA_NAME: "药方名称",
  FORMULA_NAME_IN_X: "药方名称 ({{X}})",
  NUM_HERBS: "已包含的中药数量",
  ADDED: "已添加",
  FORMULA_CREATED: "药方创建成功",
  FORMULA_UPDATED: "药方更新成功",
  POINT_GROUP_CREATED: "穴位分组创建成功",
  HERB_CREATED: "中药创建成功",
  HERB_UPDATED: "中药更新成功",
  UNDO: "撤销",
  REDO: "重做",
  PLZ_INPUT_FORMULA_NAME_CN: "请填入药方的中文名称",
  PLZ_INPUT_FORMULA_NAME_EN: "请填入药方的英文名称",
  PLZ_INPUT_FORMULA_NAME_X: "请填入药方的{{X}}名称",
  PLZ_INPUT_PINYIN: "请填入拼音",
  PLZ_INPUT_HERB_NAME_CN: "请填入中药的中文名称",
  PLZ_INPUT_HERB_NAME_EN: "请填入中药的英文名称",
  PLZ_INPUT_HERB_NAME_X: "请填入中药的{{X}}名称",
};
const packagePages = {
  INCLUDES: "包含",
  INCLUDES_ALL_LOWER_AND: "包含低级包所有内容和",
  PP_PER_YEAR: "每人/年",
  PP_PER_MONTH: "每人/月",
  PACKAGES: "订阅服务",
  EXPIRE_IN_X_DAYS: "到期时间：{{X}}天",
  FOR_NEXT_X_DAYS: "在接下来的{{X}}天",
  SELECT_CLINIC_FOR_APPLYING_PACKAGE: "请选择要申请套餐的诊所",
  NUMBER_OF_USER: "用户人数",
  SELECTED_PACKAGE: "已选套餐",
  CURRENT_USER: "现有用户",
  NEW_PACKAGE: "订阅新套餐",
  NO_CLINIC_MEMBERS: "诊所目前没有未分配套餐的成员",
  ASSIGN_PACKAGE_TO_USER: "分配给诊所成员",
  PER_EXIST_USER: "每位现有用户",
  PER_NEW_USER: "每位新用户",
  NO_PACKAGES_FOUND: "未找到可用的套餐",
  EXTEND: "添加人数",
  UPGRADE: "升级",
  RENEW: "继续订阅",
  PP: "每人",
  SELECT_A_PACKAGE: "选择一个套餐",
  CHANGE: "修改",
  REASSIGN: "重新分配",
  ASSIGN: "分配",
  PURCHASE_PACKAGES: "购买套餐",
  NO_PACKAGE: "无套餐",
  EXPIRE_DATE: "到期日期",
  MAX_USERS: "最大用户数",
  TIME: "时间",
  PRICE: "价格",
  PAYMENT_HISTORY: "支付历史",
  CHECK_YOUR_PAYMENT_HISTORY: "检查您的支付历史",
  THIS_PACKAGE_IS_ONLY_FOR_YOURSELF_NOT_FOR_YOUR_CLINIC_MEMBER:
    "此套餐为个人使用套餐，激活后将直接绑定至您的账户。",
  PURCHASE: "购买",
  RENEW: "续订",
  UPGRADE: "升级",
  SELECT_AVAILABLE_CLINIC_PACKAGE_FOR_YOUR_CLINIC: "为您诊所挑选所需的套餐",
  EXTEND_SELECTED_PACKAGE: "为已选的套餐添加人数",
  UPGRADE_SELECTED_PACKAGE: "升级已选的套餐",
  APPLY_THE_PACKAGE_TO_YOUR_CLINIC: "将套餐配置 / 应用至您的诊所",
  MAKE_PAYMENT: "付款",
  MY_CLINICS: "我的诊所",
  NOTE: "提示",
  ANY_CLINICS_MANAGED_BY_U_WILL_BE_AVAILABLE_BELOW:
    "您管理的所有诊所将在下方显示",
  CURRENT_PURCHASED_USERS: "当前已购买的用户人数",
  USERS: "位用户",
  FOR_USERS_PACK: "份",
  EXTEND_TO: "扩展至",
  EXTEND_USERS_NUMBER_CANNOT_BE_EQUAL_OR_LESS_THAN_CURRENT_USER_NUMBER:
    "扩展的用户数量不能小于或等于当前用户数量",
  PLZ_CHECK_THE_NUMBER_OF_USERS: "请检查用户数量",
  SYSTEM_WILL_DIRECT_U_BACK_PLS_WAIT: "系统正在跳转，请稍候...",
  PURCHASE_FOR: "购买",
  IF_U_GOT_PROMOTION_CODE: "如果您有促销码",
  CLICK_HERE: "点击这里",
  IF_U_GOT_PROMOTION_CODE_INPUT_IT_HERE: "如果您有促销码，请在此输入",
  CURRENT_USERS_ASSIGNED_TO_THIS_PACKAGE: "已分配给此套餐的用户",
  PURCHASED_FOR: "已购买",
  RENEW_SELECTED_PACKAGE: "续订您已选的套餐",
  EXTEND_PACKAGE_FOR_YOUR_CLINIC: "扩展您的诊所套餐",
  UPGRADE_PACKAGE_FOR_YOUR_CLINIC: "升级您的诊所套餐",
  RENEW_PACKAGE_FOR_YOUR_CLINIC: "续订您的诊所套餐",
  EXTENDED_USER_PACK: "份 (扩展后)",
  CURRENT_USER_PACK: "份 (当前)",
  PAYMENT_UNAVAILABLE: "当前支付不可用",
  PLS_OPEN_PAGE_OVER_HTTPS: "请在HTTPS下打开此页面以安全支付。",
  CREATE_UR_CLINIC_NOW: "创建您的诊所",
  NO_PACKAGE_SUBSCRIBED: "当前未订阅任何套餐",
  BELONGS_TO: "来自于",
  TO_ACCESS_FULL_HEALTHNEX_SERVICES_PLEASE_SELECT_A_PACKAGE_FOR_UR_CLINIC:
    "请选择诊所的功能套餐，解锁完整的 Healthnex 服务。",
  RENEW_UR_CLINIC_PACKAGE: "续订您的诊所套餐",
  PACKAGE_ASSIGNED_BY_CLINIC_OWNER:
    "诊所负责人 (Business Owner) 分配给您的套餐",
  RENEW_UR_PERSONAL_PACKAGE: "续订您的个人套餐",
  FOR_PERSONAL: "个人套餐",
  FOR_CLINIC: "诊所套餐",
  PURCHASE_FOR_MYSELF: "为自己购买",
  PURCHASE_FOR_CLINIC: "为诊所购买",
  HEALTHNEX_IS_GOING_TO_CREATE_U_OWNED_CLINIC_PLS_PROVIDE_THE_ADDRESS:
    "Healthnex 即将为您创建诊所，请提供诊所地址以继续。",
  CLINIC_ADDRESS: "诊所地址",
  SORRY: "抱歉",
  FIND_UR_SUITABLE_PACKAGES: "找到您适合的套餐",
  ARE_U_LOOKING_TO_BUY_A_PERSONAL_PACKAGE_CLINIC_PACKAGE:
    "您正在考虑的购买的是个人套餐还是诊所套餐？",
  I_WANNA_BUY: "我想购买",
  PERSONAL_WEBSITE_FOR_MYSELF: "创建个人网站",
  CLINIC_PACKAGE_FOR_MY_CLINIC: "为自己的诊所添加服务",
  HOW_MANY_USERS_PACK_U_WISH_TO_INCLUDE_IN_YOUR_PACKAGE:
    "请问您希望在您的套餐中包含多少用户？",
  CLINIC_MEMBERS_WHO_CAN_ACCESS_APPOINTMENT_AND_PRESCRIPTION_USING_AI_AND_ALSO_INCLUDES_PERSONAL_WEBSITE:
    "诊所成员可使用 AI 辅助处方功能及患者病历管理系统，并包含个人专属网站模块。",
  CLINIC_MEMBERS_WHO_CAN_ACCESS_APPOINTMENT_AND_PRESCRIPTION_USING_AI_AND_ALSO_WITHOUT_INCLUDES_PERSONAL_WEBSITE:
    "诊所成员可使用 AI 辅助处方以及患者病历系统，不包含个人网站模块。",
  WITHOUT_PERSONAL_WEBSITE: "不包含个人网站",
  INCLUDES_PERSONAL_WEBSITE: "包含个人网站",
  ALL_CLINIC_PACKAGES: "所有诊所套餐",
  WHAT_FEATURES_U_WISH_TO_INCLUDE: "您希望在您的诊所套餐中包含哪些功能？",
  INCLUDES_X_USERS: "包含 {{X}} 位用户",
  CUSTOM_USER_PACKS: "自定义用户人数",
  THIS_PACKAGE_REQUIRES_TO_PURCHASE_AT_LEAST_X_USER_PACKS:
    "此套餐需要购买至少 {{X}} 份用户套餐",
  SHORT_APPOINTMENT: "预约",
  SHORT_PRESCRIPTION: "处方",
  SHORT_PACKAGE: "套餐",
  WEB: "网站",
  X_YEARS: "{{X}}年",
  ADDONS_SERVICE_INCLUDED: "可选择的附加服务",
  ADDON_SERVICE_SELECTED: "已选择的附加服务",
  PER_MESSAGE: "每条消息",
  ADD_ON_BILL_BASED_ON_UR_USAGE_CHARGE_WILL_BE_APPLIED_EVERY_X: "该附加服务按使用量计费。在每个计费周期（{{X}}）内您可正常使用，费用将在下一个周期开始时，根据上一个周期的实际使用量进行结算",
  CONTINUE_USE_BILL_CHARGED_EVERY_X: "系统将在每个周期（{{X}}）开始时，根据您上一个周期的使用情况进行收费",
  WEEKLY: "每周",
  FORTNIGHTLY: "每周",
  MONTHLY: "每月",
  QUARTERLY: "每季度",
  BI_ANNUALLY: "每半年",
  ANNUALLY: "每年",
  ADDON_DETAIL: "附加服务详情",
  NEXT_BILLING_DATE: "下次计费时间",
  BILLING_CYCLE: "计费周期",
  ADDON_PRICE: "附加服务价格",
  X_ADDONS_SERVICE_INCLUDED: "{{X}}个可选择的附加服务",
  SELECT_BILLING_METHOD: "选择收费方式",
  BILLING_METHOD: "收费方式",
  TEMPORARILY_FREE: "当前免费",
  FIRST_YEAR_FREE: "第一年免费",
  ON_PROMOTION: "优惠中",
  PROMOTION_END_DATE: "优惠结束日期",
  REGULAR_PRICE_RESUMES_ON_X: "{{X}} 后恢复原价",
  SET_AS_DEFAULT: "设为默认",
  RECENTLY_USED: "最近使用",
  USE_DIFFERENT_CARD: "选择其他银行卡",
  PAY_WITH_SAVED_CARD: "使用已保存的银行卡",
  CARD_HOLDER_NAME: "持卡人姓名",
  ENABLE_AUTO_RECHARGE: "开启自动续订",
  CANCEL_AUTO_RECHARGE: "取消自动续订",
  AUTO_RECHARGE_WHEN_SUBCRPTION_EXPIRED: "当订阅到期时，系统将自动使用此卡进行续订",
  SAVE_BELOW_CARD_DETAILS: "保存此卡信息",
  STORE_CREDIT_CARD_SECURELY: "您的银行卡信息将被安全保存，方便下次快速支付",
  ADDON_REQUIRES_SAVED_CARD: "您已选择附加服务，需要按周期自动续费。请保存银行卡信息以便每个计费周期自动扣款。",
  DETECT_U_HAVE_A_SAVED_CARD_THIS_CARD_DETAIL_WILL_BE_SAVE_AND_REPLACE_THAT_CARD_DETAIL: "检测到您已有已保存的银行卡，付款完成后将自动保存替换为当前银行卡",
  ARE_YOU_SURE_TO_CANCEL_AUTO_RECHARGE: "您确定要取消自动续订吗？",
  U_CAN_ENABLE_AUTO_RECHARGE_LATER: "您依然可以稍后开启自动续订",
  AUTO_RECHARGE_HAS_BEEN_ENABLED: "自动续订已开启",
  AUTO_RECHARGE_HAS_BEEN_CANCELLED: "自动续订已取消",
  AUTO_RECHARGE: "自动续订",
  HAS_ENABLED: "已开启",
  NOT_ENABLED: "未开启",
};

const cmasaImport = {
  IMPORT_CLINICS: "导入诊所",
  CLINICS_FOUND_IN_X: "在 {{X}} 中找到的诊所",
  NO_CLINIC_FOUND: "未找到诊所",
  CLINICS_IMPORTED_FROM_X: "从 {{X}} 导入的诊所",
  NO_CLINIC_IMPORTED: "未导入任何诊所",
  DELETE: "删除",
  CONFIRM: "确认",
  ARE_YOU_SURE_TO_DELETE_X: "你确定要删除 {{X}} 吗？",
  THIS_ACTION_CANNOT_BE_UNDONE: "此操作无法撤销",
  IMPORT_CLINIC: "导入诊所",
  UPDATE_CLINIC: "更新诊所",
  UPLOAD_AVATAR: "上传头像",
  REUPLOAD_PROFILE_IMAGE: "重新上传头像",
  CLICK_TO_UPLOAD: "点击上传",
  PLEASE_FILL_ALL_REQUIRED_FIELDS: "请填写所有必填字段",
  PLEASE_ENTER_VALID_EMAIL: "请输入有效的邮箱地址",
  PLEASE_ENTER_SAME_PASSWORD: "请再次输入相同的密码",
  SIGN_UP_SUCCESS: "注册成功",
  CLINIC_EXISTS: "该诊所已存在",
  NEXT_STEP: "下一步",
  SAME_WITH_ORG_PASSWORD: "与原密码相同",
  PROFILE_IMG: "个人头像",
  I_CHANGED_MY_MIND: "我改变主意了",
  ADDING: "待创建",
  JOINING: "待加入",
  OR: "或",
  SKIP: "跳过",
  JOIN: "加入",
  SAVE_CONFIRM: "保存确认",
  ARE_YOU_SURE_TO_SUBMIT_YOUR_CLINIC_INFO:
    "您确定提交您已填写的诊所信息并同意创建诊所吗？",
  FOUND_RELEVANT_CLINICS:
    "我们在 Healthnex 系统中找到了一些可能与该诊所相关的诊所。",
  JOIN_OR_SKIP_CLINIC_GUIDE:
    "您可以点击“加入”申请加入其中一个诊所。如果不确定或没有看到想加入的诊所，您可以点击“跳过”稍后处理。",
  NEED_TO_ADD_CLINIC: "您需要在我们的 Healthnex 系统中添加这个诊所吗？",
  ADD_CLINIC_DESCRIPTION:
    "点击“添加”继续操作。您将成为该诊所的负责人 (Business Owner)，拥有邀请或移除成员的权限。您也可以在之后将所有权转移给诊所内的其他成员。如果您不确定是否需要现在添加，可以点击“跳过”稍后处理。",
  CLINIC_RESULT_TITLE: "该诊所的处理结果",
  CLINIC_SKIPPED_MSG:
    "该诊所已被跳过。你不会加入已有诊所，也不会将其作为新诊所添加。",
  CLINIC_NOT_LISTED: "上面列表中没有我想加入的诊所。",
  I_DO_NOT_WANT_TO_USE_THE_CLINIC_INFO_ABOVE: "我不想使用上面的诊所信息",
  PREVIOUS_CLINIC: "上一个诊所",
  NEXT_CLINIC: "下一个诊所",
  ARE_YOU_SURE_TO_CHANGE_YOUR_MIND:
    "你确定要改主意吗？这会清空过程中对这个诊所的设定",
};

const camera = {
  FOR_PATIENT: "为{{name}}患者",
  UPLOAD_PHOTO_LABEL: "上传",
  TAKE_PHOTO: "拍照",
  OR_CHOOSE_FROM_ALBUM: "或从相册选择",
  CHOOSE_PHOTO: "选择图片",
  PREVIEW: "预览",
  DISCONNECTED_TITLE: "连接已断开 / 链接已失效",
  DISCONNECTED_BODY: "此拍照链接已失效、或被关闭。请重新生成新的二维码/链接。",
  CLICK_AND_UPLOAD_WITH_YOUR_PHONE: "点击并使用手机上传照片",
  CLICK_AND_RECORD_WITH_YOUR_PHONE: "点击并连接到手机录制音频",
  CLICK_AND_USE_YOUR_PHONE: "点击并使用手机录制音频",
  // SCAN_TO_CONNECT: "扫码以连接/重连",
  SCAN_TO_CONNECT: "",
  CAMERA_TOKEN_EXPIRED: "摄像头令牌已过期",
  IF_YOU_ALREADY_CONNECTED_WITH_YOUR_PHONE:
    "扫码连接手机，连接后在不同页面都会保持连接。",
};
const Library = {
  MEDICAL_PUBLICATIONS: "医学书籍",
  SEARCH_MEDICAL_PUBLICATIONS: "搜索医学书籍",
  SEARCH_PUBLICATION_BY_NAME: "按名称搜索书籍",
  RECENT: "最近阅读",
  LIBRARY: "图书馆",
  NO_PUBLICATIONS_FOUND: "未找到书籍",
  NO_RECENT_PUBLICATIONS: "未找到最近的书籍",
  NO_PUBLICATIONS_IN_LIBRARY: "未找到图书馆中的书籍",
  SEARCH_FOR_THE_MEDICAL_PUBLICATIONS_IN_SEARCH_BAR_OR_VISIT_OUR_LIBRARY:
    "在搜索栏中搜索医学书籍或访问我们的图书馆",
  JUST_NOW: "刚刚",
  RECENT_X_MINUTES: "最近{{x}}分钟",
  RECENT_X_HOURS: "最近{{x}}小时",
  RECENT_X_DAYS: "最近{{x}}天",
  ADD_THIS_BOOK_TO_YOUR_FAVORITES: "将此书添加到您的收藏夹",
  CHAPTERS: "章节",
  BOOKMARK: "书签",
  ADD_BOOKMARK: "添加书签",
  FULL_SCREEN: "全屏",
  TEXT_SIZE: "文本大小",
  NEXT_PAGE: "下一页",
  PREVIOUS_PAGE: "上一页",
  FONT_SIZE: "字体大小",
  SMALL: "小",
  MEDIUM: "中",
  LARGE: "大",
  BOOKS_MANAGEMENT: "书籍管理",
  SAVE_BOOK: "我的收藏",
  READER: "阅读器",
  REGULAR: "默认",
  SEARCH_FOR_PUBLICATIONS: "按标题或作者搜索",
};

const bookingPage = {
  BOOK_DOCTOR: "预约医生",
  BOOKING_A_DOCTOR: "预约医生",
  SEARCH_BY_PRACTITIONER_NAME_SERVICE_TYPE_OR_SUBURB:
    "按医师姓名、治疗类型或诊所区域邮编快速查找。",
  BY: "按",
  SERVICE_TYPE: "服务类型",
  PLEASE_SELECT_SERVICE_TYPE: "请至少选择一种服务类型",
  SEARCH_BY_PRACTITIONER_NAME: "按医师姓名搜索",
  SEARCHING_PRACTITIONERS: "正在搜索医师",
  NO_SERVICE_LISTED: "暂无可用服务",
  BOOK: "预约",
  WEBSITE: "网站",
  PUBLISH_WEBSITE: "发布网站",
  JOIN: "加入",
  AND_X_PRACTITIONERS_MORE: "以及其他{{X}}位医师…",
  MEDICINE_TREATMENT: "中医药方治疗",
  ACUPUNCTURE_TREATMENT: "针灸治疗",
  MASSAGE_TREATMENT: "推拿治疗",
  REMEDIAL_MASSAGE_TREATMENT: "康复推拿治疗",
  NO_RELEVANT_PRACTITIONERS_FOUND: "未找到相关医师",
  NO_SERVICES_LISTED: "暂无可用服务",
  BOOK_THIS_PRACTITIONER: "预约这位医师",
  THIS_PRACTITIONER_HAS_NOT_REGISTERED_YET: "这位医师还尚未注册",
  PUBLISH_PRACTITIONER_PROFILE_WEBSITE: "发布医师个人网站",
  VIEW_PRACTITIONER_PROFILE_WEBSITE: "查看医师个人网站",
  NO_WORKING_CLINIC: "无工作诊所",
  AND_X_MORE_CLINIC: "以及其他{{X}}个诊所",
  CHOOSE_CLINIC: "选择诊所",
  CHOOSE_CLINIC_DESCRIPTION: "选择您要预约的诊所",
  CHOOSE_SERVICE: "选择服务",
  CHOOSE_SERVICE_DESCRIPTION: "选择您要预约的医疗服务",
  PICK_APPOINTMENT_DATE: "选择预约日期",
  PICK_APPOINTMENT_DATE_DESCRIPTION: "选择您要预约的日期",
  MORNING: "早上",
  AFTERNOON: "下午",
  PATIENT_INFO_DESCRIPTION: "请填写患者信息",
  CONFIRM_DESCRIPTION: "请确认预约信息",
  SUBMIT_APPOINTMENT: "提交预约",
  PREV: "上一步",
  YOUR_APPOINTMENT_BOOKED_SUCCESSFULLY: "您已成功预约",
  CREATE_BOOKING: "正在预约中",
  TOMORROW: "明天",
  TODAY: "今天",
  IS_ALREADY_BOOKED: "已被他人预约",
  TIME_ALREADY_BOOKED: "该时间已被他人预约",
  YOU_NEED_TO_WAIT_FOR_THE_PRACTITIONER_TO_CONFIRM:
    "该预约将触发超额预约，但由于由您（医师）创建，系统会自动批准。",
  BACK_TO_HOME: "关闭页面",
  INVITATION_LINK_EXPIRED: "当前邀请链接已过期",
  INVITATION_LINK_EXPIRED_DESC: "当前邀请链接已失效，请联系诊所重新发送邀请。",
  EXISTING_PATIENT: "现有患者",
  START_WITH_NEW_PATIENT: "为新患者预约",
  BACK_TO_EXISTING_PATIENT: "返回现有患者预约",
  NEW_PATIENT: "新患者",
  ARE_U_LOOKING_FOR: "👀 您是否在查找",
  SELECTED_PATIENT: "已选择的患者",
  ALL_GOOD: "一切就绪",
  PLS_REFER_TO_THE_APPOINTMENT_DETAIL_BELOW: "以下是您的预约详情，请查阅",
  VIEW_DETAIL: "查看详情",
  SELECTED_FROM_OUTSIDE_TIMESLOT: "选自时间表",
  BOOK_TIMESLOT: "预约此时间段",
  INVALID_DOB: "无效的出生日期",
  AGREED_TO_SEND_APPOINTMENT_SMS_TO_PATIENT:
    "我同意此预约信息会以短信或者邮件方式通知患者",
  CONFIGURE_UR_PROVIDED_SERVICES: "设置您所提供的医疗服务种类",
  NOT_AVAILABLE_FOR_BOOKING: "暂时不可预约",
  BOOKED_ENABLED_ONLY: "仅显示可预约",
  PLEASE_SELECT_EXISTING_PATIENT: "请选择一名患者来完成预约",
  THIS_FEATURE_REQUIRED_PRESCRIPTION_PACKAGE:
    "抱歉，您的当前功能包未包含患者记录功能。",
  PLEASE_CONSIDER_UPGRADE_YOUR_PACKAGE_OR_CONTINUE_WITH_NEW_PATIENT:
    "您可以联系诊所负责人申请升级功能包，或者继续为新患者创建预约。",
  U_SELECTED_A_PAST_TIMESLOT: "您选择了一个过去的时间段",
  U_SELECTED_A_PAST_TIMESLOT_NO_SMS_WILL_BE_SENT:
    "您选择了一个过去的时间段，短信通知将不会发送至患者。",
  ANY_RECOMMENDED_PATIENTS_FROM_EXISTING_WILL_BE_SHOWN_HERE:
    "系统将基于您已保存的患者信息进行推荐，并在此处显示结果。",
  PICK_APPOINTMENT_PRACTITIONER: "为",
  PICK_APPOINTMENT_PRACTITIONER_END: "选择预约医师",
  PICK_APPOINTMENT_PRACTITIONER_SINGLE_PATIENT: "选择预约医师",
  RESELECT_APPOINTMENT_DATE: "重新选择预约日期",
  RESELECT_PRACTITIONER: "重新选择医师",
  AVAILABLE_PRACTITIONERS: "可预约医师",
  DESELECT_CHINESE_MEDICINE_FIRST: "请先取消选择中医服务。",
  DESELECT_PRODUCTS_FIRST: "请先取消已选服务产品。",
  NUMBER_OF_PEOPLE: "人数",
  PERSON: "人",
  PEOPLE: "人",
  ENTER_PATIENT_INFORMATION: "填写患者信息",
  IS_THIS_PERSON_NEW_PATIENT: "第一次来这家诊所吗？",
  EXISTING_PATIENT: "现有患者",
  A_REMINDER_SMS_WILL_BE_SENT_TO_THE_U_WHEN_NEAR_THE_APPOINTMENT_DATE:
    "注：当预约时间临近时，系统将向您发送提醒短信。",
  NO_AVAILABLE_PRACTITIONERS: "当天未找到可预约医师",
  ORR: "或者",
  CONFIRM_APPOINTMENT_DESCRIPTION: "请在确认预约前检查预约详情。",
  PICK_APPOINTMENT_TIME: "选择预约时间",
  PRODUCTS: "服务产品",
  I_AM_A_NEW_PATIENT: "我是新患者",
  SEARCH_EXISTING_PATIENT: "搜索现有患者",
  DESELECT_ALL: "清除选择",
  SERVICES_ITEM: "服务项目",
  X_BED_NUM: "{{X}}张床位",
  NEW_TO_THIS_CLINIC: "这是我第一次到访这家诊所",
  A_REMINDER_EMAIL_WILL_BE_SENT_TO_THE_PATIENT: "预约提醒邮件将发送至患者的邮箱，请查收。",
};

const guide = {
  WE_FIRST_GO_TO_CLINIC_MANAGEMENT_PAGE: "我们首先进入诊所人员管理页面",
  CLICK_ON_THIS: "点击此按钮",
  CREATE_A_NEW_CLINIC_BY_COMPLETE_THE_ESSENTIAL_INFORMATION:
    "填写您的诊所基本信息",
  SUBMIT_YOUR_CLINIC_INFORMATION: "提交诊所信息后诊所将创建成功",
  IF_U_RECEIVE_CLINIC_INVITATION: "如果您收到任何诊所的邀请",
  ANY_INVITATION_WILL_BE_SHOWN_HERE_U_CAN_ACCEPT_OR_REJECT_THE_INVITATION:
    "任何诊所邀请都将显示在此处，您可以根据需要接受或拒绝邀请",
  IF_U_WISH_TO_JOIN_A_CLINIC: "如果您想加入某家诊所",
  SEARCH_THE_CLINIC_NAME_U_WISH_TO_JOIN: "通过搜索诊所名称来查找您想加入的诊所",
  DONE: "完成",
  START_GUIDE: "开始引导",
  USER_GUIDE: "使用教程视频",
  GUIDE: "指南",
  NEED_HELP: "需要帮助？",
  CONTACT_SUPPORT: "联系客服",
  VIEW_USER_GUIDE: "查看教程",
  CLINIC_MANAGEMENT_GUIDE: "诊所管理指南",
  CLINIC_MANAGEMENT_DESCRIPTION: "此系统指南将引导您如何创建和加入诊所",
  PRESCRIPTION_MEDICAL_HISTORY_GUIDE: "处方与病历指南",
  PRESCRIPTION_MEDICAL_HISTORY_GUIDE_DESCRIPTION:
    "此系统指南将引导您如何创建患者和处方",
  APPOINTMENT_GUIDE: "预约指南",
  MANAGE_UR_APPOINTMENTS_GUIDE_DESCRIPTION:
    "此系统指南将引导您如何设置工作时间并创建预约",
  MORE_GUIDES_ON_THE_WAY: "更多系统指南即将到来",
};

const patientConsent = {
  PATIENT_CONSENT: "患者同意書",
  CONSENT_TITLE_1: "治療內容",
  CONSENT_DESCRIPTION_1: "本人明白，在{{X}}接受治療可能包括：",
  CONSENT_ITEM_1: "使用無菌一次性針具之針灸治療",
  CONSENT_ITEM_2: "艾灸、拔罐或刮痧",
  CONSENT_ITEM_3: "中藥治療（湯劑、散劑、丸劑或顆粒劑）",
  CONSENT_ITEM_4: "根據中醫理論提供的生活方式與飲食建議",
  CONSENT_TITLE_2: "風險與副作用",
  CONSENT_DESCRIPTION_2:
    "本人明白，儘管診所會採取一切合理的防護措施，仍可能出現以下輕微副作用：",
  CONSENT_ITEM_5: "針刺部位輕微瘀青、出血或酸痛",
  CONSENT_ITEM_6: "針灸後短暫頭暈或疲倦",
  CONSENT_ITEM_7: "服用中藥後出現輕微腸胃變化或過敏反應",
  CONSENT_ITEM_8: "拔罐或刮痧後皮膚短暫出現紅痕或瘀印",
  CONSENT_ITEM_9: "嚴重不良反應極為罕見。",
  CONSENT_TITLE_3: "信息安全",
  CONSENT_DESCRIPTION_3: "本人已告知主治醫師：",
  CONSENT_ITEM_10: "現有之疾病或過敏史",
  CONSENT_ITEM_11: "懷孕情況（如適用）",
  CONSENT_ITEM_12: "目前正在服用的藥物或營養補充品",
  CONSENT_DESCRIPTION_4: "本人明白中醫治療並非急症醫療之替代方式。",
  CONSENT_DESCRIPTION_5: "本人之個人及健康資料將依據澳洲隱私法保密處理。",
  CONSENT_TITLE_4: "同意與確認",
  CONSENT_ITEM_13:
    "本人已閱讀並明白上述內容，並已有機會提出問題，所有疑問均已獲得滿意答覆。",
  CONSENT_ITEM_14: "本人自願同意接受{{X}}的醫師提供之中醫及／或針灸治療。",

  DRAW_YOUR_SIGNATURE: "签署你的签名",
  SIGNATURE_UPLOADED: "签名已上传",
  CONSENT_SIGN_SUCCESS: "您已经成功签署治疗同意书，请继续您的看诊流程",
};

const agreements = {
  PRIVACY_POLICY_TITLE: "HEALTHNEX 隐私政策",
  PRIVACY_POLICY_EFFECTIVE_DATE:
    "生效日期：本政策自用户首次注册并使用 Healthnex 平台之日起生效。",
  PRIVACY_POLICY_SECTION_OVERVIEW_TITLE: "1. 概述",
  PRIVACY_POLICY_SECTION_OVERVIEW_CONTENT:
    "Healthnex 重视并致力于保护用户及其患者的隐私。本隐私政策说明我们如何根据《澳大利亚隐私法 1988（Privacy Act 1988, Cth）》及澳大利亚隐私原则（APPs）收集、使用、存储及披露个人信息与健康信息。",
  PRIVACY_POLICY_SECTION_COLLECT_TITLE: "2. 我们收集的信息",
  PRIVACY_POLICY_COLLECT_USER_INFO:
    "用户信息：姓名、联系方式、执业信息、诊所信息、账户登录信息；",
  PRIVACY_POLICY_COLLECT_PATIENT_INFO:
    "患者信息：病历记录、预约信息、处方信息及其他健康信息；",
  PRIVACY_POLICY_COLLECT_TECH_INFO: "技术信息：IP 地址、设备信息、日志记录。",
  PRIVACY_POLICY_SECTION_USAGE_TITLE: "3. 信息的使用目的",
  PRIVACY_POLICY_USAGE_PLATFORM: "提供和维护 Healthnex 平台功能；",
  PRIVACY_POLICY_USAGE_ACCOUNT: "管理账户与诊所运营；",
  PRIVACY_POLICY_USAGE_SECURITY: "技术支持、系统安全与合规；",
  PRIVACY_POLICY_USAGE_LEGAL: "法律法规要求的其他用途。",
  PRIVACY_POLICY_SECTION_HEALTH_INFO_TITLE: "4. 健康信息",
  PRIVACY_POLICY_HEALTH_INFO_DESCRIPTION:
    "健康信息属于敏感信息。Healthnex 仅作为数据处理方，根据用户（数据控制方）的指示处理患者健康信息。",
  PRIVACY_POLICY_SECTION_DISCLOSURE_TITLE: "5. 信息披露",
  PRIVACY_POLICY_DISCLOSURE_DESCRIPTION:
    "除非法律要求或经用户授权，我们不会向第三方披露个人或健康信息。部分技术服务（如云服务、邮件服务）可能涉及受控的第三方处理。",
  PRIVACY_POLICY_SECTION_SECURITY_TITLE: "6. 数据安全",
  PRIVACY_POLICY_SECURITY_DESCRIPTION:
    "我们采取合理的技术与组织措施保护信息安全，包括访问控制、加密及审计机制。",
  PRIVACY_POLICY_SECTION_RETENTION_TITLE: "7. 数据保留",
  PRIVACY_POLICY_RETENTION_DESCRIPTION:
    "信息将根据法律要求及业务需要进行保留或删除。",
  PRIVACY_POLICY_SECTION_RIGHTS_TITLE: "8. 用户权利",
  PRIVACY_POLICY_RIGHTS_DESCRIPTION:
    "用户有权请求访问、更正或删除其个人信息（受法律限制）。",
  PRIVACY_POLICY_SECTION_BREACH_TITLE: "9. 数据泄露",
  PRIVACY_POLICY_BREACH_DESCRIPTION:
    "如发生可通报的数据泄露事件，我们将依照澳大利亚可通报数据泄露制度（NDB Scheme）履行义务。",
  PRIVACY_POLICY_SECTION_CONTACT_TITLE: "10. 联系我们",
  PRIVACY_POLICY_CONTACT_DESCRIPTION:
    "如有隐私相关问题，请联系 Healthnex 官方支持渠道。",
  IF_ANY_SENSITIVE_RELATED_QUESTION_PLS_CONTACT_HEALTHNEX:
    "如有隐私相关问题，请联系 Healthnex 官方支持渠道。",

  DATA_PROCESSING_ADDENDUM: "数据处理附录",
  DPA_TITLE: "HEALTHNEX 数据处理附录",
  DPA_SUB_TITLE: "(Data Processing Addendum, DPA)",
  DPA_INTRO: "本数据处理附录构成 Healthnex 平台使用协议的一部分。",
  DPA_SECTION_ROLES_TITLE: "1. 角色定义",
  DPA_ROLE_USER: "用户：数据控制方（Data Controller）",
  DPA_ROLE_HEALTHNEX: "Healthnex：数据处理方（Data Processor）",
  DPA_SECTION_SCOPE_TITLE: "2. 处理范围",
  DPA_SCOPE_DESCRIPTION:
    "Healthnex 仅在提供平台服务所必需的范围内，根据用户指示处理个人信息及健康信息。",
  DPA_SECTION_DATA_TYPE_TITLE: "3. 数据类型",
  DPA_DATA_TYPE_DESCRIPTION: "包括但不限于：",
  DPA_DATA_TYPE_PATIENT_INFO: "患者健康信息；",
  DPA_DATA_TYPE_APPOINTMENT_RECORD: "预约与病历数据；",
  DPA_DATA_TYPE_USER_ACCOUNT: "用户账户数据。",
  DPA_SECTION_SECURITY_TITLE: "4. 数据安全",
  DPA_SECURITY_DESCRIPTION:
    "Healthnex 将采取合理的技术与组织安全措施，防止数据的未经授权访问、披露或丢失。",
  DPA_SECTION_SUBPROCESSORS_TITLE: "5. 分包处理",
  DPA_SUBPROCESSORS_DESCRIPTION:
    "Healthnex 可能使用受信任的第三方服务提供商（如云基础设施、AI 服务）。所有分包方须受保密与数据保护义务约束。",
  DPA_SECTION_BREACH_RESPONSE_TITLE: "6. 数据泄露响应",
  DPA_BREACH_RESPONSE_DESCRIPTION:
    "如发生数据泄露，Healthnex 将在合理时间内通知用户，并配合履行法定义务。",
  DPA_SECTION_POST_TERMINATION_TITLE: "7. 协议终止后的数据处理",
  DPA_POST_TERMINATION_DESCRIPTION:
    "在协议终止后，Healthnex 将根据用户指示及法律要求删除或匿名化相关数据，除非法律另有规定。",
  DPA_SECTION_PRECEDENCE_TITLE: "8. 优先适用",
  DPA_PRECEDENCE_DESCRIPTION:
    "如本附录与主协议存在冲突，就数据保护事项以本附录为准。",
};

const freeTrialTerms = {
  FREE_TRIAL_TERMS_PAGE_TITLE: "条款",
  FREE_TRIAL_TERMS_TITLE:
    "HEALTHNEX 平台免费试用三（3）个月使用条款（包含隐私与数据处理条款）",
  FREE_TRIAL_TERMS_SUBTITLE:
    "本条款适用于您在三个月免费试用期间对 Healthnex 平台的访问与使用。",
  FREE_TRIAL_TERMS_EFFECTIVE_DATE:
    "生效日期： 用户首次注册并访问 Healthnex 平台之日",
  FREE_TRIAL_TERMS_PARTIES:
    "当您访问或使用 Healthnex 平台（“平台”）时，即表示您同意遵守本条款。Healthnex（以下简称“Healthnex”、“我们”或“本平台”）；以及任何注册或使用 Healthnex 平台的个人或实体，包括但不限于诊所负责人、诊所运营者、执业医师，或同时具备多重身份的个人（以下简称“用户”、“您”）。",

  FREE_TRIAL_TERMS_PURPOSE_TITLE: "1.	协议目的",
  FREE_TRIAL_TERMS_PURPOSE_DESC:
    "本协议用于约定 Healthnex 向用户提供 为期三（3）个月的免费试用服务 的使用条款，并明确试用期结束后的后续安排。",

  FREE_TRIAL_TERMS_USER_DEF_TITLE: "2.	用户身份说明",
  FREE_TRIAL_TERMS_USER_DEF_DESC:
    "1.	用户可基于以下一种或多种身份使用 Healthnex 平台，包括但不限于：",
  FREE_TRIAL_TERMS_USER_DEF_ITEM_1: "• 1)诊所负责人或运营者",
  FREE_TRIAL_TERMS_USER_DEF_ITEM_2: "• 2)诊所管理人员",
  FREE_TRIAL_TERMS_USER_DEF_ITEM_3: "• 3) 执业医师或医疗专业人员",
  FREE_TRIAL_TERMS_USER_DEF_MULTI_CAPACITY:
    "2.	如用户同时具备多重身份，本协议项下的所有义务与责任 将累计适用。",
  FREE_TRIAL_TERMS_USER_ACCOUNT_RESP:
    "3.	用户应对其账户下发生的所有活动负责，包括由其关联的医师或工作人员所进行的操作。",

  FREE_TRIAL_TERMS_ACCESS_TITLE: "3.	免费试用资格",
  FREE_TRIAL_TERMS_ACCESS_P1:
    "1.	Healthnex 在试用期内向用户授予一项 有限的、非独占的、不可转让、可随时撤销的许可，用于访问和使用 Healthnex 平台。",
  FREE_TRIAL_TERMS_ACCESS_P2: "2.	免费试用期限为自生效日起 连续三（3）个月。",
  FREE_TRIAL_TERMS_ACCESS_P3: "3.	免费试用 不收取任何费用，且 不会自动续期。",

  FREE_TRIAL_TERMS_FEATURES_TITLE: "4.	试用期间的平台功能",
  FREE_TRIAL_TERMS_FEATURES_INTRO:
    "在试用期间，用户可使用包括但不限于以下功能：",
  FREE_TRIAL_TERMS_FEATURES_ITEM_1: "• 1)	创建和定制个人或诊所网站页面；",
  FREE_TRIAL_TERMS_FEATURES_ITEM_2: "• 2)	预约与日程管理功能；",
  FREE_TRIAL_TERMS_FEATURES_ITEM_3:
    "• 3)	病人信息与病历管理，包括处方相关功能；",
  FREE_TRIAL_TERMS_FEATURES_ITEM_4:
    "• 4)	使用 AI 辅助功能进行行政和工作流程支持（非诊断用途）；",
  FREE_TRIAL_TERMS_FEATURES_ITEM_5: "• 5)	在诊所环境中与其他执业人员协作。",
  FREE_TRIAL_TERMS_FEATURES_NOTE:
    "Healthnex 有权根据实际情况对试用功能进行调整、限制或终止。",

  FREE_TRIAL_TERMS_EXPIRY_TITLE: "5.	试用期结束与续订（重要条款）",
  FREE_TRIAL_TERMS_EXPIRY_P1:
    "1)	用户明确确认并同意：若在三个月免费试用期结束时未与 Healthnex 签订付费订阅或服务协议，其对 Healthnex 平台的访问权限将终止。",
  FREE_TRIAL_TERMS_EXPIRY_P2: "2)	试用期结束后，如用户未完成订阅：",
  FREE_TRIAL_TERMS_EXPIRY_ITEM_1: "• 平台访问权限可能被暂停或终止；",
  FREE_TRIAL_TERMS_EXPIRY_ITEM_2: "•	用户将无法继续使用平台功能或访问相关数据。",
  FREE_TRIAL_TERMS_EXPIRY_P3:
    "Healthnex 不承担延长试用期或继续提供免费访问的任何义务。",

  FREE_TRIAL_TERMS_DATA_PRIVACY_TITLE: "6.	数据、隐私与健康信息",
  FREE_TRIAL_TERMS_DATA_PRIVACY_P1:
    "1)	用户确认，在使用 Healthnex 平台过程中，Healthnex 可能收集、存储、处理及传输《1988 年隐私法（澳大利亚）》所定义的 个人信息及健康信息。",
  FREE_TRIAL_TERMS_DATA_PRIVACY_P2:
    "2)	用户为其病人数据的 数据控制方（Data Controller），Healthnex 仅根据用户指示对相关数据进行处理。",
  FREE_TRIAL_TERMS_DATA_PRIVACY_P3:
    "3)	Healthnex 将依照以下文件处理所有个人信息与健康信息：",
  FREE_TRIAL_TERMS_DATA_PRIVACY_ITEM_1: "《隐私政策（Privacy Policy）》",
  AND_D: "以及",
  FREE_TRIAL_TERMS_DATA_PRIVACY_ITEM_2:
    "《数据处理附录（Data Processing Addendum, DPA）》。",
  FREE_TRIAL_TERMS_DATA_PRIVACY_P4:
    "4)	上述《隐私政策》与《数据处理附录》通过引用方式构成本协议不可分割的一部分。",
  FREE_TRIAL_TERMS_DATA_PRIVACY_P5:
    "5)	如本协议与《数据处理附录》存在不一致，以 《数据处理附录》在健康数据处理义务范围内为准。",

  FREE_TRIAL_TERMS_USER_RESP_TITLE: "7.	用户责任与合规义务",
  FREE_TRIAL_TERMS_USER_RESP_INTRO: "用户声明并保证：",
  FREE_TRIAL_TERMS_USER_RESP_ITEM_1:
    "1.	如用户为执业医师，其已依法在相关司法辖区完成注册并具备执业资格；",
  FREE_TRIAL_TERMS_USER_RESP_ITEM_2:
    "2.	如用户为诊所负责人或运营者，其将确保所有使用平台的医师均具备合法执业资格；",
  FREE_TRIAL_TERMS_USER_RESP_ITEM_3:
    "3.	使用 Healthnex 平台的行为符合所有适用法律法规，包括隐私与健康记录相关法律；",
  FREE_TRIAL_TERMS_USER_RESP_ITEM_4:
    "4.	所有临床判断、诊断、治疗及处方行为 均由相关执业人员自行负责，Healthnex 不承担任何医疗责任。",

  FREE_TRIAL_TERMS_TRIAL_DISCLAIMER_TITLE: "8.	试用期间免责条款",
  FREE_TRIAL_TERMS_TRIAL_DISCLAIMER_P1:
    "•	在法律允许的最大范围内，Healthnex 平台在试用期间以 “现状”及“可用状态” 提供。",
  FREE_TRIAL_TERMS_TRIAL_DISCLAIMER_P2:
    "•	Healthnex 不保证平台在试用期间的持续可用性、无错误运行，或适用于任何特定用途。",

  FREE_TRIAL_TERMS_LIABILITY_TITLE: "9. 责任限制",
  FREE_TRIAL_TERMS_LIABILITY_P1:
    "•	在法律允许的范围内，Healthnex 不对用户因使用试用服务而产生的任何间接或后果性损失承担责任。",
  FREE_TRIAL_TERMS_LIABILITY_P2:
    "•	本条款不排除或限制《澳大利亚消费者法（Australian Consumer Law）》项下不可依法排除的权利。。",

  FREE_TRIAL_TERMS_AMENDMENTS_TITLE: "10.	协议变更",
  FREE_TRIAL_TERMS_AMENDMENTS_P1:
    "Healthnex 可通过平台通知或电子方式对本协议进行合理修改。用户在修改后继续使用平台即视为接受更新后的协议",

  FREE_TRIAL_TERMS_GOVERNING_LAW_TITLE: "11. 适用法律",
  FREE_TRIAL_TERMS_GOVERNING_LAW_P1:
    "本协议受 澳大利亚新南威尔士州（NSW）法律管辖，双方同意接受该州法院的专属管辖。",

  FREE_TRIAL_TERMS_ACK_TITLE: "12.	确认与同意",
  FREE_TRIAL_TERMS_ACK_INTRO:
    "用户通过点击“我同意”、注册账户或使用 Healthnex 平台，即确认：",
  FREE_TRIAL_TERMS_ACK_ITEM_1: "•	已完整阅读并理解本协议",
  FREE_TRIAL_TERMS_ACK_ITEM_2: "•	同意受本协议全部条款约束；",
  FREE_TRIAL_TERMS_ACK_ITEM_3:
    "•	明确知晓：三个月试用期结束后，如未订阅付费方案，其平台访问权限将终止。",
  FREE_TRIAL_TERMS_ACK_CHECKBOX:
    "我已阅读并同意《Healthnex 免费试用使用条款》、《隐私政策》及《数据处理附录》，并确认如未订阅付费方案，我在三个月试用期结束后将无法继续使用 Healthnex 平台。",
};

const dashboard = {
  SEARCH_PATIENTS: "搜索患者",
  SEARCH_PATIENTS_THAT_U_WANT_TO_VIEW_THE_DETAIL_ABOUT: "搜索并查看患者详情",
  VIEW_USER_GUIDE_AND_UNDERSTAND_THE_SYSTEM: "观看用教程视频并了解系统",
  VIEW_APPOINTMENTS: "查看预约",
  VIEW_CREATED_APPOINTMENTS_ON_TIME_SCHEDULE:
    "通过时间表查看所有已创建的预约。",
  CREATE_APPOINTMENT_FOR_THE_SELECTED_PATIENT: "为所选患者创建预约",
  CREATE_MEIDICAL_HISTORY_FOR_THE_SELECTED_PATIENT: "为所选患者创建病历",
  VIEW_PATIENT_MEDICAL_HISTORY: "查看患者病历",
  VIEW_MEDICAL_HISTORY_FOR_THE_SELECTED_PATIENT: "查看所选患者病历",
  ADD_NEW_PATIENT_TO_THE_SYSTEM: "将新患者添加到系统中",
  VIEW_PATIENT: "查看患者",
  VIEW_PATIENT_INFO: "查看患者信息",
  VALIDATE_PATIENT: "验证新患者",
  VALIDATION_REQUIRED: "需要验证",
  RECOMMENDED_PATIENTS: "推荐患者",
  MERGE: "合并",
  MERGE_TO_RECOMMENDED_PATIENTS: "合并至以下已存的患者",
  MERGE_TO_THIS_PATIENT: "合并至此患者",
  VIEW_MERGED_PATIENT: "查看已合并的患者",
  CONFIRMED_AS_NEW_PATIENT: "确认为新患者",
  PATIENT_CONFIRMED: "已确认为新患者",
  PATIENT_MERGED: "患者合并成功",
  DELETE_PATIENT: "删除患者",
  DELETE_PATIENT_CONFIRM: "确定要删除该患者吗？此操作无法撤销。",
  DELETE_PATIENT_FAILED: "删除失败，该患者可能已存在病历记录。",
  NUMBER_OF_APPOINTMENTS: "患者预约总数",
  TOTAL_EARNINGS: "总收入",
  TOTAL_CHARGED: "原始总收入",
  INSURANCE_REBATE_TOTAL: "医保返还总金额",
  TOTAL_DISCOUNT: "折扣总金额",
  NO_PATIENTS_HAS_CREATED_PRESCRIPTION: "已开具处方的患者数量",
  NO_PRESCRIPTION_CONDUCTED: "已开具处方总数",
  YOUR_CLINIC_MEMBERS: "您的诊所成员",
  MY_STATS: "我的工作统计",
  VIEW_STATS: "查看统计",
  VIEW_THIS_WEEK: "查看本周",
  VIEW_TODAY: "查看今天",
  THIS_WEEK: "本周",
  S_STATS: "的工作统计",
  GOOD_MORNING: "早上好",
  GOOD_NOON: "中午好",
  GOOD_AFTERNOON: "下午好",
  GOOD_EVENING: "晚上好",
  VIEW_CLINIC_STATS: "查看诊所整体工作统计",
  GO_TO: "跳转到",
  PAGE_BACK: "页面",
};

const patientList = {
  IMPORT_PATIENT_FROM_EXCEL: "从Excel文件导入患者",
  IF_U_WANT_TO_IMPORT_PATIENTS_FROM_YOUR_EXCEL:
    "您可以填写 Excel 模板并上传至 Healthnex，以快速导入患者信息。",
  STEP_1_DOWNLOAD_THE_EXCEL_TEMPALTE_FILE_FROM_BELOW_AND_FILL_IN_ALL_THE_REQUIRED_COLUMNS:
    "步骤一：下载下方的 Excel 模板，并填写文件中患者的所有必填信息。",
  STEP_2_COMPLETE_PATIENT_INFO_EXCEL_TEMPALTE_AND_UPLOAD_BELOW:
    "步骤二：完成填写后，点击下方按钮上传 Excel 模板至 Healthnex 平台。",
  DOWNLOAD_EXCEL_TEMPLATE: "下载Excel模板",
  UPLOAD_EXCEL: "上传Excel（.xlsx）文件",
  IMPORTED_PATIENTS: "已导入患者",
  PATIENTS_IMPORTED_SUCCESSFULLY: "名患者信息已成功导入",
  IMPORT_ERRORS_FOUND: "条错误导入信息",
  NO_ERRORS_FOUND: "未在导入时发现错误",
  RECORDS_REQUIRED_UR_ACTION_DUE_TO_SIMILAR_PATIENTS_FOUND_IN_THE_SYSTEM:
    "条记录在系统中发现可能存在重复的患者信息，请您进行手动处理。",
  IMPORT_STATUS: "导入操作",
  IMPORT_PAUSED: "导入暂停",
  X_SIMILAR_PATIENTS_FOUND_IN_THE_SYSTEM:
    "系统查找到 {{X}} 名可能与当前患者信息存在相似性的患者",
  OVERWRITE_EXCEL_TO_THIS: "使用导入数据覆盖该患者信息。",
  HERE_IS_THE_DIFFERENCE_BETWEEN_TWO_RECORDS:
    "您可以在下方查看该患者信息与导入数据之间的差异",
  CURRENT_IN_SYSTEM: "系统现有患者信息",
  EXCEL_INFO_TO_UPDATE: "Excel 导入的患者信息",
  THERE_ARE_STILL_SOME_IMPORTED_PATIENTS_INFO_NEED_UR_ACTION:
    "仍有部分患者信息未成功导入，仍需要您进行手动处理",
  ARE_U_SURE_TO_COMPLETE_THE_IMPORT_NOW:
    "您确定已完成导入操作，并要关闭此窗口吗？",
  DOWNLOADING: "正在下载",
  PATIENTS_IMPORTED_FROM_EXCEL: "已从 Excel 导入患者信息",
  RE_UPLOAD_THE_EXCEL: "重新上传 Excel",
  COMPLETE_IMPORT: "完成导入",
  PREFER_NOT_TO_SAY: "不便透露",
  ADDED_PATIENTS: "新增患者信息",
  DUPLICATED_PATIENTS: "已存在的患者信息",
  EXCEL_FILE_UPLOAD_FAILED_PLEASE_MAKE_SURE_YOU_ARE_USING_OUR_TEMPLATE_FILE_U_CAN_DOWNLOAD_THE_FILE_HERE:
    "Excel 文件上传失败。请确认您正在使用本系统提供的模板文件。您可通过下方按钮下载模板。",
  EXPORT_MEDICAL_HISTORY: "导出病历记录",
  EXPORT_X_MEDICAL_HISTORY: "导出{{X}}的病历记录",
  STEP_1_SELECT_DATE_RANGE_MEDICAL_INSURANCES_TO_FILTER_MEDICAL_HISTORY_THAT_U_LIKE_TO_EXPORT:
    "步骤一：选择问诊日期范围，并根据患者使用的相关医保进行筛选，以确定需要导出的医疗历史记录。",
  OPTIONAL: "可选",
  IF_U_WANT_TO_EXPORT_PATIENT_HISTORY_CREATED_FROM_SPECIFIC_CLINIC:
    "如果您希望仅导出由特定诊所创建的病历，请在下方选择相应的诊所进行筛选。",
  STEP_2_EXPORT_RELATED_PATIENT_HISTORY_TO_EXCEL:
    "步骤二：将筛选出的相关患者病历记录导出为 Excel 文件。",
  TOTAL_MEDICAL_RECORDS_FOUND: "已找到的相关病历记录总数",
  MULTI_SELECTION: "可多选",
  EXPORT_TO_EXCEL: "导出为 Excel",
  UPDATED_BY: "上次修改者",
  UPLOAD_ATTACHMENT: "上传文件",
  MAX_X_ATTACHMENTS_ALLOWED: "最多只能上传{{X}}个附件",
  DELETING: "删除中",
  OCCUPATION: "职业",
  NOTES: "备注",
  ADDRESS_INFO: "地址信息",
  POSTAL_ADDRESS: "邮寄地址",
  SAME_AS_HOME_ADDRESS: "与家庭地址相同",
  OTHER_INFO: "其他信息",
  PLEASE_CHECK_THE_INFORMATION_THAT_U_WISH_TO_UPDATE: "请勾选您想要更新或者保留的信息。",
  NEW_INFO: "新资料",
};

const templateEditor = {
  CLINIC_DOC_TEMPLATE: "文档与短信模板",
  DOCUMENT_TEMPLATES: "文档与短信模板",
  YOU_CAN_CREATE_EDIT_CLINIC_TEMPLATES_HERE: "创建并管理诊所使用的证明、信函和短信内容。",
  NEW_CLINIC_TEMPLATE: "新建诊所模板",
  TEMPLATE_NAME: "模板名称",
  TEMPLATE_CATEGORY: "模板类别",
  TEMPLATE_SOURCE: "模板来源",
  SYSTEM_TEMPLATE: "系统模板",
  CLINIC_TEMPLATE: "诊所模板",
  CLINIC_TEMPLATES: "诊所模板",
  CLINIC_TEMPLATES_HINT: "由您的诊所自定义的模板。",
  SYSTEM_TEMPLATES: "系统模板",
  SYSTEM_TEMPLATES_HINT: "Healthnex 提供的默认模板。编辑后将生成诊所副本。",
  NO_CLINIC_TEMPLATE_YET: "暂无诊所模板。可编辑下方的系统模板来创建自己的模板。",
  USER_DEFINED: "自定义",
  SICK_CERT: "病假条",
  REFERRAL: "转诊信",
  ALL: "全部",
  SEARCH_TEMPLATES: "搜索模板",
  CLEAR_FILTERS: "清除筛选",
  CLEAR_SEARCH: "清除搜索",
  NO_TEMPLATE_FOUND: "未找到模板",
  TRY_ANOTHER_SEARCH_TERM: "请尝试其他关键词或清除筛选条件。",
  LOADING_TEMPLATES: "正在加载模板……",
  CREATE_SUCCESS: "模板创建成功。",
  TEMPLATE_SAVE_SUCCESS: "模板保存成功。",
  TEMPLATE_DELETE_SUCCESS: "模板删除成功。",
  DELETE_TEMPLATE: "删除模板",
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEMPLATE: "确定要删除此模板吗",
  TEMPLATE_WILL_BE_RESET_TO_SYSTEM_TEMPLATE: "如果此模板当前正在使用，删除后将改用系统模板。",
  NOTE: "注意",
  CREATED_IN: "创建于",
  LAST_EDITED_AT: "最后编辑时间",
  EDIT: "编辑",
  DELETE: "删除",
  TEMPLATE_ACTIVATED: "模板已成功启用。",
  TEMPLATE_DEACTIVATED: "模板已成功停用。",
  STATUS: "状态",
  IN_USE: "使用中",
  NOT_USED: "未使用",
  UPDATING: "正在更新",
  DUPLICATE: "复制",
  DUPLICATE_TEMPLATE: "复制模板",
  SAVE: "保存",
  SAVING: "正在保存",
  SAVE_AS_CLINIC_TEMPLATE: "另存为诊所模板",
  LOADING_TEMPLATE: "正在加载模板",
  CREATING_TEMPLATE: "正在创建模板",
  SAVING_TEMPLATE: "正在保存模板",

  SMS_CREATE_BOOKING: "短信 - 预约确认",
  SMS_RESCHEDULE_BOOKING: "短信 - 预约改期",
  EDIT_SMS_TEMPLATE: "编辑短信模板",
  MESSAGE_CONTENT: "短信内容",
  VARIABLES: "变量",
  INSERT_VARIABLE_HINT: "点击或拖动变量插入到光标位置，或在内容中输入 {{ 搜索变量。",
  CHARACTERS: "个字符",
  SMS_CHAR_LIMIT_HINT: "字数按填入示例患者和诊所信息后的内容计算，实际信息可能使短信略长或略短。",
  SMS_CHAR_LIMIT_EXCEEDED: "内容超过 300 个字符上限，请缩短后再保存。",
  SMS_TODAY: "今天",
  SMS_TEXT_MESSAGE: "短信",
  SMS_PREVIEW_EMPTY: "开始输入即可预览短信",
  DRAG_ELEMENTS_AND_DROP_ON_PAGE: "请将以下内容模块拖放到页面中进行编辑。",
  PREVIEW: "预览",
  SCALE: "缩放",
  ZOOM_OUT: "缩小",
  ZOOM_IN: "放大",
  RESET_SCALE: "重置缩放",
  CONTENT: "内容",
  TEXT: "文本",
  LAYOUT: "布局",
  COLUMNS: "分栏",
  LINE_DIVIDER: "分隔线",
  MEDIA: "媒体",
  IMAGE: "图片",
  SIGNATURE: "签名",
  PAGE_SIZE: "页面尺寸",
  PAGE_MARGIN: "页面边距",
  PAGE_SETTINGS: "页面设置",
  SELECT_ELEMENT_TO_EDIT_HINT: "点击页面中的元素，即可在此编辑其设置。",
  TEXT_PARAGRAPH: "文本段落",
  ENTER_CONTENT_HERE: "请在此输入内容",
  FONT_SIZE: "字体大小",
  BOLD: "粗体",
  ITALIC: "斜体",
  UNDERLINE: "下划线",
  ALIGNMENT: "对齐方式",
  TEXT_COLOUR: "文字颜色",
  BOTTOM_MARGIN: "底部间距",
  DYNAMIC_FIELD: "标签与预设内容",
  LABEL: "标签",
  LABEL_FONT_SIZE: "标签字体大小",
  VALUE_FONT_SIZE: "内容字体大小",
  VALUE_COLOUR: "内容颜色",
  LABEL_COLOUR: "标签颜色",
  TWO_COLUMNS: "双栏布局",
  COLUMN_GAP: "栏间距",
  LEFT_WIDTH_RATIO: "左栏宽度",
  RIGHT_WIDTH_RATIO: "右栏宽度",
  HORIZONTAL_LINE: "水平分隔线",
  LINE_WIDTH: "线条宽度",
  COLOUR: "颜色",
  SPACING: "空白间距",
  HEIGHT: "高度",
  MINIMUM_HEIGHT: "最小高度",
  PRACTITIONER_SIGNATURE: "医师签名",
  CLINIC_LOGO: "诊所标志",
  CLEAR: "清空",
  LEFT: "左对齐",
  CENTER: "居中",
  RIGHT: "右对齐",
  JUSTIFY: "两端对齐",
  MANUAL_INPUT: "手动输入",
  AUTOMATIC_FIELDS: "预设字段",
  USER_INPUT_FIELDS: "需用户填写的字段",
  USER_INPUT: "需用户输入",
  USER_INPUT_FIELD_HINT: "生成文档前需要用户填写此内容。",
  DRAG_OR_CLICK_VARIABLE_HINT: "拖动或点击以插入",
  VARIABLE_PALETTE_TITLE: "插入变量",
  VARIABLE_PALETTE_PANEL_HINT: "将变量拖到文本框中，或点击以在光标处插入。",
  INSERT_PRESET_VARIABLES: "插入预设内容",
  SELECT_PRESET_OPTIONS: "选择预设内容",
  SHOW_PREVIEW: "显示预览",
  TOOLBAR_SIZE: "字号",
  TOOLBAR_COLOUR: "颜色",
  TOOLBAR_THICKNESS: "粗细",
  PRACTITIONER_NAME: "医师姓名",
  CMBA_NUMBER: "CMBA 注册号",
  CLINIC_NAME: "诊所名称",
  CLINIC_ADDRESS: "诊所地址",
  PATIENT_NAME: "患者姓名",
  PATIENT_DOB: "患者出生日期",
  BOOKING: "预约",
  BOOKING_CODE: "预约编号",
  BOOKING_START_DATE: "预约开始日期",
  BOOKING_START_TIME: "预约开始时间",
  BOOKING_PATIENT_NAME: "预约患者姓名",
  PRACTITIONER_PHONE: "医师电话",
  TODAY_DATE: "今天日期",
  START_DATE: "开始日期",
  END_DATE: "结束日期",
  FREE_TEXT: "自由文本",
  CONSULTED_DATE: "就诊日期",
  UNFIT_UNTIL_DATE: "不适合工作至",

  PERMISSION_ROLES: "权限角色",
  PERMISSION_ROLES_HINT: "为您的诊所创建自定义角色，基于共享的权限集合。",
  CLINIC_ROLES: "诊所角色",
  CLINIC_ROLES_SECTION_HINT: "由您的诊所创建的角色——可完全编辑。",
  NO_CLINIC_ROLE_YET: "暂无诊所角色，创建一个开始使用。",
  SYSTEM_ROLES: "系统角色",
  SYSTEM_ROLES_HINT: "Healthnex提供的默认角色——只读。",
  SYSTEM: "系统",
  NEW_CLINIC_ROLE: "新建诊所角色",
  EDIT_CLINIC_ROLE: "编辑诊所角色",
  SEARCH_ROLES: "搜索角色",
  ROLE_NAME_EN: "角色名称（英文）",
  ROLE_NAME_CN: "角色名称（中文）",
  ROLE_NAME_TH: "角色名称（泰文）",
  ROLE_NAME_VN: "角色名称（越南文）",
  ROLE_NAME_IS_REQUIRED: "角色名称（英文）为必填项。",
  TRANSLATING: "翻译中",
  PERMISSIONS: "权限",
  SELECTED: "已选",
  CLEAR_ALL: "清除全部",
  SEARCH_PERMISSIONS: "搜索权限",
  NO_PERMISSIONS_FOUND: "未找到权限",
  X_PERMISSIONS_ASSIGNED: "已分配{{X}}项权限",
  X_PERMISSIONS_ADDED: "新增{{X}}项",
  X_PERMISSIONS_REMOVED: "移除{{X}}项",
  REMOVED: "已移除",
  PERMISSION_DIFF_VS_CURRENT_HINT: "以下展示的是该角色权限相对于医师当前角色的对比。",
  NO_PERMISSIONS_ADDED_VS_CURRENT: "相比当前角色，没有新增的权限。",
  NO_PERMISSIONS_REMOVED_VS_CURRENT: "相比当前角色，没有被移除的权限。",
  DELETE_ROLE: "删除角色",
  ROLE_NAME: "角色名称",
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_ROLE: "确定要删除这个角色吗",
  NO_DATA: "暂无数据",
  ROLE_CREATE_SUCCESS: "角色创建成功。",

  PERMISSION_ASSIGNMENT: "权限分配",
  CURRENT_ROLE: "当前角色",
  CURRENT_PERMISSIONS: "当前权限",
  VIEW_PERMISSIONS: "查看权限",
  RESET_TO_CURRENT_ROLE: "切回当前角色",
  SWITCH_TO_THIS_ROLE: "切换至该角色权限",
  NO_PERMISSIONS_ASSIGNED: "暂无已分配的权限。",
  REASSIGN_ROLE: "重新分配角色",
  SELECT_ROLE_TO_ASSIGN: "选择角色",
  PREVIEW_ROLE_PERMISSIONS: "预览该角色的权限",
}

export default {
  translation: {
    ...signUp,
    ...navigation,
    ...prescription,
    ...search,
    ...info,
    ...notification,
    ...appointment,
    ...clinicManagement,
    ...clinicHerbs,
    ...Library,
    ...camera,
    ...packagePages,
    ...cmasaImport,
    ...bookingPage,
    ...guide,
    ...patientConsent,
    ...agreements,
    ...freeTrialTerms,
    ...dashboard,
    ...patientList,
    ...templateEditor,
    // ---- New onboarding flow ----
    ABN: "ABN",
    RETRY: "重试",
    ONBOARDING_STEP_X_OF_Y: "第 {{current}} 步，共 {{total}} 步",
    ONBOARDING_SHOW_MORE: "显示更多（{{count}}）",
    ONBOARDING_SHOW_FEWER: "收起",
    ONBOARDING_USERNAME_CHECKING: "正在检查可用性…",
    ONBOARDING_USERNAME_HINT: "您将使用此用户名登录 Healthnex。",
    ONBOARDING_ABOUT_TITLE: "介绍一下您自己",
    ONBOARDING_ABOUT_SUB: "只需填写几项快速信息即可开始，很快就能完成。",
    ONBOARDING_INVITE_EMAIL_LOCKED: "这是您的邀请发送到的邮箱。",
    ONBOARDING_ACCOUNT_TITLE: "创建您的账户",
    ONBOARDING_ACCOUNT_SUB: "很高兴认识您{{greeting}}。请设置您的登录信息。",
    ONBOARDING_PASSWORDS_MATCH: "两次密码一致。",
    ONBOARDING_PASSWORDS_MUST_MATCH: "两次密码必须一致。",
    ONBOARDING_PASSWORD_HINT: "请输入两次相同的密码以确认。无特殊格式要求。",
    ONBOARDING_CLINIC_DECISION_TITLE: "是否创建您的第一家诊所？",
    ONBOARDING_CLINIC_DECISION_SUB: "您可以现在设置，也可以先体验 Healthnex，稍后再设置。",
    ONBOARDING_CLINIC_YES: "是，创建我的诊所",
    ONBOARDING_CLINIC_YES_DESC: "现在设置您的诊所、服务和工作时间。",
    ONBOARDING_CLINIC_NOTNOW: "暂不，我稍后再创建诊所",
    ONBOARDING_CLINIC_NOTNOW_DESC: "先体验——您可以随时创建或加入诊所。",
    ONBOARDING_GETSTARTED_TITLE: "您想如何开始？",
    ONBOARDING_GETSTARTED_SUB: "请选择最符合您情况的选项。",
    ONBOARDING_CREATE_CLINIC: "创建我的诊所",
    ONBOARDING_CREATE_CLINIC_DESC: "创建一家新诊所，并添加其服务、营业时间以及您的工作信息。",
    ONBOARDING_JOIN_CLINIC: "加入现有诊所",
    ONBOARDING_JOIN_CLINIC_DESC: "查找现有诊所，发送加入请求，并添加您的执业信息。",
    ONBOARDING_RECOMMENDED: "推荐",
    ONBOARDING_YOUR_DETAILS_AT: "您在 {{clinic}} 的信息",
    ONBOARDING_YOUR_DETAILS_SUB: "选择您提供的服务或疗法，并设置您在该诊所的常规工作时间。",
    ONBOARDING_YOUR_THERAPIES: "您的服务或疗法",
    ONBOARDING_PROPOSED_HOURS: "您拟定的工作时间",
    ONBOARDING_JOIN_TITLE: "查找您的诊所",
    ONBOARDING_JOIN_SUB: "搜索您想加入的诊所并发送请求。",
    ONBOARDING_JOIN_SEARCH_LABEL: "诊所名称",
    ONBOARDING_JOIN_PENDING: "等待审批",
    ONBOARDING_JOIN_CONFIRM_BODY: "完成设置后，我们将发送您加入 {{clinic}} 的请求。在诊所审核期间，您可以继续设置您的账户。",
    ONBOARDING_JOIN_CHANGE: "选择其他诊所",
    ONBOARDING_JOIN_REQUEST: "诊所加入请求",
    ONBOARDING_JOIN_STATUS: "请求状态",
    ONBOARDING_SUBMIT_JOIN: "发送加入请求",
    ONBOARDING_ERR_SELECT_CLINIC: "请搜索并选择要加入的诊所。",
    ONBOARDING_LABEL_JOIN: "加入诊所",
    ONBOARDING_CLINIC_DETAILS_TITLE: "设置您的诊所",
    ONBOARDING_CLINIC_DETAILS_SUB: "目前只需填写要点，其余内容可随时补充。",
    ONBOARDING_CREATE_CLINIC_PROMO: "限时优惠！新诊所赠送3个月免费试用！（仅限前3个诊所）",
    ONBOARDING_CAPACITY: "床位 / 诊室",
    ONBOARDING_CAPACITY_HINT: "您诊所拥有的床位或诊室数量。",
    ONBOARDING_OPENING_HOURS: "诊所营业时间",
    ONBOARDING_OPENING_HOURS_HINT: "诊所对外营业的时间段。",
    ONBOARDING_OPENING_FROM: "开始营业",
    ONBOARDING_OPENING_TO: "结束营业",
    ONBOARDING_WORK_AT_CLINIC: "您在 {{clinic}} 的工作时间？",
    ONBOARDING_PRACTITIONER_TITLE: "您的服务与工作时间",
    ONBOARDING_PRACTITIONER_SUB: "设置您在该诊所提供的服务和工作时间。可随时修改。",
    ONBOARDING_PRACTITIONER_CLINIC_NOTE: "这些设置将在您于 {{clinic}} 工作时生效。",
    ONBOARDING_PRACTITIONER_AT: "{{clinic}} 的医师",
    ONBOARDING_YOUR_MODALITIES: "您的服务或疗法",
    ONBOARDING_SELECT_ALL_APPLY: "请选择所有适用项。",
    ONBOARDING_N_SELECTED: "已选择 {{count}} 项",
    ONBOARDING_WORKING_HOURS: "工作时间",
    ONBOARDING_WORKING_HOURS_HINT: "默认已选择工作日。取消勾选休息日，或调整时间。",
    ONBOARDING_START_TIME: "开始时间",
    ONBOARDING_END_TIME: "结束时间",
    ONBOARDING_PRODUCTS_TITLE: "您的诊所提供哪些服务和产品？",
    ONBOARDING_PRODUCTS_SUB: "添加您诊所提供的服务产品。您可以在之后随时更新。",
    ONBOARDING_PRODUCTS_OPTIONAL: "您可以暂时跳过，稍后再添加服务。",
    ONBOARDING_CLINIC_SERVICES: "诊所服务",
    ONBOARDING_WELCOME_TITLE: "设置完成！",
    ONBOARDING_WELCOME_BODY: "您的账户已准备就绪。去主页看看，管理预约、患者等更多功能。",
    ONBOARDING_YOUR_WORKING_HOURS: "您的工作时间",
    ONBOARDING_STANDARD_OPENING_HOURS: "标准营业时间",
    ONBOARDING_PRICE_LIST: "价目表",
    ONBOARDING_SELECTED_MODALITIES: "您已选择的疗法",
    ONBOARDING_OTHER_MODALITIES: "其他疗法",
    ONBOARDING_ADD_ANOTHER_MODALITY: "添加其他疗法",
    ONBOARDING_ADD_SERVICE: "添加服务",
    ONBOARDING_REMOVE_SERVICE: "删除服务",
    ONBOARDING_ERR_PRODUCT_NAME: "请输入产品名称。",
    ONBOARDING_INVITE_CHECKING: "正在检查您的邀请…",
    ONBOARDING_INVITE_VALID: "邀请已确认。注册后您将加入该诊所。",
    ONBOARDING_INVITE_VALID_NAMED: "您已受邀加入 {{clinic}}。注册后即可加入。",
    ONBOARDING_INVITE_INVALID: "我们无法验证此邀请。请检查链接后重试。",
    ONBOARDING_INVITE_EXPIRED: "此邀请已过期。请让您的诊所重新发送。",
    ONBOARDING_SUMMARY_TITLE: "确认并完成{{greeting}}",
    ONBOARDING_SUMMARY_SUB: "请确认信息无误，然后完成以创建您的账户。",
    ONBOARDING_SUBMITTING_SUB: "正在设置您的账户…",
    ONBOARDING_PERSONAL_INFO: "个人信息",
    ONBOARDING_CLINIC_CREATED_TITLE: "创建诊所",
    ONBOARDING_NAME: "姓名",
    ONBOARDING_ACCOUNT: "账户",
    ONBOARDING_HOURS: "时间",
    ONBOARDING_NONE: "无",
    ONBOARDING_NO_PRODUCTS: "未添加服务。",
    ONBOARDING_SUBMIT_ACCOUNT: "创建您的账户",
    ONBOARDING_SUBMIT_AUTH: "为您登录",
    ONBOARDING_SUBMIT_CLINIC: "创建您的诊所",
    ONBOARDING_SUBMIT_PRODUCTS: "添加您的服务",
    ONBOARDING_SUBMIT_MEMBER: "设置您的接待量",
    ONBOARDING_SUBMIT_SETTINGS: "保存您的服务与工作时间",
    ONBOARDING_SUBMIT_FAILED: "出现问题。您的信息已保存——可以重试。",
    ONBOARDING_FINISH: "完成设置",
    ONBOARDING_BACK_TO_SIGNIN: "返回登录",
    ONBOARDING_LABEL_ABOUT: "关于您",
    ONBOARDING_LABEL_ACCOUNT: "您的账户",
    ONBOARDING_LABEL_CLINIC_Q: "您的诊所",
    ONBOARDING_LABEL_CLINIC: "诊所信息",
    ONBOARDING_LABEL_PRACTITIONER: "服务与时间",
    ONBOARDING_LABEL_PRODUCTS: "价目表",
    ONBOARDING_LABEL_SUMMARY: "确认",
    ONBOARDING_ERR_FIRST_NAME: "请输入您的名字。",
    ONBOARDING_ERR_LAST_NAME: "请输入您的姓氏。",
    ONBOARDING_ERR_EMAIL: "请输入您的邮箱。",
    ONBOARDING_ERR_EMAIL_INVALID: "请输入有效的邮箱地址。",
    ONBOARDING_ERR_PHONE: "请输入您的电话号码。",
    ONBOARDING_ERR_PHONE_MOBILE: "请输入您的手机号码。",
    ONBOARDING_ERR_PHONE_INVALID: "请输入有效的澳大利亚手机号码，例如：0412345678。",
    ONBOARDING_ERR_GENDER: "请选择性别。",
    ONBOARDING_ERR_USERNAME: "请选择一个用户名。",
    ONBOARDING_ERR_USERNAME_CHECK: "请等待用户名检查完成。",
    ONBOARDING_ERR_PASSWORD: "请设置密码。",
    ONBOARDING_ERR_CONFIRM: "请再次输入密码。",
    ONBOARDING_ERR_MISMATCH: "两次密码不一致。",
    ONBOARDING_ERR_CLINIC_NAME: "请输入诊所名称。",
    ONBOARDING_ERR_ADDRESS: "请输入诊所地址（街道、区、州和邮编）。",
    ONBOARDING_ERR_CLINIC_CREATE_FAILED: "诊所创建失败，请重试。",
    ONBOARDING_ERR_CHOOSE: "请选择一个选项以继续。",
    ONBOARDING_ERR_MODALITY: "请至少选择一项服务或疗法。",
    ONBOARDING_ERR_WORKING_DAY: "请至少选择一个工作日。",
    ONBOARDING_ERR_PRODUCT_ROW: "请完善或移除标记的服务（类型、项目名称和有效价格）。",
    ONBOARDING_CONTACT_TITLE: "我们如何联系您？",
    ONBOARDING_CONTACT_SUB: "我们将通过这些方式就您的账户和预约与您联系。",
    ONBOARDING_CLINIC_LOCATION_TITLE: "您的诊所在哪里？",
    ONBOARDING_CLINIC_LOCATION_SUB: "填写诊所地址，方便患者找到您。",
    ONBOARDING_CLINIC_HOURS_TITLE: "诊所营业时间",
    ONBOARDING_CLINIC_HOURS_SUB: "设置诊所的营业时间。这与您本人的工作时间是分开的。",
    ONBOARDING_CLINIC_CAPACITY_TITLE: "容量与营业时间",
    ONBOARDING_CLINIC_CAPACITY_SUB: "设置诊所和您本人可服务的人数，以及诊所的营业时间。",
    ONBOARDING_MODALITIES_TITLE: "您的服务或疗法",
    ONBOARDING_MODALITIES_TITLE_AT: "您在 {{clinic}} 提供的疗法",
    ONBOARDING_MODALITIES_SUB: "选择您在此提供的服务或疗法。您可以随时修改。",
    ONBOARDING_WORKING_TITLE: "您的工作时间",
    ONBOARDING_WORKING_TITLE_AT: "您在 {{clinic}} 的工作时间",
    ONBOARDING_PROPOSED_WORKING_TITLE_AT: "您在 {{clinic}} 的拟定工作时间",
    ONBOARDING_WORKING_SUB: "设置您通常的工作日和时间。您可以随时修改。",
    ONBOARDING_PROPOSED_WORKING_SUB: "提出您希望的工作日和时间。在诊所批准您的申请之前，这些时间尚未生效。",
    ONBOARDING_PRACTITIONER_CAPACITY: "同时可服务的最大人数",
    ONBOARDING_PRACTITIONER_CAPACITY_HINT: "您可以同时接待的患者人数，不能超过诊所的床位数。",
    ONBOARDING_PRACTITIONER_CAPACITY_HINT_WITH_MAX: "您可以同时接待的患者人数（该诊所共有 {{max}} 张床位/诊室，不能超过此数）。",
    ONBOARDING_WORKING_OPTIONAL_NOTE: "此步骤为可选 — 您可以现在设置工作时间，也可以稍后在诊所设置中设置。",
    ONBOARDING_WORKING_NOT_SET: "未设置",
    ONBOARDING_WORKING_LATER: "您可以稍后在诊所设置中配置工作时间。",
    ONBOARDING_SET_UP: "设置",
    ONBOARDING_JOIN_REVIEW_TITLE: "确认您的诊所",
    ONBOARDING_JOIN_REVIEW_SUB: "在发送申请前，请确认这是正确的诊所。",
    ONBOARDING_JOIN_SELECTED: "已选择：{{clinic}}",
    ONBOARDING_SKIP_WORKING_HOURS: "暂时跳过工作时间",
    ONBOARDING_SKIP_SERVICES: "我稍后再添加",
    ONBOARDING_LABEL_CONTACT: "联系方式",
    ONBOARDING_LABEL_LOCATION: "位置",
    ONBOARDING_LABEL_HOURS: "容量与营业时间",
    ONBOARDING_LABEL_MODALITIES: "疗法",
    ONBOARDING_LABEL_WORKING: "工作时间",
    ONBOARDING_LABEL_JOIN_SEARCH: "查找诊所",
    ONBOARDING_LABEL_JOIN_REVIEW: "确认诊所",
    ONBOARDING_JOIN_NORESULT_TITLE: "未找到该诊所",
    ONBOARDING_JOIN_NORESULT_BODY: "请检查诊所名称后重试。您也可以跳过此步骤，稍后再创建或加入诊所。",
    ONBOARDING_JOIN_TRY_ANOTHER: "重新搜索",
    ONBOARDING_JOIN_ERROR_TITLE: "搜索时出现问题",
    ONBOARDING_SKIP_CLINIC_SETUP: "暂时跳过诊所设置",
    ONBOARDING_NO_CLINIC_NOTE: "您的账户已就绪。您可以体验 Healthnex，创建或加入诊所后即可使用临床功能。",
    ONBOARDING_ERR_SERVICE_NAME: "请输入服务名称。",
    ONBOARDING_ERR_SERVICE_PRICE: "请输入有效的价格。",
    BACK: "返回",
    CLOSE: "关闭",
    ONLINE_ZOOM_MEETING: "网络会议",
    CN: "中",
    EN: "英",
    OTHER_LANGUAGE_VERSION: "English Version",
    KEY_MEMBERS: "主要成员",
    INTRODUCTION: "专业描述",
    LOAD_MORE: "加载更多",
    CURRENT: "当前",
    HISTORY_EVENT: "过往活动",
    HISTORY_CPD: "过往CPD",
    EXPIRED: "已过期",
    MONTH_FORMAT: "M月",
    EDIT: "编辑",
    FROM: "从",
    TO: "至",
    TOTAL_X: "总计{{X}}条记录",
    CLINIC: "诊所",
    HRS: "小时",
    VIEW: "查看",
    LOADING: "加载中",
    VIEW_ALL: "查看所有",
    SWITCH_TEMPLATE: "切换模板",
    NO_INPUT_YET: "[尚未填写相关信息]",
    U_ARE_EDITING: "您正在编辑",
    X_WEBSITE: "您的{{X}}版网站",
    TERMS_AND_CONDITIONS: "条款和条件",
    PRIVACY_POLICY: "隐私政策",
    INITIATING: "系统初始化中",
    FAILED_TO_ACCESS_MICROPHONE: "访问麦克风失败",
    LISTENING: "正在聆听",
    TRANSCRIBING: "转录信息中",
    SPEECH_TO_TEXT: "语音转文字",
    STOP_RECORDING: "停止录音",
    DISPLAYED: "已展示",
    RECORDS: "条数据",
    X_RECORDS: "{{X}}条数据",
    WITH_TOTAL_X_RECORDS: "总计{{X}}条数据",
    ALL_X_RECORDS_LOADED: "已加载{{X}}条数据",
    AI_AUTO_TRANSLATE: "AI补全",
    ADD_TO_CLINIC_FORMULA: "添加到诊所药方",
    NON_PREMIUM: "非高级药材",
    NON_TOXIC: "无毒性",
    APPOINTMENT_HISTORY: "预约记录",
    ADJUST_APPOINTMENT_TIME: "调整预约时间",
    ADJUST_NOW: "立即调整",
    I_UNDERSTAND_THE_ACTION_AND_AGREE_TO_PROCEED: "我理解该操作并同意继续",
    PLEASE_NOTE_CHANGING_APPOINTMENT_DURATION_MIGHT_CAUSE_OVERBOOKING_TO_OTHER_EXISTING_APPOINTMENT:
      "请注意，更改预约时长可能会导致现有的预约存在时间冲突",
    NEXT_WEEK: "下周",
    JUMP_TO_TODAY: "跳转到今天",
    APPOINTMENTS_PENDING_FOR_SCHEDULE: "待安排的超额预约",
    X_APPOINTMENTS_PENDING_FOR_YOUR_SCHEDULE: "{{X}} 条超额预约等待您的安排",
    RELOAD: "重新加载",
    CANNOT_RESCHEDULE_WITHIN_24_HOURS: "不能在24小时内重新调整预约",
    PREV_WEEK: "上一周",
    PENDING_APPROVAL: "待批准",
    SUBSCRIBE: "订阅",
    THIS_ITEM_WILL_NOT_LONGER_BE_ABLE_TO_BE_USED_IN_THIS_CLINIC:
      "该项目将不再能够在此诊所中使用",
    PLEASE_SELECT_A_VIDEO: "请选择一个视频",
    PLEASE_SELECT_A_COVER_IMAGE: "请选择一张封面图片",
    RESCHEDULE: "重新安排",
    RESCHEDULE_APPOINTMENT: "重新安排预约",
    CURRENT_APPOINTMENT_TIME: "当前预约时间",
    NEW_APPOINTMENT_TIME: "新的预约时间",
    NOT_SELECTED: "未选择",
    LINK_APPOINTMENT_TO_PATIENT_SUCCESS: "已成功将预约关联到患者",
    LINK_APPOINTMENT_TO_PATIENT: "将预约关联到患者",
    ACCEPT_APPOINTMENT: "接受预约",
    PROCEED_TO_PATIENT_INFO: "前往患者信息",
    CONFIRM_RESCHEDULE: "确认重新安排",
    APPOINTMENT_DATE: "预约日期",
    PENDING_APPOINTMENT: "待处理预约",
    PENDING_APPOINTMENTS: "待处理的预约",
    PENDING_SCHEDULE: "排程待定",
    LINK_TO_PATIENT: "关联到患者",
    LINK_TO_ANOTHER_PATIENT: "关联到另一位患者",
    LINK_ANOTHER_PATIENT_FROM_CLINIC_TO_THIS_APPOINTMENT:
      "将本诊所的另一位患者关联到此预约",
    THIS_PACKAGE_IS_ONLY_FOR_YOUR_CLINIC_PLZ_CREATE_ONE:
      "该套餐仅适用于您自己的诊所，请先创建一个您自己的诊所",
    CLEAR: "清除",
    YOUR_WORKING_CLINICS: "您所属的诊所",
    ALL: "全部",
    SEARCH_PACKAGE: "搜索套餐",
    SEARCH_TREATMENT: "搜索治疗",
    X_APPOINTMENTS_PENDING: "有 {{X}} 个预约待处理",
    X_MODALITIES_INCLUDES: "包含 {{X}} 种治疗方式",
    ARE_U_SURE_TO_ACCEPT_THIS_APPOINTMENT_SCHEDULE:
      "您确定要接受此预约安排吗？",
    OVERBOOKING_ACCEPTED: "已接受超额预约",
    RESCHEDULE_SUCCESS: "重新预约成功",
    AN_CONFIRMATION_SMS_WILL_SEND_TO_PATIENT_TO_CONFIRM_THE_RESCHEDULE:
      "系统将重新发送预约短信提醒您的病人",
    CONTINUE: "继续",
    VIEW_THIS_DATE_SCHEDULE: "查看此日期的日程",
    PLS_NOTE_THIS_CLINIC_INFO_WILL_BE_SUBMITTED_FOR_APPROVAL:
      "请注意，诊所信息将提交审批",
    YOU_WILL_BE_NOTIFIED_WHEN_APPROVAL_IS_DONE: "审批完成后你将收到通知",
    SUBMIT_CONFIRM: "确认提交",
    PLEASE_FILL_IN_ALL_REQUIRED_FIELDS: "请填写所有必填字段",
    CLINIC_CREATE_REQUEST_SENT: "诊所创建请求已发送",
    UPDATE_CONFIRM: "确认更新",
    ARE_YOU_SURE_TO_UPDATE_YOUR_CLINIC_INFO: "确定要更新诊所信息吗？",
    CLINIC_UPDATED: "诊所信息已更新",
    CLOSED_CLINIC_SUCCESS: "诊所关闭成功",
    PROTECTED_PAGE: "此页面需要诊所访问权限",
    PROTECTED_PAGE_WARNING: "你需要适当的访问权限才能查看此页面。",
    TO_START_YOUR_WORK_PLS_IDENTIFY_YOUR_ROLE:
      "为了向您提供准确的操作指引，请先选择您的角色",
    IF_UR_CLINIC_OWNER: "如果您是一名诊所负责人 / 个体户",
    IF_UR_CLINIC_OWNER_CREATE_UR_CLINIC:
      "如果您是诊所负责人 / 个体户，请创建您的诊所及相关信息。后续您可以邀请其他诊所工作人员加入您的诊所。",
    IF_UR_CLINIC_PRACTITIONER: "如果您是一名诊所工作人员",
    IF_UR_CLINIC_PRACTITIONER_SEARCH_FOR_THE_CLINIC_YOU_WISH_TO_JOIN_AND_SUBMIT_A_JOIN_REQUEST:
      "如果您是医师，请搜索您要加入的诊所名称，然后申请加入该诊所。",
    SKIP_USER_GUIDE: "跳过用户指南",
    USER_GUIDE_WILL_GUIDE_THROUGH_HOW_AND_WHERE_TO_CREATE_JOIN_A_CLINIC:
      "用户指南将引导您如何创建或加入诊所。",
    START_NOW: "立即开始",
    ACCEPT_INVITE: "接受邀请",
    ARE_YOU_SURE_TO_ACCEPT_INVITE: "确定要接受此诊所的邀请吗？",
    REJECT_INVITE: "拒绝邀请",
    ARE_YOU_SURE_TO_REJECT_INVITE: "确定要拒绝此诊所的邀请吗？",
    RESPONSE_SUCCESS: "响应成功",
    JOIN_REQUEST_SENT: "加入请求已发送",
    SEND_JOIN_REQUEST: "请求加入诊所",
    JOIN_REQUEST_SENT_SHORT: "已请求",
    REQUEST_ACCEPTED: "请求已接受",
    INVITATION_SENT: "邀请已发送",
    NO_PACKAGES: "没有可用的套餐",
    X_PRACTITIONERS_ARE_NOW_INACTIVE: "有{{X}}位医生已被设为不活跃",
    ACTIVE_CONFIRM: "激活确认",
    ACTIVATE: "激活",
    INACTIVE_CONFIRM: "不活跃确认",
    ARE_YOU_SURE_TO_INACTIVE: "你确定要设为不活跃吗？",
    INACTIVE_PRACTITIONERS_ARE_NOT_ALLOWED_TO_BE_BOOKED_BY_PATIENT:
      "不活跃的医生不能被患者预约",
    REJECTED: "已拒绝",
    RESUBMIT: "重新提交",
    DELETE_APPLICATION: "删除申请",
    ARE_YOU_SURE_TO_DELETE_THIS_APPLICATION: "你确定要删除此申请吗",
    REBUILD_CLINIC: "重新提交诊所",
    DELETE_APPLICATION_SUCCESS: "申请删除成功",
    SEARCH_CLINIC_BY_NAME: "按名称搜索诊所",
    OTHER_PRACTITIONERS_ARE_NO_VISIBLE: "其他医生对非本诊所工作者不可见",
    DECLINE_JOIN_INVITATION_CONFIRM: "确认拒绝加入邀请",
    ARE_YOU_SURE_TO_CANCEL_QUIT_FROM_CLINIC: "你确定要取消退出诊所吗？",
    SECTION_UNPUBLISHED: "模块未发布",
    SECTION_PUBLISHED: "模块已发布",
    REFRESH: "刷新",
    CHANGE_THIS_BOOKING_DURATION: "更改此预约时长",
    ARE_YOU_SURE_TO_CHANGE_THIS_APPOINTMENT_DURATION_FOR_X:
      "你确定要更改此预约的时长（针对 {{X}} ）吗？",
    BOOKING_DURATION_ADJUST_SUCCESS: "预约时长调整成功",
    NO_PENDING_APPOINTMENTS: "没有待定预约",
    ASSIGN_OWNERSHIP: "设为诊所共同负责人",
    STOP_BEING_CLINIC_OWNER: "退出诊所负责人身份",
    CONFIRM_TO_ADD_CLINIC_CO_OWNER: "确认将 {{name}} 设为诊所共同负责人吗？",
    CLINIC_CO_OWNER_ADDED_SUCCESS: "已添加诊所共同负责人",
    TRANSFER_OWNERSHIP: "转让诊所负责人身份",
    CONFIRM_TO_TRANSFER_CLINIC_OWNERSHIP: "确认将诊所负责人身份转让给 {{name}} 吗？",
    CLINIC_OWNERSHIP_TRANSFERRED_SUCCESS: "诊所负责人身份转让成功",
    TRANSFER_OWNERSHIP_AND_QUIT_CLINIC: "转让负责人身份并退出诊所",
    SELECT_A_SUCCESSOR_TO_TRANSFER_OWNERSHIP_AND_QUIT_HINT: "请选择一位医师转让诊所负责人身份。转让成功后，您将退出该诊所。",
    CLINIC_OWNERSHIP_TRANSFERRED_AND_QUIT_SUCCESS: "已转让负责人身份并退出诊所",
    CONFIRM_TO_EXIT_CLINIC_OWNERSHIP: "确认退出 {{name}} 的负责人身份吗？",
    EXIT_CLINIC_OWNERSHIP_SUCCESS: "已退出诊所负责人身份",
    CANNOT_EXIT_OWNERSHIP_NO_OTHER_OWNER: "该诊所目前只有你一位负责人，无法退出，如需停止运营请选择「关闭诊所」",
    ARE_YOU_SURE_TO_ASSIGN_OWNERSHIP_TO: "你确定要将负责人身份分配给",
    YOU_WILL_BE_LOST_ALL_OWNER_PERMISSIONS_IN_THIS_CLINIC:
      "你将失去该诊所的负责人权限",
    ACTIONS_REQUIRED_OWNER_PERMISSION: "此操作需要负责人权限",
    SUBSCRIBE_PACKAGE_TO_UNLOCK_FEATURE: "订阅相应套餐即可启用该功能",
    FEATURE_LOCKED: "暂无该功能权限",
    PAY_SUCCESSFUL: "支付成功",
    OWNER_CHANGED: "负责人已变更",
    VIEW_PATIENT_INFO: "查看患者信息",
    CLINIC_QR_CODE: "诊所二维码",
    APPOINTMENT_QR_CODE: "预约二维码",
    DOWNLOAD: "下载",
    SIGNATURE: "签名",
    MANAGE_YOUR_SIGNATURE: "管理您的签名",
    UPLOAD_SIGNATURE_FROM_DEVICE: "从设备上传签名图片",
    VIEW_SIGNATURE: "查看签名",
    SIGNATURE_USAGE_MSG: "签名将用于处方开立时的自动签署。",
    UPLOAD_SIGNATURE_CONSENT:
      "上传签名即表示您同意 Healthnex 系统在相关场景中使用该签名。",
    ARE_YOU_SURE_TO_CLEAR_ALL_SELECTED_ITEMS:
      "您确定要清除所有已选择的项目吗？",
    RECORD_VIDEO: "录制视频",
    NO_RESULTS_FOUND: "未找到结果",
    PRESS_ENTER_TO_CREATE: "按 Enter 键创建",
    CREATING: "正在创建",
    CREATE_CLINIC_ITEM: "创建诊所条目",
    NAME_CN: "中文名称",
    NAME_EN: "英文名称",
    CREATE: "创建",
    YOU_CAN_EDIT_THIS_LATER:
      "现在只需要填写一个名称。您可以稍后在「诊所资源管理」中完善此条目的详细信息。",
    OPTION: "选项",
    CONFIGURE_CLINIC_OPTION: "配置诊所选项",
    CLINIC_OPTIONS: "诊所选项",
    OPTION_ITEM_INFO: "选项项目信息",
    ADD_ITEM: "添加项目",
    X_HAS_BEEN_ADDED: "{{X}} 已添加",
    ALL_HERBS_IN_X_HAS_ADDED: "已添加 {{X}} 中的所有药材",
    PLZ_INPUT_ITEM_NAME_CN: "请输入中文名称",
    PLZ_INPUT_ITEM_NAME_EN: "请输入英文名称",
    PLZ_INPUT_ITEM_NAME_X: "请输入{{X}}名称",
    SEARCH_OPTION_ITEM_NAME: "搜索选项项目名称",
    SIGN_AND_UPLOAD: "签名并上传",
    DRAW_YOUR_SIGNATURE: "手写签名",
    SIGNATURE_UPLOADED: "签名已上传",
    SIGNATURE_DELETED: "签名已删除",
    NO_RECORDS_FOUND: "未找到记录",
    CLINIC_POINT_GROUPS: "诊所穴位分组",
    CONFIGURE_CLINIC_POINT_GROUPS: "配置诊所穴位分组",
    ADD_POINT_GROUP: "添加穴位分组",
    ALL_POINTS_IN_X_HAS_ADDED: "已添加 {{X}} 中的所有穴位",
    POINT_GROUPS_NAME: "分组名称",
    POINT_GROUPS_NAME_IN_X: "分组名称({{X}})",
    POINT_GROUP_INFO: "分组信息",
    PLZ_INPUT_POINT_GROUP_NAME_CN: "请输入分组中文名称",
    PLZ_INPUT_POINT_GROUP_NAME_EN: "请输入分组英文名称",
    PLZ_INPUT_POINT_GROUP_NAME_X: "请输入分组{{X}}名称",
    SEARCH_POINT_NAME_HERE: "在此搜索穴位名称",
    POINTS_IN_THIS_GROUP: "该分组包含的穴位",
    ADD_TO_CLINIC_POINT_GROUPS: "添加到诊所穴位分组",
    NO_POINT_ADDED: "尚未添加穴位",
    CONTINUE: "继续",
    REMOVE_PRACTITIONER_SUCCESS: "医师已成功移除",
    SEARCHING_CLINICS: "正在搜索诊所...",
    INVITE_SUCCESS: "邀请已成功发送",
    ITEM_CREATED: "项目已创建",
    PRACTITIONER_QUIT_REJECTED: "医师离职申请已被拒绝",
    PRACTITIONER_QUIT_ACCEPTED: "医师离职申请已被接受",
    PLEASE_ADD_AT_LEAST_ONE_HERB: "请至少添加一种药材",
    PLEASE_ADD_AT_LEAST_ONE_POINT: "请至少添加一个穴位",
    INSURANCE_INFO_UPDATED: "保险信息已更新",
    REPORTING: "报表",
    CHECK_YOUR_REPORTING: "查看你的报表",
    CLINIC_REPORTING: "诊所报表",
    CHECK_YOUR_CLINIC_REPORTING: "查看诊所报表",
    SELECT_DEFAULT_DATE_UNIT: "选择默认时间单位",
    DAY: "日",
    MONTH: "月",
    YEAR: "年",
    PATIENTS_AND_REVENUE: "就诊人数 & 收入",
    PATIENTS: "就诊人数",
    REVENUE: "收入",
    PEOPLE_UNIT: "人",
    AVERAGE_REVENUE: "平均收入",
    PLEASE_SELECT_VALID_DATE_RANGE_90_DAYS: "请选择不超过90天的有效日期范围",
    PLEASE_SELECT_VALID_DATE_RANGE_36_MONTHS:
      "请选择不超过36个月的有效日期范围",
    PLEASE_SELECT_VALID_DATE_RANGE_10_YEARS: "请选择不超过10年的有效日期范围",
    PRINT_INSTRUCTION: "下载处方",
    PRINT_TCM_INSTRUCTION: "下载中药处方",
    PRINT_MASSAGE_INSTRUCTION: "下载穴位说明",
    MAXIMUM_NUMBER_OF_USERS: "达到订阅人数上限",
    HERB_WITH_ZERO_RAW_EXISTS_PLS_CHECK: "药量不能为零，请核对处方。",
    NO_GST: "（不含GST）",
    INC_GST: "（含GST）",
    PRESCRIPTION_RECORDS: "开方记录",
    CLINIC_SERVICES: "诊所服务",

    LOADING_SERVICES: "正在加载服务",
    AND_OTHER_COUNT: "和其他{{count}}个",
    WHO_IS_THIS_APPOINTMENT_FOR: "这个预约是为谁进行的？",
    MYSELF: "我自己",
    SOMEONE_ELSE: "其他人",
    ABOUT_YOU: "关于您",
    ABOUT_THE_PATIENT: "关于病人",

    PREVIOUS: "上一步",

    APPROVED: "已同意",

    I_AGREE_TO_RECEIVE_SMS: "我同意接收关于此预约的短信通知。",
    I_AGREE_TO_RECEIVE_SMS_EMAIL: "我同意接收关于此预约的短信或者邮件通知。",
    SELECT_PRACTITIONER: "选择医师",
    CREATE_APPOINTMENT: "创建预约",
    ADD_APPOINTMENT: "创建预约",
    NO_AVAILABLE_CLINIC: "没有可用的诊所",
    NO_SERVICES_AVAILABLE: "没有可用的服务",
    IS_ALREADY_BOOKED: "已被他人预约",
    TIME_ALREADY_BOOKED: "该时间已被他人预约",
    YOU_NEED_TO_WAIT_FOR_THE_PRACTITIONER_TO_CONFIRM:
      "该预约将触发超额预约，但由于由您（医师）创建，系统会自动批准。",
    ARE_YOU_SURE_YOU_WANT_TO_BOOK_THIS_TIME: "您确定要预约这个时间吗？",
    PLEASE_SELECT_AT_LEAST_ONE_SERVICE: "请选择至少一项服务",
    May: "五月",
    June: "六月",
    July: "七月",
    August: "八月",
    September: "九月",
    October: "十月",
    November: "十一月",
    December: "十二月",
    January: "1月",
    February: "2月",
    March: "3月",
    April: "4月",
    Mon: "周一",
    Tue: "周二",
    Wed: "周三",
    Thu: "周四",
    Fri: "周五",
    Sat: "周六",
    Sun: "周日",
    Jan: "1月",
    Feb: "2月",
    Mar: "3月",
    Apr: "4月",
    Jun: "6月",
    Jul: "7月",
    Aug: "8月",
    Sep: "9月",
    Oct: "10月",
    Nov: "11月",
    Dec: "12月",
    REMEDIAL_MASSAGE: "康复推拿",
    REMEDIAL_MASSAGE_OPTION: "康复推拿 (Remedial Massage)",
    DEEP_TISSUE_MASSAGE: "深层组织推拿",
    SPORTS_MASSAGE: "运动推拿",
    DRY_NEEDLING: "干针",
    CUPPING: "拔罐",
    PREGNANCY_MASSAGE: "孕妇推拿",
    MYOTHERAPY: "肌肉疼痛治疗",
    ASSISTED_STRETCHING: "辅助拉伸",
    TRIGGER_PT_THERAPY: "刺痛点治疗",
    MYOFASCIAL_RELEASE: "筋膜松解",
    JOINT_MOBILISATION: "关节松动术",
    PHYSIO: "物理治疗",
    CHIRO: "脊椎治疗",
    BEAUTY: "美容",
    COSMETIC_MEDICINE: "医美",
    SELECT_SERVICE: "选择 {{service}} 服务",
    MAXIMUM_NUMBER_OF_FILES: "已达到文件数量上限（最多 {{X}} 个）",
    MULTIPLE_SELECT: "多选",
    CANCEL_MULTIPLE_SELECT: "取消多选",
    ARE_YOU_SURE_TO_DELETE_THIS_APPOINTMENT_FOR_X:
      "确定要删除 {{X}} 的预约吗？系统将向患者发送取消通知。",
    DELETE_APPOINTMENT: "删除预约",
    REJECT_APPOINTMENT: "拒绝预约",
    SYSTEM_OPTIMIZED_FOR_DESKTOP: "本系统已针对桌面端进行优化。",
    RECOMMEND_DESKTOP_FOR_BEST_EXPERIENCE:
      "为了获得最佳体验，建议通过桌面端访问本网站。",
    PROMOTION_CODE: "促销码",
    PLEASE_SELECT_VALID_DATE_RANGE: "请选择有效的日期范围",
    PLEASE_CHECK_THE_FORM: "请检查表单",
    TIMESLOT_HAS_BOOKED_BY_OTHER_PATIENT: "此时间段已被另一个患者预约。",
    NO_AVAILABLE_TIMESLOT_FOUND_IN_THIS_DATE: "该日期暂无可预约时间",
    APPOINTMENT_SCHEDULE_APPROVED: "预约已批准",
    FORGOT_PASSWORD: "忘记密码",
    WE_SENT_VERIFY_CODE_PLEASE_CHECK_YOUR_SMS: "验证码已发送，请检查短信。",
    SEND_VERIFY_CODE: "发送验证码",
    RESEND_VERIFY_CODE: "重新发送验证码",
    PLEASE_ENTER_YOUR_VERIFICATION_CODE: "请输入验证码",
    VERIFICATION_CODE: "验证码",
    PLEASE_ENTER_YOUR_NEW_PASSWORD: "请输入新密码",
    PLEASE_ENTER_YOUR_NEW_PASSWORD_AGAIN: "请再次输入新密码",
    NEW_PASSWORD: "新密码",
    SEND_TO: "发送至",
    OR: "或",
    WE_WILL_SEND_VERIFY_CODE_PLEASE_CHECK_YOUR_SMS:
      "我们将发送验证码，请检查短信。",
    WRONG_VERIFY_CODE: "验证码错误。",
    SMS_SEND_TOO_FREQUENT_WAIT_3_MIN_RETRY:
      "短信发送过于频繁，请在 3 分钟后重试。",
    USERNAME_NOT_FOUND: "未找到用户名对应信息，请检查输入是否正确。",
    CHANGE_PASSWORD_SUCCESS: "密码修改成功",
    SMS_SENT: "短信已发送",
    REQUEST_REJECTED: "请求已被拒绝",
    INVITED_SUCCESS: "邀请已成功发送",
    CONTINUE: "继续",
    VIP_PACKAGE_EXPIRED: "您的 VIP 套餐已失效或者过期，暂无权限查看该页内容",
    RECORDING_TOO_SHORT: "录音时间过短，无法获取信息！",
    TRANSCRIPT_EMPTY_TRY_AGAIN: "内容为空，请重试。",
    MORNING: "上午",
    AFTERNOON: "下午",
    DOWNLOAD_INVOICE: "下载发票",
    OTHER_PHOTO: "其他照片",
    DIAGNOSIS_DESCRIPTION: "描述",
    SET_AS_HOME: "设为首页",
    SEARCH_AND_USE_EXISTING_PATIENT_INFO: "搜索并使用现有患者信息",
    APPOINTMENT_DETAILS: "预约信息",
    OP_TYPE: "选项类型",
    CANCEL_INVITATION: "取消邀请",
    ARE_U_SURE_TO_CANCEL_THIS_INVITATION: "你确定要取消此邀请吗？",
    ARE_YOU_SURE_TO_DELETE_X_ITEMS: "你确定要删除 {{X}} 个项目吗？",
    PROFILE: "个人信息",
    UPDATE: "更新",
    PROFILE_UPDATED: "个人信息已更新",
    INVITE_PRACTITIONER_TO_JOIN_CLINIC:
      "你搜索的医师或许还不是我们的用户，点击下面按钮邀请该医师创建账号并加入诊所。",
    PRACTITIONER_U_SEARCHED_MAY_NOT_BE_USER_YET:
      "您搜索的医师暂未加入我们的系统。",
    CLICK_BUTTON_BELOW_TO_INVITE:
      "点击下方按钮，快速邀请医师注册并加入您的诊所吧！",
    INVITE_NEW_USER: "邀请新用户",
    NEW_REQUESTS: "待处理的请求",
    PLZ_SIGN_IN: "请先登录",
    SELECT_YOUR_SPECIALTY: "请选择你的服务类别",
    EXPIRED_AT: "过期时间",
    PENDING_USER_SIGNUP: "等待用户注册",
    RESEND_EMAIL: "再次发送邮件",
    RESEND_EMAIL_SUCCESS: "邮件发送成功",
    DAYS_LEFT_X: "剩余{{X}}天",
    ASSIGN_A_PACKAGE: "为该医师分配套餐",
    ASSIGN_A_ROLE: "分配角色",
    PATIENT_CONSENT: "患者同意書",
    PLEASE_SELECT_A_PACKAGE: "请选择套餐",
    REJECT_SUCCESS: "已拒绝请求",
    ACCEPT_SUCCESS: "已接受请求",
    ARE_YOU_SURE_TO_DELETE_THIS_TEST: "你确定要删除此检查吗？",
    FILE_TOO_LARGE_MAX_100MB: "文件过大，单个文件大小不能超过 100MB。",
    BEST_UPLOAD_PRACTICE:
      "为了最佳使用体验，单个文件大小不超过100MB，录制的视频最好在30秒之内。",
    REVIEW_REVIEW: "总览",
    CAN_NOT_START_WITH_NUMBER: "不能以数字开头",
    PACKAGE_NAME: "订阅服务",
    OG_PRICE: "原价",
    INSURANCE_NAME: "保险公司名称",
    USER_ALREADY_BEEN_TAKEN: "用户名已被占用，请尝试其他用户名。",
    INVALID_FORMAT:
      "用户名可能存在违规字符（如用户名不允许以数字开头或包含了空格）",
    LOGIN_USERNAME: "登录用户名",
    CONNECT_FAILED: "无法连接到 AI 服务",
    CONNECTING_AI: "正在连接 AI",
    U_CAN_NOW_START_SPEAKING: "你现在可以开始说话了",
    UNIT_NO_SHOP_NO: "门牌号/门店号",
    STREET_NO: "街道号",
    STREET_NAME: "街道名称",
    CLINIC_NAME_IS_REQUIRED: "诊所名称是必填项",
    CLINIC_CREATED: "诊所创建成功",
    PERSONAL_WEB: "个人网站",
    SLUG_CHAR_TYPE_LIMIT: "只允许使用英文、数字和 ‘-’ 符号",
    CHECK_THIS_CLINIC_PACKAGES: "查看此诊所目前套餐",
    TYPE_TO_SEARCH: "输入以搜索",
    PLEASE_ENTER_VALID_PHONE_NUMBER: "请输入有效的手机号码",
    NO_AVAILABLE_PACKAGES: "未找到可用的套餐",
    PLEASE_PURCHASE_PACKAGE_FIRST: "请先购买VIP套餐再邀请用户",
    PLEASE_PURCHASE_PACKAGE_FIRST_TO_APPROVE_PRACTITIONER_TO_JOIN: "请先购买套餐，才能批准该医师加入",
    ASSIGNED_TO: "分配给",
    PERSONAL: "个人用户（我）",
    RECEIPT_GENERATING: "收据生成中",
    RECEIPT_GENERATING_PLZ_WAIT: "正在生成收据，请稍等",
    INSTRUCTION_GENERATING: "正在生成处方",
    STREET_TYPE: "街道类型",
    SUMMARY: "审核并提交",
    FEATURE_PREVIEW_VIDEO_NOTE:
      "本视频仅用于功能展示，购买对应的 VIP 套餐即可解锁并使用该功能。",
    FEATURE_PURCHASE_HINT_FOR_CLINIC_OWNER:
      "如果您是诊所负责人 (Business Owner)，请点击下方按钮购买套餐。",
    TODAY: "今天",
    CLOSED_TODAY: "今日不在此诊所",
    GENERATING_NEW_WINDOW_MSG:
      "文件将会在新窗口打开，请检查浏览器设置，允许打开新窗口或弹出窗口。",
    DISCONNECTED_SUCCESSFULLY: "已成功断开连接",
    PATIENT_VISIT_FLOW: "患者就诊流程教程",
    PATIENT_CHECKIN_AND_VISIT:
      "介绍患者到诊时的完整流程，包括有预约与无预约两种情况，以及患者签到、建档和进入问诊的方式。",
    SYSTEM_SETTING_SUMMARY: "系统设置概览教程",
    SYSTEM_SETTING_OVERVIEW: "Healthnex 主要配置功能和入口的快速概览。",
    SYSTEM_SETTING_WORK_TIME_SETTING: "系统设置 - 工作时间设置教程",
    SYSTEM_SETTING_WORKTIME:
      "关于如何在系统中设置和管理医师工作时间安排的分步指南。",
    APPOINTMENT_SUMMARY: "预约概览教程",
    APPOINTMENT_SUMMARY_DESCRIPTION:
      "介绍 Healthnex 中预约的工作原理及其多种创建方式。",
    APPOINTMENT_CREATE: "预约 - 创建预约教程",
    HOW_TO_CREATE_APPOINTMENT:
      "关于如何为患者创建预约的分步指南，包括选择服务、医师和时间段。了解如何通过医师门户、个人网站或 Healthnex 首页创建预约。",
    APPOINTMENT_MANAGE: "预约 - 管理预约教程",
    VIEW_EDIT_CANCEL_APPOINTMENT:
      "了解如何在 Healthnex 系统中查看、编辑、重新安排和取消预约。",
    PRESCRIPTION_SUMMARY: "处方概览教程",
    PRESCRIPTION_SUMMARY_DESCRIPTION:
      "智能问诊和处方工作流程及其五个主要步骤的概览。",
    PRESCRIPTION_SYMPTOM: "处方 - 症状教程",
    PRESCRIPTION_SYMPTOM_DESCRIPTION:
      "使用语音或文本快速记录患者症状，借助 AI 辅助进行结构化和翻译。",
    PRESCRIPTION_DIAGNOSIS: "处方 - 诊断教程",
    PRESCRIPTION_DIAGNOSIS_DESCRIPTION:
      "记录临床评估，选择治疗原则，生成标准化诊断内容。",
    PRESCRIPTION_TREATMENT: "处方 - 治疗教程",
    PRESCRIPTION_TREATMENT_DESCRIPTION:
      "选择治疗方法，如中药或针灸，完成处方，并保存可重复使用的诊所模板。",
    PRESCRIPTION_PAYMENT: "处方 - 付款教程",
    PRESCRIPTION_PAYMENT_DESCRIPTION:
      "审核费用，适用时使用保险，并完成就诊付款。",
    PRESCRIPTION_CONCLUSION: "处方 - 结论教程",
    PRESCRIPTION_CONCLUSION_DESCRIPTION:
      "审核完整的病历，打印处方和收据，完成就诊。",
    PERSONAL_WEBSITE_SUMMARY: "个人网站概览教程",
    PERSONAL_WEBSITE_OVERVIEW:
      "医师个人网站的概览，包括个人资料部分和预约功能。",
    EDIT_AND_PUBLISH: "个人网站 - 编辑和发布教程",
    EDIT_AND_PUBLISH_WEBSITE:
      "关于如何编辑个人网站内容、预览布局并发布以供患者预约的分步指南。",
    PATIENT_VISIT_FLOW: "患者就诊流程教程",
    PATIENT_CHECKIN_AND_VISIT:
      "介绍患者到诊时的完整流程，包括有预约与无预约两种情况，以及患者签到、建档和进入问诊的方式。",
    SYSTEM_SETTING_SUMMARY: "系统设置概览教程",
    SYSTEM_SETTING_OVERVIEW: "Healthnex 主要配置功能和入口的快速概览。",
    SYSTEM_SETTING_WORK_TIME_SETTING: "系统设置 - 工作时间设置教程",
    SYSTEM_SETTING_WORKTIME:
      "关于如何在系统中设置和管理医师工作时间安排的分步指南。",
    APPOINTMENT_SUMMARY: "预约概览教程",
    APPOINTMENT_SUMMARY_DESCRIPTION:
      "介绍 Healthnex 中预约的工作原理及其多种创建方式。",
    APPOINTMENT_CREATE: "预约 - 创建预约教程",
    HOW_TO_CREATE_APPOINTMENT:
      "关于如何为患者创建预约的分步指南，包括选择服务、医师和时间段。了解如何通过医师门户、个人网站或 Healthnex 首页创建预约。",
    APPOINTMENT_MANAGE: "预约 - 管理预约教程",
    VIEW_EDIT_CANCEL_APPOINTMENT:
      "了解如何在 Healthnex 系统中查看、编辑、重新安排和取消预约。",
    PRESCRIPTION_SUMMARY: "处方概览教程",
    PRESCRIPTION_SUMMARY_DESCRIPTION:
      "智能问诊和处方工作流程及其五个主要步骤的概览。",
    PRESCRIPTION_SYMPTOM: "处方 - 症状教程",
    PRESCRIPTION_SYMPTOM_DESCRIPTION:
      "使用语音或文本快速记录患者症状，借助 AI 辅助进行结构化和翻译。",
    PRESCRIPTION_DIAGNOSIS: "处方 - 诊断教程",
    PRESCRIPTION_DIAGNOSIS_DESCRIPTION:
      "记录临床评估，选择治疗原则，生成标准化诊断内容。",
    PRESCRIPTION_TREATMENT: "处方 - 治疗教程",
    PRESCRIPTION_TREATMENT_DESCRIPTION:
      "选择治疗方法，如中药或针灸，完成处方，并保存可重复使用的诊所模板。",
    PRESCRIPTION_PAYMENT: "处方 - 付款教程",
    PRESCRIPTION_PAYMENT_DESCRIPTION:
      "审核费用，适用时使用保险，并完成就诊付款。",
    PRESCRIPTION_CONCLUSION: "处方 - 结论教程",
    PRESCRIPTION_CONCLUSION_DESCRIPTION:
      "审核完整的病历，打印处方和收据，完成就诊。",
    PERSONAL_WEBSITE_SUMMARY: "个人网站概览教程",
    PERSONAL_WEBSITE_OVERVIEW:
      "医师个人网站的概览，包括个人资料部分和预约功能。",
    EDIT_AND_PUBLISH: "个人网站 - 编辑和发布教程",
    EDIT_AND_PUBLISH_WEBSITE:
      "关于如何编辑个人网站内容、预览布局并发布以供患者预约的分步指南。",
    RESET_PASSWORD: "重置密码",
    PLEASE_ENTER_YOUR_CURRENT_PASSWORD: "请输入当前密码",
    PLEASE_ENTER_DIFFERENT_PASSWORD: "新旧密码重复",
    CONFIG_PRINT_UNIT_IN_EACH_CMT:
      "注意：药量的打印单位将应用每个中药方中的设置。",

    AT_LEAST_ONE_PRINT_OPTION_REQUIRED: "至少选择一种展示单位。",

    CHECKBOX_SHOW_RAW_UNIT_IN_PRINT: "勾选以在打印时展示生药量。",

    CHECKBOX_SHOW_GRAN_UNIT_IN_PRINT: "勾选以在打印时展示颗粒计量。",
    SHOW_RAW_UNIT_IN_PRINT: "打印时显示生药单位",
    HIDE_RAW_UNIT_IN_PRINT: "打印时隐藏生药单位",

    SHOW_GRAN_UNIT_IN_PRINT: "打印时显示颗粒计量",
    HIDE_GRAN_UNIT_IN_PRINT: "打印时隐藏颗粒计量",

    CONNECTION_FAILED: "连接失败",
    PURCHASED_AT: "购买时间",
    SELECTED: "已选择",
    PERSONALIZATION: "个性化",
    PERSONALIZE_YOUR_SYSTEM: "个性化您的系统",
    APPOINTMENT_TIMESLOT_STYLE: "预约时间段样式",
    DROPDOWN_STYLE: "下拉样式",
    SLIDE_STYLE: "按钮样式",
    PERSONALIZE_YOUR_TIMESLOT_STYLE: "个性化您的时间段样式",
    FORM_HAS_NOT_BEEN_SAVED_U_SURE_LEAVE_NOW: "表单尚未保存，确定离开？",
    PAGE_NOT_FOUND: "未找到请求页面",
    THE_REQUESTED_PAGE_COULD_NOT_BE_LOCATED:
      "很抱歉，系统无法找到您请求的页面。",
    WE_COULDNT_FIND_THE_PAGE_YOU_ARE_LOOKING_FOR_IT_MAY_HAVE_BEEN_MOVED_DELETED_OR_THE_URL_MIGHT_BE_INCORRECT:
      "该页面可能已被移除、重命名，或当前访问的地址不正确。",
    WHAT_YOU_CAN_DO: "您可以尝试以下操作",
    CHECK_THE_URL_FOR_TYPOS_AND_TRY_AGAIN: "检查地址栏中的 URL 是否输入正确",
    USE_THE_NAVIGATION_MENU_TO_FIND_WHAT_YOU_NEED:
      "通过系统导航返回并查找相关页面",
    CONTACT_SUPPORT_IF_THE_PROBLEM_PERSISTS:
      "如果问题仍然存在，请联系系统管理员或技术支持",
    NEED_ASSISTANCE_CONTACT_SYSTEM_SUPPORT:
      "需要帮助？请通过Healthnex官网联系我们",
    GO_TO_LOGIN: "跳转到登录",
    CUSTOMER_SERVICE: "联系客服",
    TECHNICAL_SUPPORT: "技术支持",
    PATIENT_LIST: "患者列表",
    CREATED_AT: "创建时间",
    FILTER_BY_LAST_NAME: "按姓氏筛选",
    VIEW_PATIENT_INFO: "查看患者信息",
    THIS_IS_A_X_USER_PACKAGE: "{{X}}人套餐",
    THIS_IS_A_X_USER_PACKAGE_MSG: "该套餐为 {{X}} 人打包价格，已包含组合优惠。",
    X_USERS_PER_YEAR: "{{X}}人 / 年",
    X_USERS_PER_Y_YEAR: "{{X}}人 / {{Y}}年",
    X_USERS_PER_MONTH: "{{X}}人 / 月",
    SECTION_CHANGED_TO: "已切换到",
    TOTAL_PATIENTS: "患者总数",
    OTHER_NON_ENGLISH_PATIENT_FIRST_NAME: "其他非英文姓氏",
    WELCOME_TO_HEATHNEX: "欢迎使用 Healthnex!",
    THIS_PLATFORM_IS_DESIGNED_TO_PROVIDE_A_MODERN_AND_EFFICIENT_WAY_TO_MANAGE_YOUR_CLINIC_PRESCRIPTION:
      "Healthnex 是一款现代化的临床管理平台，旨在简化处方流程，提升诊所日常运营效率。",
    ALSO_AIMS_TO_BUILD_ALL_IN_ONE_PLATFORM_FOR_MODERN_TCM_PRACTICES:
      "系统专为中医（TCM）临床实践打造，将处方管理、治疗方案及病历记录整合于同一平台，帮助医生更专注于诊疗本身。",
    TO_START_LET_US_QUICK_INTRODUCE_WUT_WE_HAVE_IN_THIS_SYSTEM:
      "下面将为您简要介绍系统功能。",
    SYSTEM_NOTICE: "系统提示",
    THIS_REQUIRED_U_TO_HAVE_CLINIC_PACKAGE_SUBSCRIPTION:
      "订阅诊所套餐可立即享受此功能。",
    CURRENT_WORKING_CLINIC: "当前工作诊所",
    IF_U_WORKING_IN_MULTIPLE_CLINICS_YOU_CAN_SELECT_THE_CURRENT_WORKING_CLINIC_HERE:
      "如果您同时在多家诊所执业，可在此选择当前正在工作的诊所。",
    UR_CURRENT_PACKAGE: "当前订阅套餐",
    PACKAGE_SUBSCRIPTION_ALLOW_YOU_TO_ACCESS_PREMIUM_SERVICE:
      "套餐订阅允许您访问高级服务。例如，诊所套餐支持处方管理及患者管理等功能，而个人网站套餐可用于发布对外公开的个人网站。",
    CHANGE_UR_SYSTEM_LANGUAGE_HERE: "在此设置系统显示语言。",
    ACCOUNT_MENU: "账户菜单",
    U_CAN_VIEW_UPDATE_UR_ACCOUNT_DETAIL_HERE_LIKE_PASSWORD:
      "查看并更新您的账户信息，包括密码和安全设置。",
    VIEW_ALL_UR_PATIENTS_HERE: "在此查看并管理您的诊所下的所有患者。",
    CREATE_JOIN_MANAGE_UR_CLINIC_HERE: "创建、加入或管理您的诊所。",
    CONFIGURE_WORKING_TIME_IN_CLINIC_FOR_PATIENT_TO_SCHEDULE_APPOINTMENT:
      "在设置诊所的工作时间，供患者预约就诊。",
    THIS_REQUIRED_U_TO_HAVE_PERSOANL_WEBSITE_PACKAGE_SUBSCRIPTION_TO_PUBLISH:
      "发布个人网站需订阅个人网站套餐。",
    MORE_TUTORIALS_TO_FOLLOW: "更多教程",
    ALTERNATIVELY_HERE_YOU_CAN_FIND_MORE_TUTORIALS_TO_FOLLOW_ABOUT_HOW_TO_USE_THIS_PLATFORM_IN_DETAIL:
      "此处您可以找到有关如何使用此平台的更多教程。",
    VER: "版本号：",
    URL_NOT_SET: "URL未设置",
    TCM_MODE: "详细诊断模式",
    ACUPUNCTURE_MASSAGE_MEDICINE_MODE: "针灸/推拿模式",
    THIS_PACKAGE_IS_NOT_LONGER_PROVIDED_PLS_CHOOSE_ANOTHER_PACKAGE:
      "该套餐已下架，暂不支持续订",
    LOADING_PACKAGES: "正在获取套餐",
    OWNER_BUSINESS_SIGNUP: "负责人 (Business Owner)",
    CMBA_INFO: "CMBA 信息",
    CMBA_NUMBER: "CMBA 号码",
    PLEASE_ENTER_YOUR_CMBA_NUMBER_HERE: "请在此处输入您的 CMBA 号码",
    NOTE_YOUR_CMBA_NUMBER_WILL_BE_SHOWN_ON_THE_MEDICAL_INVOICE:
      "注意：您输入的 CMBA 号码将显示在您的处方收据上。",
    UPDATING_CMBA_INFO: "正在更新 CMBA 信息",
    CMBA_INFO_UPDATED: "CMBA 信息已更新",
    PLEASE_ENTER_YOUR_CMBA_NUMBER: "请在此输入您的 CMBA 号码",
    U_CAN_ENTER_MODIFY_UR_CMBA_NUMBER_HERE:
      "您可以在此填写或修改您的 CMBA 号码",
    VIEW_EDIT_INSURANCE: "查看 / 编辑保险信息",
    IF_U_NEED_TO_RENEW_PLS_CONTACT_CLINIC_OWNER:
      "如果您需要续订或订阅新套餐，请联系诊所负责人 (Business Owner)。",
    INVITE_U_TO_JOIN_THE_CLINIC: "邀请您加入诊所",
    U_HAD_LEFT_FROM_BELOW_CLINICS: "您已离开以下诊所",
    GO_CLINIC: "在诊所中查看",
    FROM_X_CLINIC: "来自{{X}}",
    CREATED_IN_CLINIC: "创建于诊所",
    PLEASE_SELECT_A_PACKAGE_FOR_THIS_PRACTITIONER: "请为这个新成员分配个套餐：",
    NEW_DURATION: "时长",
    OTHER_PHONE: "其他电话",
    GST_INCLUDED: "包含GST",
    SHOW_GST_DETAIL: "显示GST详情",
    COLLAPSE: "收起",
    THIS_PRICE_INCLUDES_GST: "此价格包含GST",
    FILTER_BY_INSURANCE_PROVIDER: "按医保筛选",
    FILTER_BY_COMPLETION_STATUS: "按完成状态筛选",
    PATIENT_INSURANCES: "患者当前医保",
    OTHER_PROVIDERS: "其他医保",
    WELCOME_BACK: "欢迎回来",
    CREATED_IN: "创建于",
    COLLAPSE_NAVIGATION: "收起导航",
    EXPAND_NAVIGATION: "展开导航",
    PRESCRIPTION_HISTORY: "开方记录",
    SEARCH_HISTORY_BY_ID_OR_PATIENT_NAME: "按病历ID或患者姓名搜索",
    VIEW_ALL_PRESCRIPTION_HISTORIES: "查看当天 / 所有开方记录",
    SEARCH_PACKAGE_BY_ORDER_ID_PACKAGE_NAME: "按订单号或套餐名称搜索",
    ORDER_NUMBER: "订单号",
    FILL_IN_DETAILS: "填写详情",
    NOT_SCHEDULED: "未安排",
    NO_CLINICS_TO_CREATE_OR_JOIN: "未创建或加入任何诊所",
    ACU_POINT_INFO: "穴位详情",
    ACU_POINT_CN: "穴位名称 (中文)",
    ACU_POINT_EN: "穴位名称 (英文)",
    PLZ_INPUT_ACU_POINT_CN: "请填写穴位名称 (中文)",
    PLZ_INPUT_ACU_POINT_EN: "请填写穴位名称 (英文)",
    PLZ_INPUT_ACU_POINT_X: "请填写穴位名称 ({{X}})",
    ADD_ACU_POINT: "添加穴位",
    POINT_CREATED: "穴位已创建",
    ONLY_PAID_HISTORY_WILL_BE_SHOWN_BELOW: "注：仅显示已结账的开方记录",
    ME_ONLY: "仅是我",
    PREFERRED_NAME: "常用名",
    SELECT_PAIN_CONDITION: "选择痛症",
    CLICK_TO_ADD_CONDITION: "点击添加痛症",
    SELECT_CATEGORY_BELOW_TO_ADD_CONDITION: "点击下方分类添加痛症",
    PAIN_CONDITIONS: "痛症",
    SELECT_POINTS_FOR_THIS_TREATMENT: "为这次治疗选择穴位",
    THIS_IS_OPTIONAL: "此步骤为可选，您可以点击按钮跳过此步骤。",
    COMMON_ACU_GROUP_TITLE: "诊所专属穴位分组",
    SEARCH_ACU_GROUP_PLACEHOLDER: "按穴位分组名称搜索",
    NO_ACU_GROUP_FOUND: "未找到穴位组",
    NO_TREATMENT_ADDED: "尚未添加治疗方案",
    TREATMENT_AMOUNT: "开方数量",
    ENTER_TREATMENT: "添加治疗方案",
    CLINIC_GROUP: "诊所专属",
    FROM_RECORD: "来自于病历",
    X_RELATED_RECORDS: "{{X}}条相关记录",
    RELATED_RECORDS: "相关记录",
    REFRESHING: "刷新中",
    CONFIGURE_PRODUCTS: "配置服务项目与产品",
    SYSTEM_ACU_GROUP: "系统默认穴位分组",
    COMPLETED: "已完成",
    IS_RECORD_COMPLETED: "是否完成",
    RECORD_INCOMPLETE: "未完成",
    HIDE_INSTRUCTION: "隐藏说明",
    VIEW_INSTRUCTION: "查看说明",
    HIDE_DETAIL: "隐藏详情",
    PRICE_REQUIRED: "当前价格为0",
    PLEASE_FILL_IN_TREATMENT_PRICE: "请填写价格",
    TREATMENT_SUBTOTAL: "治疗费用小计",
    OTHER_FEE_SUBTOTAL: "其他费用小计",
    POINTS: "穴位",
    TREATMENT_INSTRUCTION: "治疗说明",
    CONFIGURE_CLINIC_POINTS: "配置诊所穴位",
    CLINIC_POINTS: "诊所穴位",
    POINTS_NAME: "穴位名称",
    POINTS_NAME_IN_X: "穴位名称（{{X}}）",
    QUICK_PAY: "快速创建病历",
    TREATMENT_FEE: "治疗费用",
    UPLOAD_PHOTOS: "上传照片",
    CLICK_TO_EXPAND: "点击展开",
    CLICK_TO_COLLAPSE: "点击收起",
    SELECT_TREATMENT_TYPE: "选择治疗类型",
    QUICK_CREATE_TREATMENT: "快速创建治疗方案",
    SELECT_ACU_GROUP: "选择穴位分组",
    SELECT_TREATMENT: "选择治疗方案",
    NO_AVAILABLE_TREATMENT: "当前未配备任何推拿/针灸有关服务类别，请通过 Healthnex 桌面端 → 诊所与人员管理 进行配置",
    FREQUENTLY_USED_ACU_GROUP: "常用穴位分组",
    USED: "使用次数",
    MOST_USED: "最常使用",
    EXPAND: "展开",
    FILTERED_BY_PAID_AT: "结账日期筛选",
    FILTERED_BY_CREATED_AT: "创建时间筛选",
    NO_NEW_PATIENT_CREATED_WITHIN_X: "在 {{X}} 内暂无新患者",
    NO_NEW_PRESCRIPTION_PAID_WITHIN_X: "在 {{X}} 内未产生新的处方结账记录",
    PRODUCT_MANAGEMENT: "产品管理",
    SERVICE: "服务",
    PRODUCT: "产品",
    NO_SERVICE_FOUND: "未添加服务项目",
    NO_PRODUCT_FOUND: "未添加服务产品",
    CREATE_SERVICE_AND_PRODUCT: "添加服务项目和产品",
    CREATE_SERVICE: "添加服务项目",
    CREATE_PRODUCT: "添加服务产品",
    EDIT_SERVICE: "编辑服务项目",
    EDIT_PRODUCT: "编辑服务产品",
    NO_SERVICE_OR_PRODUCT_FOUND:
      "请在左侧选择已有服务查看，或点击下方按钮创建新的服务项目或产品。",
    SERVICE_BASIC_INFO: "服务项目基本信息",
    SERVICE_DESCRIPTION: "服务项目描述",
    NAME_ENGLISH: "名称（英文）",
    NAME_CHINESE: "名称（中文）",
    DESCRIPTION_CHINESE: "描述（中文）",
    DESCRIPTION_ENGLISH: "描述（英文）",
    DETAILS: "详情",
    PRACTITIONERS_PRODUCT_SETTING: "医师分配情况",
    CONFIGURE_PRACTITIONERS_FOR_THIS_PRODUCT: "为此产品配置医师",
    DEFAULT_PRICE: "默认价格",
    ENABLED: "是否启用",
    ENABLE: "是否启用",
    CUSTOM_PRICE: "自定义价格",
    NEW_PRACTITIONERS_ARE_ABLED_BY_DEFAULT: "新添加的医师默认启用",
    CUSTOM_PRICE_OVERRIDES_DEFAULT_PRICE: "自定义价格将覆盖默认价格",
    LEAVE_CUSTOM_PRICE_EMPTY_TO_USE_DEFAULT_PRICE:
      "如果自定义价格留空，将使用默认价格",
    PRODUCT_DESCRIPTION: "服务产品描述",
    NO_MODALITY_SELECTED: "未选择治疗方式",
    SERVICE_INFO: "服务项目信息",
    FIELDS_MARKED_WITH_ASTERISK_ARE_REQUIRED: "带有 * 号的字段为必填项",
    SELECT_MODALITY: "选择治疗方式",
    PLEASE_ENTER_NAME_ENGLISH: "请输入名称（英文）",
    PLEASE_ENTER_NAME_CHINESE: "请输入名称（中文）",
    PLEASE_ENTER_DESCRIPTION_ENGLISH: "请输入描述（英文）",
    PLEASE_ENTER_DESCRIPTION_CHINESE: "请输入描述（中文）",
    PRODUCT_INFO: "服务产品信息",
    SELECT_SERVICE_TYPE: "选择服务类型",
    PRODUCT_NAME: "服务产品名称",
    THIS_ITEM: "此项",
    ASSIGN_PRACTITIONERS: "医师分配情况",
    BED_NUM_IF_APPLIED: "推拿 / 针灸床位数（如适用）",
    BED_NUM_IF_APPLIED_DESCRIPTION:
      "仅在为诊所成员分配可预约产品，且诊所需要根据床位或房间数量限制同时接待人数时使用。若诊所成员仅提供中医服务，通常无需特别设置，默认填写 1 即可。此项最小值为 1。",
    WORK_CAPACITY: "推拿/针灸最大同时接待人数",
    WORK_CAPACITY_DES:
      "用于设置该成员可同时接待的客户数量上限。最少为 1 人，且不能超过诊所床位数。",
    CLINIC_FORM_STEP_BASIC_SUB: "诊所的名称，以及患者可以如何联系您。",
    CLINIC_FORM_STEP_ADDRESS_SUB: "您的诊所在哪里？",
    CLINIC_FORM_STEP_CAPACITY_TITLE: "容量与营业时间",
    CLINIC_FORM_STEP_CAPACITY_SUB: "设置诊所可接待的人数，以及诊所的营业时间。",
    CLINIC_FORM_STEP_FEES_SUB: "可选 — 为您提供的服务设置价格，之后也可以补充。",
    HEAD_FACE: "头/面部",
    SHOULDER_NECK_BACK: "肩/颈/背部",
    ABDOMEN: "腹部",
    HAND: "手部",
    LEG: "腿部",
    FOOT: "足部",
    WAIST: "腰部",
    SHOULDER_NECK: "肩/颈部",
    NECK_BACK: "颈/背部",
    ARM: "手臂",
    YOU_HAVE_EXCEEDED_THE_MAXIMUM_NUMBER_OF_RETRIES:
      "您已超过最大重试次数，请稍后再试。",
    PRESCRIPTION_NOT_READY: "处方尚未准备好，请稍后再试。",
    CASE_CREATED: "病历已创建",
    NO_AVAILABLE_TREATMENT_TYPE: "未配置其他诊疗项目，默认使用中医推拿。",
    PATIENTS_CREATED_BY: "患者创建于",
    PRESCRIPTION_PAID_AT: "病历问诊于",
    LEFT_ARM: "左臂",
    RIGHT_ARM: "右臂",
    LEFT_LEG: "左腿",
    RIGHT_LEG: "右腿",
    LEFT_HAND: "左手",
    RIGHT_HAND: "右手",
    LEFT_FOOT: "左脚",
    RIGHT_FOOT: "右脚",
    LEFT_WAIST: "左腰",
    RIGHT_WAIST: "右腰",
    SERVICE_PRODUCT_LIST: '当前服务项目下的产品列表',
    ASSIGNED_PRACTITIONERS: '已分配的医师数量',
    PRODUCT_SERVICE: '所属服务',
    ASSIGNED: '已分配',
    UNASSIGNED: '未分配',
    ASSIGN_OR_NOT: '是否分配此医师',
    PLEASE_ENTER_NAME: '请输入名称',
    PLEASE_ENTER_DESCRIPTION: '请输入描述',
    SERVICE_NAME: '服务项目名称',
    PRODUCT_INCLUDED: '产品数量',
    EDIT_PRODUCT_INFO: '编辑产品信息',
    EDIT_PRACTITIONERS_PRODUCT_SETTING: '编辑医师分配情况',
    SERVICE_PROJECT: '服务项目',
    SELECT_WORKING_SERVICES: '选择服务种类',
    SELECT_SERVICE_PROJECT: '选择服务项目',
    SERVICE_EXPLANATION: '服务项目用于定义一类服务，比如头部推拿，背部推拿等，后续创建的服务产品将基于该服务项目设置价格和时长。',
    NO_PRACTITIONERS_FOR_THIS_SERVICE: '当前没有可提供该服务类型的医师，请前往配置服务类型，或联系对应医师完成配置。',
    PATIENT_SYSTEM_AND_PRESCRIPTION_FUNCTION_FOR_TCM: '您可以管理诊所的患者信息与病历，并为患者开具中医模式下的处方',
    PRESCRIPTION_MEDICAL_HISTORY_FOR_TCM: '处方与病历指南-中医模式',
    PRESCRIPTION_MEDICAL_HISTORY_FOR_MASSAGE: '处方与病历指南-推拿模式',
    PATIENT_SYSTEM_AND_PRESCRIPTION_FUNCTION_FOR_MASSAGE: '您可以管理诊所的患者信息与病历，并为患者开具推拿模式下的处方',
    NAME_IS_REQUIRED: '请输入名称',
    INVALID_PRICE: '请输入有效的价格',
    INVALID_DURATION: '请输入有效的时长',
    NO_PRODUCTS_AVAILABLE_FOR_THIS_PRACTITIONER: '该医师没有设置可预约的服务产品',
    ADD_CUSTOMISED_SERVICE: "添加自定义服务",
    CUSTOM_SERVICE_CREATEDED: "自定义服务已创建",
    U_CAN_ADD_UR_CUSTOMISED_SERVICE_TO_WORK_WITH: "您可以创建一种自定义的服务类型，用于创建病历记录时使用。",
    INPUT_UR_SERVICE_TYPE_NAME_HERE: "请输入服务类别名称",
    PLEASE_NOTE_ONLY_YOU_WILL_BE_ABLE_USE_THIS_CUSTOMISED_SERVICE: "请注意，此自定义服务类别仅供您本人使用。",
    PLEASE_NOTE_ONLY_THIS_CLINIC_WILL_BE_ABLE_USE_THIS_CUSTOMISED_SERVICE: "请注意，此自定义服务仅可在您担任诊所负责人（Business Owner）的诊所中使用。",
    TREATMENT_INSTRUCTIONS: "治疗说明",
    DEFAULT_DOB_WARNING: "未提供出生日期，系统已使用默认日期（01/01/1990）。",
    RESIGN_CONSENT_FORM: "重新签署同意书",
    CONSENT_FORM_DOES_NOT_COVER_DATE_X: "所选问诊日期早于患者同意书的生效日期({{X}}),请为患者重新签署同意书后再修改",
    SAVE_APPOINTMENT_INFO_LOCALLY: "保存预约信息至本地",
    TRANSLATING: "翻译中",
    PROCESSING: "处理中",
    OTHER_LANG_CONTENT_GOES_HERE: "在此录入其他语言的内容",
    PLEASE_SELECT_DOWNLOAD_FORMAT: "请选择下载格式",
    PDF_FILE: "PDF 文件",
    WORD_DOC: "Word 文档",
    NEXT_MONTH: "下个月",
    PREV_MONTH: "上个月",
    ALL_TIME: "所有时间段",
    TCM_MODE_SERVICE_DESC: "选择以下服务类别后，创建病历时将使用详细诊断模式。该模式提供更完整的病历选项，并支持录入更详细的诊疗信息。",
    ACUPUNCTURE_MASSAGE_MEDICINE_MODE_SERVICE_DESC: "选择以下服务类别后，创建病历时将使用针灸/推拿快捷模式。该模式主要适用于推拿按摩类服务，相比详细诊断模式简化了开方流程，让诊疗录入更加快捷。",
    MASSAGE_QUICK_MODE: "针灸/推拿快捷模式",
    TRY_NEW_UI: "试用新版病历单",
    TRY_NEW_UI_INTRO: "新版病历单目前只是针对针灸/推拿类型的病历做了界面改进。它会自动提醒您哪些必填内容还没填，填写的内容和以前完全一样，只是样子变了。这是测试功能，使用中遇到问题欢迎反馈，不喜欢也可以随时关闭试用。",
    TRY_NEW_UI_STEP_BY_STEP: "使用引导式开方（分步填写）",
    GUIDED_UI_TOGGLE_OLD: "旧界面",
    GUIDED_UI_TOGGLE_NEW: "新界面",
    I_AGREE_AND_SIGN: "我同意并签署",
    PATIENT_SIGN_IN_PERSON: "患者现场签字",
    AND_X_MORE: "和其他{{X}}条记录",
    CLICK_TO_ADD_CONTENT: "点击添加内容",
    NO_CONTENT_FILLED: "未填写内容",
    CONTENT_FILLED: "已填写内容",
    TREATMENT_OUTCOME: "治疗结果",
    TREATMENT_RECOMMENDATION: "治疗建议",
    SHOW_ALL_SERVICES: "显示全部服务",
    SHOW_SERVICE_HAS_PRODUCT: "显示有产品的服务",
    UP_TO_X_USERS_INCLUDED: "最多可包含{{X}}位用户",
    PHONE_CONSULTATION: "电话咨询",
    PLEASE_CONTACT_US_FOR_THIS_PACKAGE: "请联系我们，为您的诊所量身定制专属套餐",
    LEFT_CALF: "左小腿",
    RIGHT_CALF: "右小腿",
    SHOWING: "正在显示",
    SWIPE_OR_USE_ARROWS_TO_VIEW_MORE_PACKAGES: "左右滑动或使用箭头查看更多套餐",
    DOWNLOAD_SICK_CERTIFICATE: "下载病假条",
    ISSUE_SICK_CERTIFICATE: "开病假条",
    DAY_VIEW: "日视图",
    PREV_DAY: "前一天",
    NEXT_DAY: "后一天",
    SCROLL_TO_NEXT_BOOKING: "滚动到下一个预约",
    X_BOOKINGS: "总计 {{X}} 个预约",
    CREATE_APPOINTMENT_FOR_THIS_DAY: "为当天创建预约",
    PLEASE_SELECT_SERVICE_TYPE_FROM_LEFT_FIRST: "请先从左侧选择服务类型。",
    UNSELECT_THIS_BODY_PART: "取消勾选此部位",
    UNSAVED_CHANGES: "未保存的更改",
    UNSAVED_BODY_PART_METHOD_CHANGES_DESC: "你已修改选择的部位或手法。如果现在关闭，这些更改将不会被保存。",
    CONTINUE_EDITING: "继续编辑",
    DISCARD_AND_CLOSE: "放弃并关闭",

    EDIT_CUSTOMISED_SERVICE: "编辑自定义服务",
    PRIMARY_LANGUAGE: "主要语言",
    OTHER_LANGUAGES: "其他语言",
    REQUIRED: "必填",
    OPTIONAL: "选填",
    TRANSLATE: "翻译",
    TRANSLATE_TO_OTHER_LANGUAGES: "翻译为其他语言",
    PLEASE_ENTER_ENGLISH_NAME_FIRST: "请先输入英文名称。",
    ENGLISH_NAME_IS_REQUIRED_AND_USED_AS_DEFAULT: "英文名称为必填项，并将作为默认显示名称。",
    OTHER_LANGUAGE_FIELDS_ARE_OPTIONAL: "其他语言为选填，可手动编辑或自动翻译生成。",
    NAME_MODALITY_IN_ENGLISH: "服务英文名称",
    NAME_MODALITY_IN_CHINESE: "服务中文名称",
    NAME_MODALITY_IN_THAI: "服务泰文名称",
    NAME_MODALITY_IN_VIETNAMESE: "服务越南文名称",
    MODALITY_UPDATED: "服务更新成功",
    CLICK_TO_EDIT: "点击编辑",
    PRODUCT_DURATION_CANNOT_EXCEED_5_HOURS: "产品时长不能超过5小时。",
    UNSAVED_CHANGES_WARNING: "任何未保存的更改都将丢失。确定要继续吗？",

    // ---- Xero 集成 ----
    XERO_SETTINGS: "Xero 设置",
    XERO_SETTINGS_HINT: "连接诊所的 Xero Organisation，将已付款的就诊记录推送为发票，供会计人员审核。",
    XERO_CONNECT: "连接 Xero",
    XERO_RETRY_CONNECT: "重试",
    XERO_NOT_CONNECTED_TITLE: "尚未连接 Xero",
    XERO_NOT_CONNECTED_DESCRIPTION: "连接本诊所的 Xero Organisation 后即可开始推送已付款的就诊记录为发票。",
    XERO_CONNECT_SUCCESS: "已连接 Xero",
    XERO_CONNECT_SUCCESS_WITH_ORG: "已连接到 Xero Organisation「{{org}}」",
    XERO_CONNECT_FAILED_ACCESS_DENIED: "你在 Xero 页面取消了授权。",
    XERO_CONNECT_FAILED_EXCHANGE: "授权失败，请重新连接。",
    XERO_ORGANISATION: "Xero Organisation",
    XERO_CONNECTED_SINCE: "连接于",
    XERO_DISCONNECT: "断开连接",
    XERO_DISCONNECT_SUCCESS: "已断开 Xero 连接",
    XERO_DISCONNECT_CONFIRM_1: "断开连接后将无法再推送发票到 Xero。",
    XERO_DISCONNECT_CONFIRM_2: "Xero 中已存在的发票不受影响。",
    XERO_DISCONNECT_CONFIRM_3: "你可以随时重新连接。",
    XERO_ACCOUNT_MAPPING: "收入科目映射",
    XERO_ACCOUNT_MAPPING_HINT: "选择治疗费用和其他费用分别记入哪个 Xero 科目。",
    XERO_ACCOUNT_CODES_INCOMPLETE_WARNING: "科目映射尚未配置完成——在两个科目都选择之前，无法推送发票到 Xero。",
    XERO_TREATMENT_ACCOUNT_CODE: "治疗收入科目",
    XERO_OTHER_FEE_ACCOUNT_CODE: "其他费用科目",
    XERO_NO_ACCOUNTS_AVAILABLE: "该 Xero Organisation 中没有可用的收入科目，请先在 Xero 中设置。",
    XERO_ACCOUNT_CODES_REQUIRED: "请先选择两个科目再保存。",
    XERO_ACCOUNT_CODES_SAVED: "科目映射已保存",
    XERO_AUTOMATION_SETTINGS: "自动化设置",
    XERO_AUTOMATION_SETTINGS_HINT: "可选。默认发票以草稿状态进入 Xero，由诊所会计人工审核批准。",
    XERO_AUTO_SYNC_TOGGLE: "自动批准并收款",
    XERO_AUTO_SYNC_TOGGLE_HINT: "开启后，推送到 Xero 的已付款就诊会自动被批准并核销收款，无需在 Xero 中手动操作。",
    XERO_AUTO_SYNC_OFF_LABEL: "关闭",
    XERO_AUTO_SYNC_OFF_DESCRIPTION: "发票在 Xero 中保持草稿状态，等待会计人工审核批准。",
    XERO_AUTO_SYNC_ON_LABEL: "开启",
    XERO_AUTO_SYNC_ON_DESCRIPTION: "发票会在 Xero 中自动被批准并标记为已收款，无需经过草稿阶段。",
    XERO_PAYMENT_ACCOUNT_CODE: "收款银行账户",
    XERO_NO_BANK_ACCOUNTS_HINT: "该 Xero Organisation 中还没有任何银行账户。请先在 Xero 中通过「Add Bank Account」创建后，再开启自动收款。",
    XERO_BANK_ACCOUNT_NOT_PAYABLE: "不支持收款",
    XERO_AUTO_SYNC_PAYMENT_ACCOUNT_REQUIRED: "开启自动收款前请先选择一个银行账户。",
    XERO_AUTO_SYNC_SAVED: "自动化设置已保存",
    XERO_INVOICE_SEARCH: "Xero 发票查询",
    XERO_PUSH_INVOICE: "推送到 Xero",
    XERO_PUSH_NOW: "立即推送",
    XERO_NEVER_PUSHED_HINT: "该就诊记录从未推送到 Xero，立即推送以创建发票。",
    XERO_PUSH_SUCCESS: "已推送到 Xero",
    XERO_PUSH_ALREADY_SYNCED: "该就诊记录已推送过 Xero，以下为已有的发票信息。",
    XERO_PUSH_DISABLED_NOT_PAID: "只有已付款的就诊记录才能推送到 Xero。",
    XERO_PUSH_DISABLED_NOT_CONNECTED: "本诊所尚未连接 Xero。",
    XERO_INVOICE_NUMBER: "发票号",
    XERO_INVOICE_STATUS: "Xero 发票状态",
    XERO_INVOICE_STATUS_DRAFT: "草稿",
    XERO_INVOICE_STATUS_SUBMITTED: "已提交",
    XERO_INVOICE_STATUS_DELETED: "已删除",
    XERO_INVOICE_STATUS_AUTHORISED: "已批准",
    XERO_INVOICE_STATUS_PAID: "已收款",
    XERO_INVOICE_STATUS_VOIDED: "已作废",
    XERO_SYNCED_AT: "推送时间",
    XERO_SYNC_STATUS_SYNCED: "推送成功",
    XERO_SYNC_STATUS_PENDING: "处理中",
    XERO_SYNC_STATUS_FAILED: "推送失败",
    XERO_SYNC_STATUS_NEVER_PUSHED: "从未推送",
    XERO_ERROR_CLINIC_NOT_SELECTED: "请先选择诊所。",
    XERO_ERROR_INVALID_TOKEN: "登录状态已失效，请重新登录。",
    XERO_UNKNOWN_ERROR: "出现了一些问题，请重试。",
    XERO_SELECT_ORGANISATION: "选择 Xero Organisation",
    XERO_SELECT_ORGANISATION_HINT: "此次 Xero 授权覆盖了多个 Organisation，请选择本诊所要推送发票到哪一个。",
    XERO_SWITCH_ORGANISATION: "切换 Organisation",
    XERO_CURRENT_ORGANISATION: "当前",
    XERO_SWITCH_ORGANISATION_TO: "切换至",
    XERO_ORG_SWITCH_SUCCESS: "已切换到 Xero Organisation「{{org}}」",
    XERO_SWITCH_ORGANISATION_CONFIRM_INTRO: "切换到「{{org}}」？以下配置因为是针对当前 Organisation 的，将被清空：",
    XERO_SWITCH_ORGANISATION_WIPE_ACCOUNTS: "治疗收入科目、其他费用科目映射",
    XERO_SWITCH_ORGANISATION_WIPE_AUTOMATION: "银行账户与自动化设置（将被关闭）",
    XERO_SWITCH_ORGANISATION_CONFIRM_OUTRO: "切换后需要为新 Organisation 重新完成科目映射，才能继续推送发票。",
  },
};
